/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Hanly API
 * Hanly API description
 * OpenAPI spec version: 0.0.1
 */
/**
 * 勘定科目マスタのシリアライザー
 */
export interface AccountTitleMaster {
  readonly id: number;
  /** @maxLength 255 */
  name: string;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedAccountTitleMasterList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: AccountTitleMaster[];
}

/**
 * 勘定科目マスタのシリアライザー
 */
export interface AccountTitleMasterRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
}

export interface StandardizedErrorDetail {
  /** @nullable */
  attr: string | null;
  code: string;
  detail: string;
  detail_args?: string[];
}

/**
 * drf-standardized-errorsに合わせた共通エラー用のシリアライザ
 */
export interface StandardizedError {
  type: string;
  errors: StandardizedErrorDetail[];
}

/**
 * 買掛金サマリ用シリアライザー
 */
export interface AccountsPayableSummary {
  readonly pay_to_id: number;
  readonly pay_to_code: string;
  readonly pay_to_name: string;
  /** 締めグループ名 */
  readonly closing_group_name: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly previous_balance: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly current_payment: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly current_payment_balance: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly current_purchase_total: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly current_purchase_subtotal: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly current_tax_10: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly current_tax_8: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly ending_balance: string;
}

export interface PaginatedAccountsPayableSummaryList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: AccountsPayableSummary[];
}

/**
 * 買掛一覧 SSRM のグループ行シリアライザー
 *
 * 金額はグループ配下の支払先の単純合計。残高系も支払先ごとの値の線形和なので合計で整合する。
 */
export interface AccountsPayableSsrmGroup {
  /** グループキー(分類名・支払先名など) */
  group_key: string;
  /** グループ内の支払先数 */
  count: number;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  previous_balance: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  current_payment: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  current_payment_balance: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  current_purchase_total: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  current_purchase_subtotal: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  current_tax_10: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  current_tax_8: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  ending_balance: string;
}

/**
 * 買掛一覧 SSRM のグループ化レスポンス(is_grouped=true)
 */
export interface AccountsPayableSsrmGroupedResponse {
  /** グループ化されたデータ */
  results: AccountsPayableSsrmGroup[];
  /** グループ数 */
  count: number;
  /** グループ化されたレスポンスかどうか(常にtrue) */
  is_grouped?: boolean;
}

/**
 * 買掛一覧 SSRM のリーフ行(支払先1件)シリアライザー
 *
 * `AccountsPayableSummaryQueryService.build_summary_queryset` の annotate 済み Partner を受ける。
 * 金額の項目名は既存の `AccountsPayableSummarySerializer` と揃えており、将来「すべて」タブを
 * AG Grid 化して同じエンドポイントへ寄せる際にフロントの項目対応を変えずに済むようにしている。
 */
export interface AccountsPayableSsrmLeaf {
  readonly pay_to_id: number;
  readonly pay_to_code: string;
  readonly pay_to_name: string;
  /**
   * 分類1
   * @nullable
   */
  readonly category_type_1: string | null;
  /**
   * 分類2
   * @nullable
   */
  readonly category_type_2: string | null;
  /**
   * 分類3
   * @nullable
   */
  readonly category_type_3: string | null;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  readonly previous_balance: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  readonly current_payment: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  readonly current_payment_balance: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  readonly current_purchase_total: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  readonly current_purchase_subtotal: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  readonly current_tax_10: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  readonly current_tax_8: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  readonly ending_balance: string;
}

/**
 * 買掛一覧 SSRM のリーフレスポンス(is_grouped=false)
 */
export interface AccountsPayableSsrmLeafResponse {
  /** 支払先別の買掛サマリ */
  results: AccountsPayableSsrmLeaf[];
  /** 総件数 */
  count: number;
  /**
   * 次ページのURL
   * @nullable
   */
  next?: string | null;
  /**
   * 前ページのURL
   * @nullable
   */
  previous?: string | null;
  /** グループ化されたレスポンスかどうか(常にfalse) */
  is_grouped: false;
}

export type AccountsPayableSsrmResponse =
  | AccountsPayableSsrmGroupedResponse
  | AccountsPayableSsrmLeafResponse;

/**
 * * `purchase` - purchase
 * * `payment` - payment
 * * `carried_forward` - carried_forward
 */
export type AccountsPayableItemIssueTypeEnum =
  (typeof AccountsPayableItemIssueTypeEnum)[keyof typeof AccountsPayableItemIssueTypeEnum];

export const AccountsPayableItemIssueTypeEnum = {
  purchase: 'purchase',
  payment: 'payment',
  carried_forward: 'carried_forward',
} as const;

/**
 * 買掛明細（仕入の商品明細）用シリアライザー
 */
export interface AccountsPayableItemDetail {
  /** 商品名 */
  readonly name: string;
  /**
   * 数量
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly quantity: string | null;
  /**
   * 単価
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly unit_price: string | null;
  /**
   * 金額（税抜）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly amount: string;
}

/**
 * 仕入の税率別消費税内訳用シリアライザー
 */
export interface AccountsPayableTaxDetail {
  /** 税率（パーセント） */
  readonly tax_rate: number;
  /**
   * 当該税率の消費税額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly amount: string;
}

/**
 * * `cash` - 現金
 * * `transfer` - 振込
 * * `fee` - 手数料
 * * `check` - 小切手
 * * `bill` - 手形
 * * `offset` - 相殺
 * * `electronic` - 電債
 * * `other` - その他
 */
export type PaymentTypeEnum = (typeof PaymentTypeEnum)[keyof typeof PaymentTypeEnum];

export const PaymentTypeEnum = {
  cash: 'cash',
  transfer: 'transfer',
  fee: 'fee',
  check: 'check',
  bill: 'bill',
  offset: 'offset',
  electronic: 'electronic',
  other: 'other',
} as const;

/**
 * 買掛明細（出金の明細）用シリアライザー
 */
export interface AccountsPayablePaymentItemDetail {
  /**
   * 出金区分
   *
   * * `cash` - 現金
   * * `transfer` - 振込
   * * `fee` - 手数料
   * * `check` - 小切手
   * * `bill` - 手形
   * * `offset` - 相殺
   * * `electronic` - 電債
   * * `other` - その他
   */
  readonly payment_type: PaymentTypeEnum;
  /**
   * 金額（符号付き）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly amount: string;
  /**
   * 勘定科目名
   * @nullable
   */
  readonly account_title_name: string | null;
  /**
   * 手形期日
   * @nullable
   */
  readonly bill_due_date: string | null;
  /**
   * 手形No
   * @nullable
   */
  readonly bill_no: string | null;
  /**
   * 行摘要
   * @nullable
   */
  readonly summary: string | null;
}

/**
 * 買掛明細トランザクション用シリアライザー
 */
export interface AccountsPayableItem {
  readonly issue_date: string;
  readonly issue_type: AccountsPayableItemIssueTypeEnum;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly purchase_amount: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly payment_amount: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly balance: string;
  /** @nullable */
  readonly source_id: number | null;
  /**
   * 仕入の商品明細（仕入のみ）
   * @nullable
   */
  readonly details: readonly AccountsPayableItemDetail[] | null;
  /**
   * 消費税合計（仕入のみ、合計欄）
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly tax_amount: string | null;
  /**
   * 税率別の消費税内訳（仕入のみ）
   * @nullable
   */
  readonly tax_details: readonly AccountsPayableTaxDetail[] | null;
  /**
   * 決済方法名（出金のみ）
   * @nullable
   */
  readonly payment_method_name: string | null;
  /**
   * 出金の明細（出金のみ）
   * @nullable
   */
  readonly payment_details: readonly AccountsPayablePaymentItemDetail[] | null;
}

/**
 * 買掛詳細用シリアライザー
 */
export interface AccountsPayableDetail {
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly previous_balance: string;
  readonly items: readonly AccountsPayableItem[];
}

/**
 * * `csv` - csv
 * * `excel` - excel
 */
export type FormatTypeEnum = (typeof FormatTypeEnum)[keyof typeof FormatTypeEnum];

export const FormatTypeEnum = {
  csv: 'csv',
  excel: 'excel',
} as const;

/**
 * 買掛一覧エクスポート用シリアライザー
 *
 * エクスポート対象の決定は次の優先順位:
 *   1. pay_to_ids 指定あり -> その支払先のみ（選択エクスポート。列フィルタは無視）
 *   2. フィルタ項目あり     -> 一覧と同じ絞り込みにマッチした全件
 *   3. いずれも無し         -> 期間・部署で集計した全件
 * from_date / to_date / department_ids は上記いずれでも常に適用される。
 * フィルタ項目は AccountsPayableListFilterFieldsMixin で買掛一覧と共有しており、同名・同型・同許容度。
 */
export interface AccountsPayableExportRequest {
  /** 支払先コード（部分一致） */
  pay_to_code?: string;
  /** 支払先名（部分一致） */
  pay_to_name?: string;
  /**
   * 締めグループID（0は未設定）
   * @minimum 0
   */
  closing_group_id?: number;
  /** 前月末残高の下限 */
  previous_balance_min?: string;
  /** 前月末残高の上限 */
  previous_balance_max?: string;
  /** 当月支払額の下限 */
  current_payment_min?: string;
  /** 当月支払額の上限 */
  current_payment_max?: string;
  /** 当月支払残の下限 */
  current_payment_balance_min?: string;
  /** 当月支払残の上限 */
  current_payment_balance_max?: string;
  /** 当月仕入(税込)の下限 */
  current_purchase_total_min?: string;
  /** 当月仕入(税込)の上限 */
  current_purchase_total_max?: string;
  /** 当月仕入(税抜)の下限 */
  current_purchase_subtotal_min?: string;
  /** 当月仕入(税抜)の上限 */
  current_purchase_subtotal_max?: string;
  /** 当月末残高の下限 */
  ending_balance_min?: string;
  /** 当月末残高の上限 */
  ending_balance_max?: string;
  /**
   * エクスポート形式（csv/excel）
   *
   * * `csv` - csv
   * * `excel` - excel
   */
  format_type: FormatTypeEnum;
  /** 支払先IDリスト（指定しない場合は全件） */
  pay_to_ids?: number[];
  /** 期間開始日 */
  from_date: string;
  /** 期間終了日 */
  to_date: string;
  /** 部門IDリスト */
  department_ids?: number[];
}

/**
 * 決済方法別回収額のシリアライザー
 */
export interface PaymentAmount {
  /** 決済方法ID */
  readonly payment_method_id: number;
  /**
   * 回収額
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly amount: string;
}

/**
 * 売掛一覧レスポンス用シリアライザー
 */
export interface AccountsReceivable {
  /** 得意先ID */
  readonly partner_id: number;
  /** 得意先コード */
  readonly partner_code: string;
  /** 得意先名 */
  readonly partner_name: string;
  /** 締めグループ名 */
  readonly closing_group_name: string;
  /**
   * 前月末残高
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly previous_balance: string;
  /**
   * 当月回収
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly current_collection: string;
  /**
   * 当月回収残
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly current_collection_balance: string;
  /**
   * 当月売上(税込)
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly current_sales_with_tax: string;
  /**
   * 当月売上(税抜)
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly current_sales_without_tax: string;
  /**
   * 消費税(10%)
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly tax_10_amount: string;
  /**
   * 消費税(8%)
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly tax_8_amount: string;
  /**
   * 当月末残高
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly end_balance: string;
  /** 決済方法別回収額 */
  readonly payment_amounts: readonly PaymentAmount[];
}

export interface PaginatedAccountsReceivableList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: AccountsReceivable[];
}

/**
 * * `invoice` - invoice
 * * `payment` - payment
 * * `carried_forward` - carried_forward
 */
export type AccountsReceivableItemIssueTypeEnum =
  (typeof AccountsReceivableItemIssueTypeEnum)[keyof typeof AccountsReceivableItemIssueTypeEnum];

export const AccountsReceivableItemIssueTypeEnum = {
  invoice: 'invoice',
  payment: 'payment',
  carried_forward: 'carried_forward',
} as const;

/**
 * 売掛明細（請求の商品明細）用シリアライザー
 */
export interface AccountsReceivableItemDetail {
  /** 商品名 */
  readonly name: string;
  /**
   * 数量
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly quantity: string | null;
  /**
   * 単価
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly unit_price: string | null;
  /**
   * 金額（税抜）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly amount: string;
}

/**
 * 請求の税率別消費税内訳用シリアライザー
 */
export interface AccountsReceivableTaxDetail {
  /** 税率（パーセント） */
  readonly tax_rate: number;
  /**
   * 当該税率の消費税額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly amount: string;
}

/**
 * 売掛明細（入金の明細）用シリアライザー
 */
export interface AccountsReceivablePaymentItemDetail {
  /**
   * 入金区分
   *
   * * `cash` - 現金
   * * `transfer` - 振込
   * * `fee` - 手数料
   * * `check` - 小切手
   * * `bill` - 手形
   * * `offset` - 相殺
   * * `electronic` - 電債
   * * `other` - その他
   */
  readonly payment_type: PaymentTypeEnum;
  /**
   * 金額（符号付き）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly amount: string;
  /**
   * 勘定科目名
   * @nullable
   */
  readonly account_title_name: string | null;
  /**
   * 手形期日
   * @nullable
   */
  readonly bill_due_date: string | null;
  /**
   * 手形No
   * @nullable
   */
  readonly bill_no: string | null;
  /**
   * 行摘要
   * @nullable
   */
  readonly summary: string | null;
}

/**
 * 売掛明細トランザクション用シリアライザー
 */
export interface AccountsReceivableItem {
  readonly issue_date: string;
  readonly issue_type: AccountsReceivableItemIssueTypeEnum;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly invoice_amount: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly payment_amount: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly balance: string;
  /** @nullable */
  readonly source_id: number | null;
  /**
   * 紐づく入金ID（入金のみ）
   * @nullable
   */
  readonly payment_id: number | null;
  /**
   * 請求の商品明細（請求のみ）
   * @nullable
   */
  readonly details: readonly AccountsReceivableItemDetail[] | null;
  /**
   * 消費税合計（請求のみ、合計欄）
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly tax_amount: string | null;
  /**
   * 税率別の消費税内訳（請求のみ）
   * @nullable
   */
  readonly tax_details: readonly AccountsReceivableTaxDetail[] | null;
  /**
   * 決済方法名（入金のみ）
   * @nullable
   */
  readonly payment_method_name: string | null;
  /**
   * 入金の明細（入金のみ）
   * @nullable
   */
  readonly payment_details: readonly AccountsReceivablePaymentItemDetail[] | null;
}

/**
 * 売掛詳細用シリアライザー
 */
export interface AccountsReceivableDetail {
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly previous_balance: string;
  readonly items: readonly AccountsReceivableItem[];
}

/**
 * 売掛一覧エクスポート用シリアライザー
 *
 * エクスポート対象の決定は次の優先順位:
 *   1. partner_ids 指定あり -> その得意先のみ（選択エクスポート。列フィルタは無視）
 *   2. フィルタ項目あり     -> 一覧と同じ絞り込みにマッチした全件
 *   3. いずれも無し         -> 期間・部署で集計した全件
 * from_date / to_date / department_ids は上記いずれでも常に適用される。
 * フィルタ項目（得意先コード/名・金額レンジ）は売掛一覧と同名・同型で、一覧と同じ許容度でパースされる。
 */
export interface AccountsReceivableExportRequest {
  /** 得意先コード（部分一致） */
  partner_code?: string;
  /** 得意先名（部分一致） */
  partner_name?: string;
  /**
   * 締めグループID（0は未設定）
   * @minimum 0
   */
  closing_group_id?: number;
  /**
   * 前月末残高の下限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  previous_balance_min?: string;
  /**
   * 前月末残高の上限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  previous_balance_max?: string;
  /**
   * 当月回収の下限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  current_collection_min?: string;
  /**
   * 当月回収の上限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  current_collection_max?: string;
  /**
   * 当月回収残の下限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  current_collection_balance_min?: string;
  /**
   * 当月回収残の上限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  current_collection_balance_max?: string;
  /**
   * 当月売上(税込)の下限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  current_sales_with_tax_min?: string;
  /**
   * 当月売上(税込)の上限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  current_sales_with_tax_max?: string;
  /**
   * 当月売上(税抜)の下限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  current_sales_without_tax_min?: string;
  /**
   * 当月売上(税抜)の上限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  current_sales_without_tax_max?: string;
  /**
   * 当月末残高の下限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  end_balance_min?: string;
  /**
   * 当月末残高の上限
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  end_balance_max?: string;
  /**
   * エクスポート形式（csv/excel）
   *
   * * `csv` - csv
   * * `excel` - excel
   */
  format_type: FormatTypeEnum;
  /** 得意先IDリスト（指定しない場合は全件） */
  partner_ids?: number[];
  /** 期間開始日 */
  from_date: string;
  /** 期間終了日 */
  to_date: string;
  /** 部門IDリスト */
  department_ids?: number[];
}

/**
 * EDIアカウント用の取引先サマリシリアライザ
 */
export interface EdiPartner {
  readonly id: number;
  /** @maxLength 250 */
  partner_name: string;
  readonly supplier_name: string;
}

/**
 * EDIアカウント読み取り用シリアライザ
 */
export interface EdiAccount {
  readonly id: number;
  readonly partners: readonly EdiPartner[];
  readonly contact_person_id: number;
  readonly contact_person_name: string;
  readonly email: string;
  readonly is_active: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * * `PROCESSING` - 招待中
 * * `ACCEPTED` - 承認済み
 * * `EXPIRED` - 期限切れ
 * * `CANCELLED` - キャンセル済み
 */
export type EdiInvitationSummaryStatusEnum =
  (typeof EdiInvitationSummaryStatusEnum)[keyof typeof EdiInvitationSummaryStatusEnum];

export const EdiInvitationSummaryStatusEnum = {
  PROCESSING: 'PROCESSING',
  ACCEPTED: 'ACCEPTED',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED',
} as const;

/**
 * EDI招待サマリシリアライザ
 */
export interface EdiInvitationSummary {
  readonly id: number;
  readonly status: EdiInvitationSummaryStatusEnum;
  /** 招待リンクの有効期限（1日間） */
  readonly expires_at: string;
  readonly created_at: string;
}

/**
 * 担当者のEDI状態レスポンスシリアライザ
 */
export interface EdiStatusByContactPerson {
  edi_account: EdiAccount | null;
  pending_invitation: EdiInvitationSummary | null;
}

/**
 * EDIアカウント招待作成用シリアライザー
 */
export interface EdiInvitationCreateRequest {
  contact_person_id: number;
}

/**
 * * `ADMIN` - 管理者
 * * `MEMBER` - メンバー
 */
export type UserRoleEnum = (typeof UserRoleEnum)[keyof typeof UserRoleEnum];

export const UserRoleEnum = {
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
} as const;

/**
 * メンバー招待用のシリアライザー
 */
export interface MemberInvitationRequest {
  /**
   * @minLength 1
   * @maxLength 150
   */
  invited_email: string;
  invited_role?: UserRoleEnum;
  organization_id: number;
}

/**
 * メンバー招待承認用のシリアライザー
 */
export interface MemberInvitationAcceptRequest {
  invitation_key: string;
  /** @minLength 1 */
  username: string;
  /** @minLength 9 */
  password: string;
}

export interface MemberInvitationValidate {
  /** @maxLength 250 */
  organization_name: string;
  email: string;
}

/**
 * 第二要素を置き換え・解除する操作(MFA の無効化・バックアップコード再発行)の入力
 *
 * MFA 有効化前に発行された(パスワードだけで取得した)アクセストークンは有効化後も使えるため、
 * パスワードに加えて現在の第二要素(認証アプリのコードまたはバックアップコード)でも再認証する。
 */
export interface MfaReauthRequest {
  /** @minLength 1 */
  current_password: string;
  /**
   * 認証アプリのコードまたはバックアップコード
   * @minLength 1
   * @maxLength 32
   */
  mfa_code: string;
}

/**
 * 発行したバックアップコード(この応答でしか参照できない)
 */
export interface MfaBackupCodes {
  backup_codes: string[];
}

/**
 * MFA 有効化(認証アプリのコード検証)
 */
export interface MfaConfirmRequest {
  /**
   * @minLength 1
   * @maxLength 32
   */
  mfa_code: string;
}

/**
 * 本人確認としてパスワードを要求する操作(MFA の無効化など)の入力
 */
export interface CurrentPasswordRequest {
  /** @minLength 1 */
  current_password: string;
}

/**
 * MFA 設定開始のレスポンス(認証アプリへの登録情報)
 */
export interface MfaSetupResponse {
  /** 手入力用のシークレット(base32) */
  secret: string;
  /** QRコードにする otpauth:// URI */
  otpauth_uri: string;
}

/**
 * ログイン中ユーザーの MFA 設定状態
 */
export interface MfaStatus {
  is_enabled: boolean;
  /** @nullable */
  confirmed_at: string | null;
  /** 未使用のバックアップコード数 */
  backup_codes_remaining: number;
}

/**
 * パスワード変更用のシリアライザー
 */
export interface PasswordChangeRequest {
  /** @minLength 1 */
  current_password: string;
  /** @minLength 9 */
  new_password: string;
}

export interface PasswordResetRequest {
  /** @minLength 1 */
  email: string;
}

export interface PasswordResetCompleteRequest {
  key: string;
  /** @minLength 9 */
  new_password: string;
}

export interface UserRegistrationOrganizationRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
  corporate_number?: string | null;
  /**
   * @minLength 1
   * @maxLength 50
   */
  company_id: string;
  website_url?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  employee_size?: string | null;
  /**
   * @maxLength 500
   * @nullable
   */
  product_categories?: string | null;
  /**
   * @maxLength 8
   * @nullable
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * 1-12の整数
   * @minimum 1
   * @maximum 12
   */
  fiscal_month?: number;
}

export interface UserRegistrationRequest {
  /** @minLength 1 */
  username: string;
  /**
   * @minLength 1
   * @maxLength 150
   */
  email: string;
  /** @minLength 9 */
  password: string;
  organization: UserRegistrationOrganizationRequest;
}

export interface UserRegistrationOrganization {
  /** @maxLength 250 */
  name: string;
  corporate_number?: string | null;
  /** @maxLength 50 */
  company_id: string;
  website_url?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  employee_size?: string | null;
  /**
   * @maxLength 500
   * @nullable
   */
  product_categories?: string | null;
  /**
   * @maxLength 8
   * @nullable
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * 1-12の整数
   * @minimum 1
   * @maximum 12
   */
  fiscal_month?: number;
}

export interface UserRegistration {
  /** @minLength 1 */
  username: string;
  /** @maxLength 150 */
  email: string;
  organization: UserRegistrationOrganization;
}

export interface Area {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedAreaList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: Area[];
}

export interface AreaRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

/**
 * * `SIGN_IN` - ログイン
 * * `SIGN_OUT` - ログアウト
 * * `DATA_EXPORT` - データ出力
 */
export type AuditLogTypeEnum = (typeof AuditLogTypeEnum)[keyof typeof AuditLogTypeEnum];

export const AuditLogTypeEnum = {
  SIGN_IN: 'SIGN_IN',
  SIGN_OUT: 'SIGN_OUT',
  DATA_EXPORT: 'DATA_EXPORT',
} as const;

/**
 * 監査ログの実行者
 *
 * AuditLog.user は SET_NULL のため、ユーザーが削除された過去のログでは null になる。
 */
export interface AuditLogUser {
  readonly id: number;
  readonly email: string;
  readonly name: string;
}

/**
 * ログ種別ごとの付加情報
 */
export type AuditLogData =
  | { [key: string]: unknown }
  | {
      /**
       * データ出力(一括DL)の対象データ
       *
       * 一覧のCSV/Excelエクスポートを追加したらここにも値を追加すること。外部連携向けのプリセット出力
       * (三井住友 KKKPC/URKPC など) は出力元の一覧と同じ対象として扱い、ファイル名で判別する。
       */
      target:
        | 'lead'
        | 'partner'
        | 'product'
        | 'inventory'
        | 'stock_adjustment_item'
        | 'sales_order_item'
        | 'sales'
        | 'sales_item'
        | 'purchase_order'
        | 'purchase_order_item'
        | 'purchase'
        | 'purchase_item'
        | 'invoice'
        | 'accounts_receivable'
        | 'accounts_payable'
        | 'project_cost_item';
      file_name: string;
      format_type: 'csv' | 'excel';
    };

/**
 * 監査ログ一覧のレスポンス
 */
export interface AuditLog {
  readonly id: number;
  readonly log_type: AuditLogTypeEnum;
  readonly user: AuditLogUser | null;
  /** ログ種別ごとの付加情報 */
  readonly data: AuditLogData;
  readonly logged_at: string;
}

export interface PaginatedAuditLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: AuditLog[];
}

/**
 * 振込先口座のシリアライザー
 */
export interface BankAccount {
  readonly id: number;
  /** @maxLength 255 */
  name: string;
  bank_details: string;
  notes?: string;
  is_default?: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedBankAccountList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BankAccount[];
}

/**
 * 振込先口座のシリアライザー
 */
export interface BankAccountRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** @minLength 1 */
  bank_details: string;
  notes?: string;
  is_default?: boolean;
}

/**
 * CSVカラムとデータ項目のマッピング
 */
export type InvoiceBulkImportRequestMapping = { [key: string]: number };

/**
 * 請求書一括登録リクエスト
 */
export interface InvoiceBulkImportRequest {
  /**
   * R2オブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: InvoiceBulkImportRequestMapping;
  /** アップロードファイル名 */
  filename?: string;
  /** 商品マスタデータ取り込みを行わない */
  skip_product_master_import?: boolean;
}

/**
 * 一括インポートエラー詳細のシリアライザ
 */
export interface BulkImportErrorDetail {
  /** エラーが発生した行番号（CSVの行番号） */
  row_number: number;
  /** エラーが発生したフィールド名 */
  row_field_name?: string;
  /** エラーメッセージ */
  message: string;
  /**
   * エラーが発生した値
   * @nullable
   */
  value?: string | null;
}

/**
 * 請求書一括登録レスポンス
 */
export interface InvoiceBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** インポートログID */
  import_log_id?: number;
  /** インポートされた請求書件数 */
  imported_count?: number;
  /** インポートされた明細件数 */
  imported_items_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

/**
 * CSV一括取込用のアップロードURL発行リクエスト用のシリアライザ
 */
export interface BulkImportUploadUrlRequestRequest {
  /**
   * ファイルサイズ(バイト)。アップロードURLの署名に含め、この値と異なるサイズのPUTを拒否する
   * @minimum 1
   * @maximum 52428800
   */
  file_size: number;
}

/**
 * pre-signed URL取得レスポンス用のシリアライザ
 */
export interface PresignedUrlResponse {
  /** アップロード用のpre-signed URL */
  presigned_url: string;
  /** R2オブジェクトキー */
  object_key: string;
}

/**
 * * `PURCHASE_ORDER` - 発注書
 * * `SALES_ORDER` - 受注書
 * * `QUOTATION` - 見積書
 * * `INVOICE` - 請求書
 * * `DELIVERY_NOTE` - 納品書
 * * `SHIPPING_LABEL` - 送り状
 */
export type DocumentTypeEnum = (typeof DocumentTypeEnum)[keyof typeof DocumentTypeEnum];

export const DocumentTypeEnum = {
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  SALES_ORDER: 'SALES_ORDER',
  QUOTATION: 'QUOTATION',
  INVOICE: 'INVOICE',
  DELIVERY_NOTE: 'DELIVERY_NOTE',
  SHIPPING_LABEL: 'SHIPPING_LABEL',
} as const;

export interface DocumentTemplateDefaultSettingsRequest {
  template: number;
}

export interface DocumentTemplateDefaultSettings {
  readonly id: number;
  readonly organization: number;
  readonly document_type: DocumentTypeEnum;
  template: number;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * * `QUOTATION` - 見積
 * * `SALES_ORDER` - 受注
 * * `INVOICE` - 請求
 * * `PURCHASE_ORDER` - 発注
 * * `PURCHASE_INVOICE` - 仕入
 */
export type NotesTemplateDocumentTypeEnum =
  (typeof NotesTemplateDocumentTypeEnum)[keyof typeof NotesTemplateDocumentTypeEnum];

export const NotesTemplateDocumentTypeEnum = {
  QUOTATION: 'QUOTATION',
  SALES_ORDER: 'SALES_ORDER',
  INVOICE: 'INVOICE',
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  PURCHASE_INVOICE: 'PURCHASE_INVOICE',
} as const;

export interface NotesTemplateDetail {
  readonly id: number;
  readonly title: string;
  readonly content: string;
  readonly document_types: readonly NotesTemplateDocumentTypeEnum[];
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedNotesTemplateDetailList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: NotesTemplateDetail[];
}

export interface NotesTemplateCreateUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  title: string;
  /** @minLength 1 */
  content: string;
  document_types: NotesTemplateDocumentTypeEnum[];
}

/**
 * * `purchase-order-common-1` - 発注書 標準1
 * * `purchase-order-common-2` - 発注書 料金表示無し
 * * `purchase-order-common-3` - 発注書 ケース対応
 * * `purchase-order-common-4` - 発注書 ケース対応 料金表示無し
 * * `purchase-order-bowcs-1` - 発注書 ボウクス標準
 * * `purchase-order-bowcs-2` - 発注書 ボウクス得意先なし
 * * `sales-order-common-1` - 受注書 標準1
 * * `sales-order-common-2` - 受注書 ケース対応
 * * `sales-order-kobayashikazuo-1` - 受注書 小林多男商店
 * * `sales-order-bowcs-1` - 受注書 ボウクス標準
 * * `sales-order-bowcs-2` - 受注書 ボウクス売上伝票
 * * `sales-order-bowcs-3` - 受注書 ボウクス金額なし
 * * `quotation-common-1` - 見積書 標準1
 * * `quotation-common-2` - 見積書 ケース対応
 * * `quotation-common-3` - 見積書 A4横
 * * `quotation-common-4` - 見積書 A4横 ケース対応
 * * `quotation-custom-properties-1` - 見積書 カスタム項目あり
 * * `quotation-custom-properties-no-total-1` - 見積書 合計なし カスタム項目あり
 * * `quotation-invoice-custom-properties-1` - 請求書 カスタム項目あり
 * * `quotation-bowcs-1` - 見積書 ボウクス標準
 * * `invoice-common-1` - 請求書 標準1
 * * `invoice-common-2` - 請求書 繰越あり
 * * `invoice-yaoki-1` - 請求書 八起1
 * * `invoice-bowcs-1` - 請求書 ボウクス標準
 * * `invoice-bowcs-receipt-1` - 領収書 ボウクス
 * * `invoice-bowcs-statement-1` - お買い上げ明細 ボウクス
 * * `invoice-bowcs-construction-1` - 請求書 ボウクス工事
 * * `delivery-note-common-1` - 納品書 標準1
 * * `delivery-note-common-2` - 納品書 受領書あり
 * * `delivery-note-common-3` - 納品書 受領書あり 料金なし
 * * `delivery-note-common-4` - 納品書 受領書あり 消費税なし
 * * `delivery-note-yaoki-1` - 納品書 八起1
 * * `delivery-note-yaoki-2` - 納品書兼請求書 八起1
 * * `delivery-note-sobajima-1` - 納品書 側島製罐1
 * * `delivery-note-sobajima-2` - 納品書 側島製罐2
 * * `delivery-note-sobajima-3` - 納品書 側島製罐3
 * * `delivery-note-bowcs-1` - 納品書 ボウクス標準
 * * `shipping-label-kuronekoyamato-1` - 送り状 ヤマト運輸
 * * `shipping-label-sagawa-1` - 送り状 佐川急便
 * * `shipping-label-fukutsu-1` - 送り状 福山通運
 * * `shipping-label-tonami-1` - 送り状 トナミ運輸
 */
export type DocumentKeyEnum = (typeof DocumentKeyEnum)[keyof typeof DocumentKeyEnum];

export const DocumentKeyEnum = {
  'purchase-order-common-1': 'purchase-order-common-1',
  'purchase-order-common-2': 'purchase-order-common-2',
  'purchase-order-common-3': 'purchase-order-common-3',
  'purchase-order-common-4': 'purchase-order-common-4',
  'purchase-order-bowcs-1': 'purchase-order-bowcs-1',
  'purchase-order-bowcs-2': 'purchase-order-bowcs-2',
  'sales-order-common-1': 'sales-order-common-1',
  'sales-order-common-2': 'sales-order-common-2',
  'sales-order-kobayashikazuo-1': 'sales-order-kobayashikazuo-1',
  'sales-order-bowcs-1': 'sales-order-bowcs-1',
  'sales-order-bowcs-2': 'sales-order-bowcs-2',
  'sales-order-bowcs-3': 'sales-order-bowcs-3',
  'quotation-common-1': 'quotation-common-1',
  'quotation-common-2': 'quotation-common-2',
  'quotation-common-3': 'quotation-common-3',
  'quotation-common-4': 'quotation-common-4',
  'quotation-custom-properties-1': 'quotation-custom-properties-1',
  'quotation-custom-properties-no-total-1': 'quotation-custom-properties-no-total-1',
  'quotation-invoice-custom-properties-1': 'quotation-invoice-custom-properties-1',
  'quotation-bowcs-1': 'quotation-bowcs-1',
  'invoice-common-1': 'invoice-common-1',
  'invoice-common-2': 'invoice-common-2',
  'invoice-yaoki-1': 'invoice-yaoki-1',
  'invoice-bowcs-1': 'invoice-bowcs-1',
  'invoice-bowcs-receipt-1': 'invoice-bowcs-receipt-1',
  'invoice-bowcs-statement-1': 'invoice-bowcs-statement-1',
  'invoice-bowcs-construction-1': 'invoice-bowcs-construction-1',
  'delivery-note-common-1': 'delivery-note-common-1',
  'delivery-note-common-2': 'delivery-note-common-2',
  'delivery-note-common-3': 'delivery-note-common-3',
  'delivery-note-common-4': 'delivery-note-common-4',
  'delivery-note-yaoki-1': 'delivery-note-yaoki-1',
  'delivery-note-yaoki-2': 'delivery-note-yaoki-2',
  'delivery-note-sobajima-1': 'delivery-note-sobajima-1',
  'delivery-note-sobajima-2': 'delivery-note-sobajima-2',
  'delivery-note-sobajima-3': 'delivery-note-sobajima-3',
  'delivery-note-bowcs-1': 'delivery-note-bowcs-1',
  'shipping-label-kuronekoyamato-1': 'shipping-label-kuronekoyamato-1',
  'shipping-label-sagawa-1': 'shipping-label-sagawa-1',
  'shipping-label-fukutsu-1': 'shipping-label-fukutsu-1',
  'shipping-label-tonami-1': 'shipping-label-tonami-1',
} as const;

export interface DocumentTemplate {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  document_type: DocumentTypeEnum;
  document_key: DocumentKeyEnum;
  readonly is_default: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedDocumentTemplateList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: DocumentTemplate[];
}

/**
 * * `PENDING` - 未確定
 * * `CONFIRMED` - 確定済
 */
export type EdiPurchaseOrderStatusEnum =
  (typeof EdiPurchaseOrderStatusEnum)[keyof typeof EdiPurchaseOrderStatusEnum];

export const EdiPurchaseOrderStatusEnum = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
} as const;

/**
 * Office用EDI発注一覧シリアライザ
 */
export interface OfficeEdiPurchaseOrderList {
  readonly id: number;
  readonly created_at: string;
  readonly partner_name: string;
  readonly orderer_name: string;
  /** @nullable */
  readonly desired_delivery_date: string | null;
  readonly notes: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly total_amount: string;
  readonly status: EdiPurchaseOrderStatusEnum;
  /** @nullable */
  readonly sales_order_id: number | null;
}

export interface PaginatedOfficeEdiPurchaseOrderListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: OfficeEdiPurchaseOrderList[];
}

/**
 * * `TAX_RATE_10` - 10%
 * * `TAX_RATE_8_REDUCED` - 8%(軽)
 * * `EXEMPTION` - 非課税
 * * `FREE` - 免税
 */
export type TaxClassEnum = (typeof TaxClassEnum)[keyof typeof TaxClassEnum];

export const TaxClassEnum = {
  TAX_RATE_10: 'TAX_RATE_10',
  TAX_RATE_8_REDUCED: 'TAX_RATE_8_REDUCED',
  EXEMPTION: 'EXEMPTION',
  FREE: 'FREE',
} as const;

/**
 * 数量別単価ティアシリアライザ
 */
export interface EdiQuantityPrice {
  min_quantity: number;
  /** @nullable */
  max_quantity: number | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
}

/**
 * EDI発注明細シリアライザ（読み取り用）
 */
export interface EdiPurchaseOrderItem {
  readonly id: number;
  /** @nullable */
  product_variation?: number | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly variation_snp: string | null;
  /** @nullable */
  readonly packaging_type_name: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  /** @maxLength 500 */
  name: string;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity?: string;
  /** @nullable */
  unit?: number | null;
  /** @nullable */
  readonly unit_name: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly amount: string;
  tax_class?: TaxClassEnum;
  /** @nullable */
  desired_delivery_date?: string | null;
  /** @nullable */
  last_purchased_at?: string | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  sort_order?: number | null;
  readonly created_at: string;
  readonly updated_at: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly base_unit_price: string;
  readonly quantity_prices: readonly EdiQuantityPrice[];
  /** @nullable */
  readonly thumbnail_url: string | null;
}

/**
 * 明細行項目表示カラム定義シリアライザ（スキーマ定義用）
 */
export interface ItemDisplayColumn {
  key: string;
  label: string;
  visible: boolean;
  required: boolean;
  sort_order: number;
}

/**
 * Office用EDI発注詳細レスポンスシリアライザ（スキーマ定義用）
 */
export interface OfficeEdiPurchaseOrderDetailResponse {
  readonly id: number;
  readonly partner: number;
  /** @nullable */
  readonly desired_delivery_date: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly subtotal: string;
  readonly tax_breakdown: unknown;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly total_amount: string;
  readonly status: EdiPurchaseOrderStatusEnum;
  readonly notes: string;
  readonly items: readonly EdiPurchaseOrderItem[];
  readonly created_at: string;
  readonly updated_at: string;
  readonly partner_name: string;
  readonly orderer_name: string;
  readonly item_display_columns: readonly ItemDisplayColumn[];
}

/**
 * Office用EDI発注一括確定シリアライザ
 */
export interface OfficeEdiPurchaseOrderConfirmRequest {
  ids: number[];
}

/**
 * * `ACTIVE` - 有効
 * * `INACTIVE` - 無効
 * * `REAUTH_REQUIRED` - 再認証必要
 */
export type ExternalConnectionStatusEnum =
  (typeof ExternalConnectionStatusEnum)[keyof typeof ExternalConnectionStatusEnum];

export const ExternalConnectionStatusEnum = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  REAUTH_REQUIRED: 'REAUTH_REQUIRED',
} as const;

export interface AmazonSpConnectionItem {
  /** 接続設定ID */
  id: number;
  /** AmazonセラーID */
  seller_id: string;
  /** Amazonストア名 */
  seller_name: string;
  /**
   * 接続ステータス
   *
   * * `ACTIVE` - 有効
   * * `INACTIVE` - 無効
   * * `REAUTH_REQUIRED` - 再認証必要
   */
  status: ExternalConnectionStatusEnum;
}

export interface PaginatedAmazonSpConnectionItemList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: AmazonSpConnectionItem[];
}

export interface BaseConnectionItem {
  /** 接続設定ID */
  id: number;
  /** BASEショップID */
  shop_id: string;
  /** BASEショップ名 */
  shop_name: string;
  /**
   * 接続ステータス
   *
   * * `ACTIVE` - 有効
   * * `INACTIVE` - 無効
   * * `REAUTH_REQUIRED` - 再認証必要
   */
  status: ExternalConnectionStatusEnum;
}

export interface PaginatedBaseConnectionItemList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: BaseConnectionItem[];
}

export interface BaseOAuthStartResponse {
  /** BASEの認証URL */
  url: string;
}

export interface Floor {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedFloorList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: Floor[];
}

export interface FloorRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

export type AllocationStatusEnum = (typeof AllocationStatusEnum)[keyof typeof AllocationStatusEnum];

export const AllocationStatusEnum = {
  UNALLOCATED: 'UNALLOCATED',
  PARTIALLY_ALLOCATED: 'PARTIALLY_ALLOCATED',
  ALL_ALLOCATED: 'ALL_ALLOCATED',
} as const;

/**
 * 入金消込シリアライザー
 */
export interface IncomingPaymentAllocation {
  readonly id: number;
  invoice: number;
  readonly invoice_number: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly invoice_total_amount: string;
  /** @nullable */
  readonly invoice_due_date: string | null;
  /** @nullable */
  readonly supplier_partner_bill_to_name: string | null;
  /** @nullable */
  readonly supplier_partner_bill_to_id: number | null;
  /**
   * 請求書の未入金額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly invoice_unallocated_amount: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  amount: string;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 入金明細シリアライザー
 */
export interface IncomingPaymentItem {
  readonly id: number;
  payment_type?: PaymentTypeEnum;
  /**
   * 符号付き（相殺・値引などの控除はマイナス）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  amount: string;
  /** @nullable */
  account_title?: number | null;
  /** @nullable */
  readonly account_title_name: string | null;
  /** @nullable */
  bill_due_date?: string | null;
  /**
   * @maxLength 30
   * @nullable
   */
  bill_no?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
  /**
   * @minimum 0
   * @maximum 32767
   */
  sort_order: number;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 入金一覧用シリアライザー
 */
export interface IncomingPaymentList {
  readonly id: number;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  payment_no: number;
  payment_date: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  amount: string;
  /** @nullable */
  readonly partner_name: string | null;
  /**
   * 得意先未確定の場合の自由入力
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
  readonly payment_method_name: string;
  /**
   * 担当者名
   * @nullable
   */
  readonly responsible_person_name: string | null;
  /** @nullable */
  readonly department_name: string | null;
  /** @nullable */
  readonly bank_account_name: string | null;
  /** @nullable */
  readonly account_title_name: string | null;
  /** 消込ステータス */
  readonly allocation_status: AllocationStatusEnum;
  /** 消込件数 */
  readonly allocation_count: number;
  /**
   * 消込済み金額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly allocated_amount: string;
  /**
   * 未消込残高
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly unallocated_amount: string;
  /**
   * 消込請求書の取引先名
   * @nullable
   */
  readonly invoice_partner_name: string | null;
  /**
   * 消込請求書の合計請求額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly invoice_total_amount: string;
  /**
   * 差額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly difference_amount: string;
  readonly allocations: readonly IncomingPaymentAllocation[];
  readonly items: readonly IncomingPaymentItem[];
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedIncomingPaymentListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: IncomingPaymentList[];
}

/**
 * 決済方法のシリアライザー
 */
export interface PaymentMethod {
  readonly id: number;
  /** @maxLength 255 */
  name: string;
  is_default?: boolean;
  readonly updated_at: string;
}

export interface User {
  readonly id: number;
  /**
   * この項目は必須です。半角アルファベット、半角数字、@/./+/-/_ で150文字以下にしてください。
   * @maxLength 150
   * @pattern ^[\w.@+-]+$
   */
  username: string;
  email?: string;
  readonly role: UserRoleEnum;
  readonly name: string;
}

/**
 * 入金詳細用シリアライザー
 */
export interface IncomingPaymentDetail {
  readonly id: number;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  payment_no: number;
  payment_date: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  amount: string;
  /** @nullable */
  partner?: number | null;
  /** @nullable */
  readonly partner_name: string | null;
  /** @nullable */
  readonly partner_code: string | null;
  /**
   * 得意先未確定の場合の自由入力
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
  readonly payment_method: PaymentMethod;
  readonly bank_account: BankAccount | null;
  readonly account_title: AccountTitleMaster | null;
  readonly responsible_person: User | null;
  /** @nullable */
  department?: number | null;
  /** @nullable */
  readonly department_name: string | null;
  readonly allocations: readonly IncomingPaymentAllocation[];
  readonly items: readonly IncomingPaymentItem[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 入金明細更新用シリアライザー
 */
export interface IncomingPaymentItemUpdateRequest {
  /** 既存明細ID（更新時のみ） */
  id?: number;
  /**
   * 入金区分
   *
   * * `cash` - 現金
   * * `transfer` - 振込
   * * `fee` - 手数料
   * * `check` - 小切手
   * * `bill` - 手形
   * * `offset` - 相殺
   * * `electronic` - 電債
   * * `other` - その他
   */
  payment_type: PaymentTypeEnum;
  /**
   * 金額（符号付き）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  amount: string;
  /**
   * 勘定科目ID
   * @nullable
   */
  account_title?: number | null;
  /**
   * 手形期日
   * @nullable
   */
  bill_due_date?: string | null;
  /**
   * 手形No
   * @maxLength 30
   * @nullable
   */
  bill_no?: string | null;
  /**
   * 行摘要
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
}

/**
 * 入金更新用シリアライザー
 */
export interface IncomingPaymentUpdateRequest {
  /**
   * @minimum 1
   * @nullable
   */
  payment_no?: number | null;
  payment_date: string;
  /** 入金明細リスト */
  items: IncomingPaymentItemUpdateRequest[];
  /** @nullable */
  responsible_person?: number | null;
  /** @nullable */
  department?: number | null;
  /** @nullable */
  partner?: number | null;
  /**
   * 得意先未確定の場合の自由入力
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
  payment_method: number;
  /** @nullable */
  bank_account?: number | null;
}

/**
 * 消込データ更新用シリアライザー
 */
export interface IncomingPaymentAllocationUpdateRequest {
  /** 既存消込ID（更新時のみ） */
  id?: number;
  /** 請求書ID */
  invoice: number;
}

/**
 * 消込データ一括更新用シリアライザー
 */
export interface IncomingPaymentAllocationBulkUpdateRequest {
  /** 消込データリスト */
  allocations?: IncomingPaymentAllocationUpdateRequest[];
}

/**
 * CSVカラムとデータ項目のマッピング
 */
export type IncomingPaymentBulkImportRequestMapping = { [key: string]: number };

/**
 * 入金一括登録用シリアライザ
 */
export interface IncomingPaymentBulkImportRequest {
  /**
   * アップロードされたCSVファイルのオブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: IncomingPaymentBulkImportRequestMapping;
}

/**
 * 入金一括登録レスポンス用シリアライザ
 */
export interface IncomingPaymentBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** 新規登録された件数 */
  imported_count?: number;
  /** スキップされた件数 */
  skipped_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

/**
 * 在庫調整実施の更新用
 */
export interface AdjustmentUpdateRequest {
  /** 調整日時 */
  adjusted_at: string;
}

/**
 * 倉庫シリアライザ(他ドメインの詳細画面等で使用する参照用の最小限の項目のみ)
 */
export interface LocationThin {
  readonly id: number;
  readonly name: string;
}

/**
 * * `STOCK_IN` - 入庫
 * * `STOCK_OUT` - 出庫
 * * `LOCATION_TRANSFER` - 倉庫移動
 * * `STOCKTAKING` - 棚卸
 */
export type StockAdjustmentTypeEnum = (typeof StockAdjustmentTypeEnum)[keyof typeof StockAdjustmentTypeEnum];

export const StockAdjustmentTypeEnum = {
  STOCK_IN: 'STOCK_IN',
  STOCK_OUT: 'STOCK_OUT',
  LOCATION_TRANSFER: 'LOCATION_TRANSFER',
  STOCKTAKING: 'STOCKTAKING',
} as const;

/**
 * * `DRAFT` - 下書き
 * * `ISSUED` - 対応中
 * * `PARTIALLY_ADJUSTED` - 一部調整済
 * * `ADJUSTED` - 調整済
 */
export type StockAdjustmentStatusEnum =
  (typeof StockAdjustmentStatusEnum)[keyof typeof StockAdjustmentStatusEnum];

export const StockAdjustmentStatusEnum = {
  DRAFT: 'DRAFT',
  ISSUED: 'ISSUED',
  PARTIALLY_ADJUSTED: 'PARTIALLY_ADJUSTED',
  ADJUSTED: 'ADJUSTED',
} as const;

/**
 * 在庫調整実施用
 */
export interface Adjustment {
  readonly id: number;
  readonly adjusted_at: string;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * * `NO_STOCK` - No Stock
 * * `IN_STOCK_PREPARATION` - In Stock Preparation
 * * `IN_STOCK` - In Stock
 * * `IGNORE` - Ignore
 */
export type StockStatusEnum = (typeof StockStatusEnum)[keyof typeof StockStatusEnum];

export const StockStatusEnum = {
  NO_STOCK: 'NO_STOCK',
  IN_STOCK_PREPARATION: 'IN_STOCK_PREPARATION',
  IN_STOCK: 'IN_STOCK',
  IGNORE: 'IGNORE',
} as const;

/**
 * 在庫調整明細に紐付く受注明細のサマリー(受注詳細への導線用)
 *
 * 受注側の serializer を import すると循環参照になるため、表示に必要な値だけを平坦に返す。
 */
export interface StockAdjustmentItemLinkedSalesOrderItem {
  /** 受注明細ID */
  id: number;
  /** 受注ID */
  sales_order_id: number;
  /**
   * 納入期日
   * @nullable
   */
  delivery_date: string | null;
  /**
   * 得意先名(受注書の得意先スナップショット)
   * @nullable
   */
  customer_name: string | null;
}

/**
 * 在庫調整明細のロット内訳の読み取り用
 *
 * lot_number / expiration_date は lot があればそのロットの値、新規ロットの入庫(調整実行まで lot が null)は
 * 入力値。調整実行や棚卸完了で番号により既存ロットへ解決した行は lot だけ紐付き入力値はそのままなので、
 * ロットの値を優先する。note は入力値。
 * is_auto_generated は内訳の無い明細の調整実行で既定ロット・自動割当が残した行。
 */
export interface StockAdjustmentItemLot {
  readonly id: number;
  /** @nullable */
  readonly lot: number | null;
  readonly lot_number: string;
  /** @nullable */
  readonly expiration_date: string | null;
  readonly note: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
  readonly is_auto_generated: boolean;
}

/**
 * * `NONE` - 対象外
 * * `LOT` - ロット管理
 * * `SERIAL` - シリアル管理
 */
export type LotManagementTypeEnum = (typeof LotManagementTypeEnum)[keyof typeof LotManagementTypeEnum];

export const LotManagementTypeEnum = {
  NONE: 'NONE',
  LOT: 'LOT',
  SERIAL: 'SERIAL',
} as const;

/**
 * 在庫調整明細詳細用
 */
export interface StockAdjustmentItemDetail {
  readonly id: number;
  product_variation: number;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly variation_snp: string | null;
  /** @nullable */
  readonly packaging_type_name: string | null;
  readonly adjustment: Adjustment | null;
  /** @maxLength 500 */
  name: string;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity: string;
  /** @nullable */
  readonly stock_ready_date: string | null;
  /** @nullable */
  unit?: number | null;
  /** @nullable */
  readonly unit_name: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp?: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  readonly stock_status: StockStatusEnum;
  /**
   * 明細の表示順序。nullの場合はIDでソート
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  sort_order?: number | null;
  /** @nullable */
  readonly linked_sales_order_item_id: number | null;
  readonly linked_sales_order_item: StockAdjustmentItemLinkedSalesOrderItem | null;
  readonly lots: readonly StockAdjustmentItemLot[];
  /**
   * 商品のロット管理区分
   *
   * * `NONE` - 対象外
   * * `LOT` - ロット管理
   * * `SERIAL` - シリアル管理
   */
  readonly lot_management_type: LotManagementTypeEnum;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * * `FREE_TEXT` - テキスト
 * * `MULTI_SELECT` - マルチセレクト
 * * `SELECT` - セレクト
 * * `URL` - URL
 * * `NUMBER` - 数値
 * * `BOOLEAN` - ブール値
 * * `WEBHOOK` - Webhook通知
 */
export type StockAdjustmentCustomPropertyFieldTypeEnum =
  (typeof StockAdjustmentCustomPropertyFieldTypeEnum)[keyof typeof StockAdjustmentCustomPropertyFieldTypeEnum];

export const StockAdjustmentCustomPropertyFieldTypeEnum = {
  FREE_TEXT: 'FREE_TEXT',
  MULTI_SELECT: 'MULTI_SELECT',
  SELECT: 'SELECT',
  URL: 'URL',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  WEBHOOK: 'WEBHOOK',
} as const;

/**
 * 在庫調整カスタムプロパティ定義用シリアライザ（読み取り用）
 */
export interface StockAdjustmentCustomProperty {
  readonly id: number;
  /** @maxLength 100 */
  label: string;
  readonly property_type: number;
  field_type: StockAdjustmentCustomPropertyFieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 在庫調整カスタムプロパティ値用シリアライザ（読み取り）
 */
export interface StockAdjustmentCustomPropertyValue {
  readonly id: number;
  stock_adjustment: number;
  custom_property: number;
  readonly custom_property_detail: StockAdjustmentCustomProperty;
  /** @nullable */
  value?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 在庫調整詳細用
 */
export interface StockAdjustmentDetail {
  readonly id: number;
  /** @maxLength 50 */
  number: string;
  readonly location: LocationThin;
  readonly destination_location: LocationThin | null;
  adjusted_at: string;
  /** @nullable */
  outbound_at?: string | null;
  adjustment_type: StockAdjustmentTypeEnum;
  responsible_person: number;
  /** 担当者名を取得 */
  readonly responsible_person_name: string;
  /** @nullable */
  responsible_department?: number | null;
  /** @nullable */
  reason?: string | null;
  status?: StockAdjustmentStatusEnum;
  readonly items: readonly StockAdjustmentItemDetail[];
  readonly custom_properties: readonly StockAdjustmentCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * * `PURCHASE_ORDER` - 発注
 * * `SALES_ORDER` - 受注
 * * `STOCKTAKING` - 棚卸し
 * * `STOCK_ADJUSTMENT` - 在庫調整
 * * `MANUFACTURING_ORDER` - 生産発注
 */
export type ReasonTypeEnum = (typeof ReasonTypeEnum)[keyof typeof ReasonTypeEnum];

export const ReasonTypeEnum = {
  PURCHASE_ORDER: 'PURCHASE_ORDER',
  SALES_ORDER: 'SALES_ORDER',
  STOCKTAKING: 'STOCKTAKING',
  STOCK_ADJUSTMENT: 'STOCK_ADJUSTMENT',
  MANUFACTURING_ORDER: 'MANUFACTURING_ORDER',
} as const;

/**
 * 在庫変更履歴一覧用
 */
export interface InventoryItemHistoryList {
  readonly id: number;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  variable_quantity?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
  reason_type: ReasonTypeEnum;
  /** @nullable */
  lot?: number | null;
  /** @nullable */
  readonly lot_number: string | null;
  /** @nullable */
  purchase_order_item?: number | null;
  /** @nullable */
  readonly purchase_order: number | null;
  /** @nullable */
  sales_order_item?: number | null;
  /** @nullable */
  readonly sales_order: number | null;
  /** @nullable */
  stock_taking?: number | null;
  /** @nullable */
  readonly stocktaking_number: string | null;
  /** @nullable */
  readonly stock_adjustment: number | null;
  /** @nullable */
  readonly stock_adjustment_number: string | null;
  /** @nullable */
  manufacturing_order?: number | null;
  /** @nullable */
  manufacturing_order_item?: number | null;
  /** @nullable */
  readonly manufacturing_order_number: string | null;
  stock_changed_at: string;
}

export interface PaginatedInventoryItemHistoryListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InventoryItemHistoryList[];
}

/**
 * CSVカラムとデータ項目のマッピング
 */
export type InventoryItemBulkImportRequestRequestMapping = { [key: string]: number };

/**
 * 在庫アイテムCSVインポートリクエスト用シリアライザ
 */
export interface InventoryItemBulkImportRequestRequest {
  /** インポート対象のロケーションID */
  location_id: number;
  /**
   * R2オブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: InventoryItemBulkImportRequestRequestMapping;
  /**
   * 元CSVファイルのファイル名
   * @minLength 1
   * @maxLength 255
   */
  filename?: string;
}

/**
 * 在庫アイテムCSVインポートレスポンス用シリアライザ
 */
export interface InventoryItemBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** インポートログID */
  import_log_id?: number;
  /** 更新された件数 */
  updated_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

/**
 * * `PROCESSING` - 処理中
 * * `SUCCESS` - 成功
 * * `FAILED` - 失敗
 */
export type ImportLogStatusEnum = (typeof ImportLogStatusEnum)[keyof typeof ImportLogStatusEnum];

export const ImportLogStatusEnum = {
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
} as const;

/**
 * 在庫アイテムインポートログ用シリアライザ
 */
export interface InventoryItemImportLog {
  readonly id: number;
  readonly location: number;
  readonly status: ImportLogStatusEnum;
  readonly is_success: boolean;
  readonly imported_count: number;
  readonly row_count: number;
  readonly errors: unknown;
  /** @nullable */
  readonly filename: string | null;
  /** エラーCSVがダウンロード可能か（object_keyが存在するか） */
  readonly has_error_file: boolean;
  readonly created_at: string;
}

export interface PaginatedInventoryItemImportLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InventoryItemImportLog[];
}

/**
 * 在庫一覧用
 *
 * location_idが指定された場合と未指定の場合で異なるデータ構造を扱う
 */
export interface InventoryItemList {
  /** @nullable */
  readonly id: number | null;
  readonly product_variation_id: number;
  readonly product_id: number;
  readonly product_variation_name: string;
  /** @nullable */
  readonly product_code: string | null;
  /** @nullable */
  readonly default_supplier_name: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly current_quantity: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly scheduled_receiving_quantity: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly scheduled_shipment_quantity: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly scheduled_quantity: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly inventory_value: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly valuation_amount: string;
  /** @nullable */
  readonly location_id: number | null;
  /** @nullable */
  readonly location_name: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly safety_stock: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly calculated_stock: string | null;
  /** @nullable */
  readonly shelf_id: number | null;
  /** @nullable */
  readonly shelf_name: string | null;
  /** @nullable */
  readonly floor_id: number | null;
  /** @nullable */
  readonly floor_name: string | null;
  /** @nullable */
  readonly area_id: number | null;
  /** @nullable */
  readonly area_name: string | null;
  /** @nullable */
  readonly category_type_1_name: string | null;
  /** @nullable */
  readonly category_type_2_name: string | null;
  /** @nullable */
  readonly category_type_3_name: string | null;
  /**
   * 商品のロット管理区分
   *
   * * `NONE` - 対象外
   * * `LOT` - ロット管理
   * * `SERIAL` - シリアル管理
   */
  readonly lot_management_type: LotManagementTypeEnum;
  /** 残高のあるロット件数(倉庫未指定は倉庫横断で同じロットを 1 件と数える) */
  readonly lot_count: number;
  /**
   * 残高のあるロットの最短の有効期限(期限切れを含む。期限のあるロットが無ければ null)
   * @nullable
   */
  readonly earliest_expiration_date: string | null;
}

export interface PaginatedInventoryItemListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InventoryItemList[];
}

/**
 * 安全在庫数更新用
 */
export interface PatchedInventoryItemSafetyStockUpdateRequest {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  safety_stock?: string;
}

/**
 * 棚番割当用
 */
export interface PatchedInventoryItemShelfUpdateRequest {
  /**
   * 棚番ID (null=割当解除)
   * @nullable
   */
  shelf_id?: number | null;
}

/**
 * 在庫アイテムエクスポートリクエスト用
 *
 * エクスポート対象の決定は次の優先順位:
 *   1. ids 指定あり    -> その ID のみ (選択エクスポート。フィルタ項目は無視)
 *   2. フィルタ項目あり -> 一覧と同じ絞り込みにマッチした全件 (指定ロケーション内)
 *   3. いずれも無し     -> 指定ロケーション内の全件
 * フィルタ項目は在庫一覧 (InventoryItemViewSet.list) の location_id 指定時のクエリパラメータと同名・同義。
 * 一覧は生のクエリ文字列を扱うため、ここでも全フィルタ項目を CharField (文字列) で受け取り、
 * _parse_inventory_filter_params 側の文字列前提のパース (validate_price_range / strict_int_convert) に委ねる。
 */
export interface InventoryItemExportRequestRequest {
  /**
   * エクスポートフォーマット
   *
   * * `csv` - csv
   * * `excel` - excel
   */
  format_type: FormatTypeEnum;
  /** エクスポート対象のIDリスト */
  ids?: number[];
  /** エクスポート対象のロケーションID */
  location_id: number;
  /** 過去在庫の評価基準日 (指定時は基準日時点の過去在庫をエクスポートする。今日以前の日付のみ) */
  valuation_date?: string;
  /**
   * 出力順。在庫一覧 (InventoryItemViewSet.list) の ordering と同名・同義。未指定時は一覧のデフォルト順。ids 指定時にも適用される
   * @minLength 1
   */
  ordering?: string;
  /**
   * 商品名 (全文検索/部分一致)
   * @minLength 1
   */
  product_variation_name?: string;
  /**
   * 商品コード (部分一致)
   * @minLength 1
   */
  product_code?: string;
  /**
   * 仕入先名 (部分一致)
   * @minLength 1
   */
  supplier_name?: string;
  /**
   * 分類1のカテゴリID
   * @minLength 1
   */
  category_type_1?: string;
  /**
   * 分類2のカテゴリID
   * @minLength 1
   */
  category_type_2?: string;
  /**
   * 分類3のカテゴリID
   * @minLength 1
   */
  category_type_3?: string;
  /**
   * 現在庫数の下限
   * @minLength 1
   */
  min_current_quantity?: string;
  /**
   * 現在庫数の上限
   * @minLength 1
   */
  max_current_quantity?: string;
  /**
   * 基準日在庫数の下限 (過去在庫用)
   * @minLength 1
   */
  min_historical_quantity?: string;
  /**
   * 基準日在庫数の上限 (過去在庫用)
   * @minLength 1
   */
  max_historical_quantity?: string;
  /**
   * 入荷予定数の下限
   * @minLength 1
   */
  min_scheduled_receiving_quantity?: string;
  /**
   * 入荷予定数の上限
   * @minLength 1
   */
  max_scheduled_receiving_quantity?: string;
  /**
   * 出荷予定数の下限
   * @minLength 1
   */
  min_scheduled_shipment_quantity?: string;
  /**
   * 出荷予定数の上限
   * @minLength 1
   */
  max_scheduled_shipment_quantity?: string;
  /**
   * 予定在庫数の下限
   * @minLength 1
   */
  min_scheduled_quantity?: string;
  /**
   * 予定在庫数の上限
   * @minLength 1
   */
  max_scheduled_quantity?: string;
  /**
   * 在庫金額の下限
   * @minLength 1
   */
  min_inventory_value?: string;
  /**
   * 在庫金額の上限
   * @minLength 1
   */
  max_inventory_value?: string;
  /**
   * 在庫評価額の下限
   * @minLength 1
   */
  min_valuation_amount?: string;
  /**
   * 在庫評価額の上限
   * @minLength 1
   */
  max_valuation_amount?: string;
  /**
   * 安全在庫の下限
   * @minLength 1
   */
  min_safety_stock?: string;
  /**
   * 安全在庫の上限
   * @minLength 1
   */
  max_safety_stock?: string;
  /**
   * 計算在庫の下限
   * @minLength 1
   */
  min_calculated_stock?: string;
  /**
   * 計算在庫の上限
   * @minLength 1
   */
  max_calculated_stock?: string;
  /**
   * 棚番名 (部分一致)
   * @minLength 1
   */
  shelf_name?: string;
  /**
   * フロア名 (部分一致)
   * @minLength 1
   */
  floor_name?: string;
  /**
   * エリア名 (部分一致)
   * @minLength 1
   */
  area_name?: string;
}

/**
 * 過去在庫一覧用
 */
export interface HistoricalInventoryItemList {
  readonly id: number;
  readonly product_variation_id: number;
  readonly product_id: number;
  readonly product_variation_name: string;
  /** @nullable */
  readonly product_code: string | null;
  /** @nullable */
  readonly default_supplier_name: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly historical_quantity: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly valuation_amount: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly inventory_value: string;
  readonly location_id: number;
  readonly location_name: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly safety_stock: string;
}

export interface PaginatedHistoricalInventoryItemListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: HistoricalInventoryItemList[];
}

/**
 * 在庫合計金額レスポンス用
 */
export interface InventorySummary {
  /**
   * 在庫コスト合計（商品名検索時はnull）
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly valuation_amount_sum: string | null;
}

/**
 * 倉庫(事業所)別在庫数用
 *
 * 指定した商品バリエーションについて、倉庫ごとの在庫数を表す。
 * 在庫レコードが存在しない倉庫は数量0で返す。
 */
export interface InventoryWarehouseStock {
  readonly location_id: number;
  readonly location_name: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly current_quantity: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly scheduled_receiving_quantity: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly scheduled_shipment_quantity: string;
}

export interface PaginatedInventoryWarehouseStockList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InventoryWarehouseStock[];
}

/**
 * * `sales_order` - sales_order
 * * `purchase_order` - purchase_order
 * * `stock_adjustment` - stock_adjustment
 * * `manufacturing_order` - manufacturing_order
 */
export type SourceTypeEnum = (typeof SourceTypeEnum)[keyof typeof SourceTypeEnum];

export const SourceTypeEnum = {
  sales_order: 'sales_order',
  purchase_order: 'purchase_order',
  stock_adjustment: 'stock_adjustment',
  manufacturing_order: 'manufacturing_order',
} as const;

/**
 * 入荷予定明細用
 */
export interface ScheduledReceivingItem {
  readonly source_type: SourceTypeEnum;
  /** @nullable */
  readonly purchase_order_id: number | null;
  /** @nullable */
  readonly purchase_order_item_id: number | null;
  /** @nullable */
  readonly supplier_name: string | null;
  /** @nullable */
  readonly stock_adjustment_id: number | null;
  /** @nullable */
  readonly stock_adjustment_number: string | null;
  /** @nullable */
  readonly manufacturing_order_id: number | null;
  /** @nullable */
  readonly manufacturing_order_number: string | null;
  /** @nullable */
  readonly scheduled_date: string | null;
  /** 納期回答待ち */
  readonly is_delivery_date_pending: boolean;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
}

/**
 * 入荷予定レスポンス用
 */
export interface ScheduledReceiving {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  total_quantity: string;
  items: ScheduledReceivingItem[];
}

/**
 * 出荷予定明細用
 */
export interface ScheduledShipmentItem {
  readonly source_type: SourceTypeEnum;
  /** @nullable */
  readonly sales_order_id: number | null;
  /** @nullable */
  readonly customer_name: string | null;
  /** @nullable */
  readonly stock_status: string | null;
  /** @nullable */
  readonly stock_ready_date: string | null;
  /** 納期回答待ち */
  readonly stock_ready_date_pending: boolean;
  /** @nullable */
  readonly stock_adjustment_id: number | null;
  /** @nullable */
  readonly stock_adjustment_number: string | null;
  /** @nullable */
  readonly manufacturing_order_id: number | null;
  /** @nullable */
  readonly manufacturing_order_number: string | null;
  /** @nullable */
  readonly scheduled_date: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
}

/**
 * 出荷予定レスポンス用
 */
export interface ScheduledShipment {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  total_quantity: string;
  items: ScheduledShipmentItem[];
}

/**
 * * `LAST_PURCHASE_COST` - 最終仕入原価法
 * * `FIFO` - 先入先出法
 * * `WEIGHTED_AVERAGE` - 総平均法
 * * `MOVING_AVERAGE` - 移動平均法
 * * `STANDARD_COST` - 標準原価法
 */
export type ValuationMethodEnum = (typeof ValuationMethodEnum)[keyof typeof ValuationMethodEnum];

export const ValuationMethodEnum = {
  LAST_PURCHASE_COST: 'LAST_PURCHASE_COST',
  FIFO: 'FIFO',
  WEIGHTED_AVERAGE: 'WEIGHTED_AVERAGE',
  MOVING_AVERAGE: 'MOVING_AVERAGE',
  STANDARD_COST: 'STANDARD_COST',
} as const;

/**
 * 在庫管理設定用
 */
export interface InventorySettingsRequest {
  valuation_method?: ValuationMethodEnum;
}

/**
 * 在庫管理設定用
 */
export interface InventorySettings {
  readonly id: number;
  valuation_method?: ValuationMethodEnum;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 在庫調整明細一覧用
 *
 * 明細 + 親の在庫調整情報をフラットに返す。
 * 親由来の表示項目・担当者名・amount(数量 × 単価)は QueryService の annotate 別名を参照し、
 * フィルタ・ソートに使う式と表示値を単一ソースにする。
 */
export interface StockAdjustmentItemList {
  readonly id: number;
  readonly stock_adjustment: number;
  readonly number: string;
  readonly adjusted_at: string;
  readonly adjustment_type: string;
  readonly status: string;
  readonly location: number;
  readonly location_name: string;
  /** @nullable */
  readonly destination_location_name: string | null;
  readonly responsible_person_name: string;
  /** @nullable */
  readonly responsible_department_name: string | null;
  /** @nullable */
  readonly reason: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /** @maxLength 500 */
  name: string;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /** @nullable */
  readonly unit_name: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  /** @pattern ^-?\d{0,22}(?:\.\d{0,2})?$ */
  readonly amount: string;
}

export interface PaginatedStockAdjustmentItemListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: StockAdjustmentItemList[];
}

/**
 * 在庫調整明細エクスポートリクエスト用
 *
 * フィルタ項目は在庫調整明細一覧 (StockAdjustmentItemViewSet.list) のクエリパラメータと同名・同義。
 * 一覧と同じ柔軟なパースに揃えるため、フィルタ項目は文字列で受け取る。
 */
export interface StockAdjustmentItemExportRequestRequest {
  /**
   * エクスポートフォーマット
   *
   * * `csv` - csv
   * * `excel` - excel
   */
  format_type: FormatTypeEnum;
  /**
   * ステータスで絞り込み（カンマ区切りで複数指定可能）
   * @minLength 1
   */
  status?: string;
  /**
   * 調整日の開始日
   * @minLength 1
   */
  adjusted_at_from?: string;
  /**
   * 調整日の終了日
   * @minLength 1
   */
  adjusted_at_to?: string;
  /**
   * 調整日フィルタの種別（AG Grid 日付フィルタ。equals/lessThan/greaterThan/inRange）
   * @minLength 1
   */
  adjusted_at_filter_type?: string;
  /**
   * 在庫調整No.で絞り込み（部分一致）
   * @minLength 1
   */
  number?: string;
  /**
   * 倉庫IDで絞り込み（カンマ区切りで複数指定可能）
   * @minLength 1
   */
  location_id?: string;
  /**
   * 処理内容で絞り込み（カンマ区切りで複数指定可能）
   * @minLength 1
   */
  adjustment_type?: string;
  /**
   * 商品コードで絞り込み（部分一致）
   * @minLength 1
   */
  product_code?: string;
  /**
   * 商品コードの空白/空白でない絞り込み（blank/notBlank）
   * @minLength 1
   */
  product_code_filter_type?: string;
  /**
   * 商品名で絞り込み（部分一致）
   * @minLength 1
   */
  name?: string;
  /**
   * 商品名の空白/空白でない絞り込み（blank/notBlank）
   * @minLength 1
   */
  name_filter_type?: string;
  /**
   * 担当者IDで絞り込み（カンマ区切りで複数指定可能）
   * @minLength 1
   */
  responsible_person_id?: string;
  /**
   * 相手先倉庫IDで絞り込み（カンマ区切りで複数指定可能）
   * @minLength 1
   */
  destination_location_id?: string;
  /**
   * 相手先倉庫未選択(NULL)を対象に含めるか(true 指定時。IDとはOR)
   * @minLength 1
   */
  destination_location_unassigned?: string;
  /**
   * 部門IDで絞り込み（カンマ区切りで複数指定可能）
   * @minLength 1
   */
  responsible_department_id?: string;
  /**
   * 部門未選択(NULL)を対象に含めるか(true 指定時。IDとはOR)
   * @minLength 1
   */
  responsible_department_unassigned?: string;
  /**
   * 理由で絞り込み（部分一致）
   * @minLength 1
   */
  reason?: string;
  /**
   * 理由の空白/空白でない絞り込み（blank/notBlank）
   * @minLength 1
   */
  reason_filter_type?: string;
  /**
   * 規格で絞り込み（部分一致）
   * @minLength 1
   */
  spec?: string;
  /**
   * 規格の空白/空白でない絞り込み（blank/notBlank）
   * @minLength 1
   */
  spec_filter_type?: string;
  /**
   * 単位で絞り込み（部分一致）
   * @minLength 1
   */
  unit_name?: string;
  /**
   * 単位の空白/空白でない絞り込み（blank/notBlank）
   * @minLength 1
   */
  unit_name_filter_type?: string;
  /**
   * 入数でフィルタリング（inRange 時の下限）
   * @minLength 1
   */
  snp?: string;
  /**
   * 入数の上限でフィルタリング
   * @minLength 1
   */
  snp_to?: string;
  /**
   * 入数フィルタの種別（AG Grid 数値フィルタ。未指定は equals 扱い）
   * @minLength 1
   */
  snp_filter_type?: string;
  /**
   * 数量でフィルタリング（inRange 時の下限）
   * @minLength 1
   */
  quantity?: string;
  /**
   * 数量の上限でフィルタリング
   * @minLength 1
   */
  quantity_to?: string;
  /**
   * 数量フィルタの種別（AG Grid 数値フィルタ。未指定は equals 扱い）
   * @minLength 1
   */
  quantity_filter_type?: string;
  /**
   * 単価でフィルタリング（inRange 時の下限）
   * @minLength 1
   */
  unit_price?: string;
  /**
   * 単価の上限でフィルタリング
   * @minLength 1
   */
  unit_price_to?: string;
  /**
   * 単価フィルタの種別（AG Grid 数値フィルタ。未指定は equals 扱い）
   * @minLength 1
   */
  unit_price_filter_type?: string;
  /**
   * 金額でフィルタリング（inRange 時の下限）
   * @minLength 1
   */
  amount?: string;
  /**
   * 金額の上限でフィルタリング
   * @minLength 1
   */
  amount_to?: string;
  /**
   * 金額フィルタの種別（AG Grid 数値フィルタ。未指定は equals 扱い）
   * @minLength 1
   */
  amount_filter_type?: string;
}

/**
 * 在庫調整一覧用
 */
export interface StockAdjustmentList {
  readonly id: number;
  /** @maxLength 50 */
  number: string;
  location: number;
  readonly location_name: string;
  /** @nullable */
  destination_location?: number | null;
  /** @nullable */
  readonly destination_location_name: string | null;
  adjusted_at: string;
  adjustment_type: StockAdjustmentTypeEnum;
  responsible_person: number;
  /** 担当者名を取得 */
  readonly responsible_person_name: string;
  /** @nullable */
  responsible_department?: number | null;
  /** @nullable */
  readonly responsible_department_name: string | null;
  /** @nullable */
  reason?: string | null;
  status?: StockAdjustmentStatusEnum;
  readonly custom_properties: readonly StockAdjustmentCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedStockAdjustmentListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: StockAdjustmentList[];
}

/**
 * 在庫調整新規作成用
 */
export interface StockAdjustmentCreateRequest {
  /**
   * 処理内容（省略時は入庫、棚卸は選択不可）
   *
   * * `STOCK_IN` - 入庫
   * * `STOCK_OUT` - 出庫
   * * `LOCATION_TRANSFER` - 倉庫移動
   * * `STOCKTAKING` - 棚卸
   */
  adjustment_type?: StockAdjustmentTypeEnum;
}

/**
 * 在庫調整明細のロット内訳の入力用
 */
export interface StockAdjustmentItemLotInputRequest {
  /**
   * 既存ロットのID(出庫・倉庫移動は必須)
   * @nullable
   */
  lot_id?: number | null;
  /**
   * ロット番号(入庫で lot_id を省略するとき。既存ロットと同じ番号ならそのロットに加算)
   * @maxLength 100
   */
  lot_number?: string;
  /**
   * 有効期限(新規ロットの入庫のみ)
   * @nullable
   */
  expiration_date?: string | null;
  /** 備考(新規ロットの入庫のみ) */
  note?: string;
  /**
   * ロットの数量
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  quantity: string;
}

/**
 * 在庫調整明細更新用
 */
export interface StockAdjustmentItemUpdateRequest {
  /**
   * 既存明細のID（新規時はnull）
   * @nullable
   */
  id?: number | null;
  /** 商品バリエーションID */
  product_variation_id: number;
  /**
   * 項目名
   * @minLength 1
   * @maxLength 500
   */
  name: string;
  /**
   * 商品コード
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * 規格
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /**
   * 数量
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  quantity: string;
  /**
   * 単位ID
   * @nullable
   */
  unit_id?: number | null;
  /**
   * 入数
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  snp?: string;
  /**
   * 単価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  unit_price: string;
  /**
   * 表示順序
   * @nullable
   */
  sort_order?: number | null;
  /** ロット管理商品のロット内訳(省略時は現状維持、指定時は置き換え。数量の合計は明細の数量と一致させる。空のリストは内訳なし=調整実行時に既定ロット・自動割当) */
  lots?: StockAdjustmentItemLotInputRequest[];
}

/**
 * 在庫調整カスタムプロパティ値更新用シリアライザ
 */
export interface StockAdjustmentCustomPropertyUpdateRequest {
  custom_property_id: number;
  /** @nullable */
  value: string | null;
}

/**
 * 在庫調整更新用
 */
export interface StockAdjustmentUpdateRequest {
  adjustment_type: StockAdjustmentTypeEnum;
  adjusted_at: string;
  /** @nullable */
  outbound_at?: string | null;
  location: number;
  /** @nullable */
  destination_location?: number | null;
  responsible_person: number;
  /** @nullable */
  responsible_department?: number | null;
  /** @nullable */
  reason?: string | null;
  /** 明細 */
  items?: StockAdjustmentItemUpdateRequest[];
  /** カスタムプロパティ値の更新データ */
  custom_properties?: StockAdjustmentCustomPropertyUpdateRequest[];
}

/**
 * 在庫調整明細の調整済リクエスト用
 */
export interface StockAdjustmentAdjustItemsRequest {
  /** 調整対象の明細IDリスト */
  item_ids: number[];
  /**
   * 調整実施日時（省略時は現在時刻）
   * @nullable
   */
  adjusted_at?: string | null;
}

/**
 * 在庫調整ステータス更新用
 */
export interface PatchedStockAdjustmentStatusUpdateRequest {
  status?: StockAdjustmentStatusEnum;
}

/**
 * 受注明細から作成する倉庫移動の明細
 */
export interface StockTransferBulkCreateItemRequest {
  /** 紐付ける受注明細ID */
  sales_order_item_id: number;
  /**
   * 移動数量
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  quantity: string;
}

/**
 * 受注明細から作成する倉庫移動1件分
 *
 * 移動先倉庫は受注明細の出荷倉庫と一致している必要がある(引当は移動先倉庫で判定するため)。
 */
export interface StockTransferBulkCreateRequest {
  /** 移動元倉庫ID */
  location: number;
  /** 移動先倉庫ID(受注明細の出荷倉庫と一致させる) */
  destination_location: number;
  /**
   * 調整実施日(省略時は作成日時)。在庫ステータスでは移動先への入庫予定日として扱う
   * @nullable
   */
  adjusted_at?: string | null;
  /**
   * 移動元からの出庫日(省略時は調整実施日と同じ)
   * @nullable
   */
  outbound_at?: string | null;
  /** 明細 */
  items: StockTransferBulkCreateItemRequest[];
}

/**
 * 受注明細からの倉庫移動一括作成用
 */
export interface StockAdjustmentBulkCreateRequest {
  /** 作成する倉庫移動のリスト */
  transfers: StockTransferBulkCreateRequest[];
}

/**
 * 受注明細からの倉庫移動一括作成レスポンス用
 */
export interface StockAdjustmentBulkCreateResponse {
  /** 作成された在庫調整リスト(同じ商品の明細が複数ある場合は分割された在庫調整を含む) */
  created_stock_adjustments: StockAdjustmentDetail[];
}

/**
 * CSVカラムとデータ項目のマッピング
 */
export type StockTakingItemBulkImportRequestRequestMapping = { [key: string]: number };

/**
 * 棚卸明細CSVインポートリクエスト用シリアライザ
 */
export interface StockTakingItemBulkImportRequestRequest {
  /**
   * R2オブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: StockTakingItemBulkImportRequestRequestMapping;
  /**
   * 元CSVファイルのファイル名
   * @minLength 1
   * @maxLength 255
   */
  filename?: string;
}

/**
 * 棚卸明細CSVインポートレスポンス用シリアライザ
 */
export interface StockTakingItemBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** インポートログID */
  import_log_id?: number;
  /** インポートされた件数 */
  imported_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

/**
 * 棚卸明細インポートログ用シリアライザ
 */
export interface StockTakingItemImportLog {
  readonly id: number;
  readonly stock_taking: number;
  readonly status: ImportLogStatusEnum;
  readonly is_success: boolean;
  readonly imported_count: number;
  readonly row_count: number;
  readonly errors: unknown;
  /** @nullable */
  readonly filename: string | null;
  readonly created_at: string;
}

export interface PaginatedStockTakingItemImportLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: StockTakingItemImportLog[];
}

/**
 * * `INIT` - 未着手
 * * `IN_PROGRESS` - 進行中
 * * `COMPLETED` - 完了
 */
export type StockTakingStatus = (typeof StockTakingStatus)[keyof typeof StockTakingStatus];

export const StockTakingStatus = {
  INIT: 'INIT',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

/**
 * 在庫棚卸一覧用
 */
export interface StockTakingList {
  readonly id: number;
  /** @maxLength 20 */
  stocktaking_number: string;
  location: number;
  readonly location_name: string;
  status?: StockTakingStatus;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  completed_at?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedStockTakingListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: StockTakingList[];
}

/**
 * 在庫棚卸作成用
 */
export interface StockTakingCreateRequest {
  location: number;
  /** @nullable */
  reason?: string | null;
}

/**
 * 在庫棚卸詳細用
 */
export interface StockTakingDetail {
  readonly id: number;
  /** @maxLength 20 */
  stocktaking_number: string;
  location: number;
  readonly location_name: string;
  status?: StockTakingStatus;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  completed_at?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 在庫棚卸更新用
 */
export interface StockTakingUpdateRequest {
  location_id?: number;
  /** @nullable */
  reason: string | null;
}

/**
 * 在庫棚卸明細のロット行の読み取り用
 *
 * lot_number / expiration_date は lot があればそのロットの値、帳簿にないロット(lot が null)は入力値。
 * 完了時に番号で既存ロットへ解決した行は lot だけ紐付き入力値はそのままなので、ロットの値を優先する。
 * current_quantity(帳簿数)は完了時に確定する。
 */
export interface StockTakingItemLot {
  readonly id: number;
  /** @nullable */
  readonly lot: number | null;
  readonly lot_number: string;
  /** @nullable */
  readonly expiration_date: string | null;
  /**
   * 棚卸完了時点のシステム上のロット在庫数
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly current_quantity: string;
  /**
   * 棚卸で確認した実際のロット在庫数。NULLは未入力
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly actual_quantity: string | null;
}

/**
 * 在庫棚卸明細の読み取り用
 */
export interface StockTakingItem {
  readonly id: number;
  product_variation: number;
  readonly product_variation_name: string;
  readonly product_code: string;
  /**
   * 棚卸完了時点のシステム上の在庫数
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly current_quantity: string | null;
  /**
   * 棚卸で確認した実際の在庫数
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  actual_quantity: string;
  /**
   * 実在庫数と現在庫数の差分を計算
   * @nullable
   */
  readonly difference: string | null;
  readonly lots: readonly StockTakingItemLot[];
  /**
   * 商品のロット管理区分
   *
   * * `NONE` - 対象外
   * * `LOT` - ロット管理
   * * `SERIAL` - シリアル管理
   */
  readonly lot_management_type: LotManagementTypeEnum;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedStockTakingItemList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: StockTakingItem[];
}

/**
 * 在庫棚卸明細のロット別実在庫の入力用
 */
export interface StockTakingItemLotInputRequest {
  /**
   * 帳簿にあるロットのID(帳簿にないロットは null)
   * @nullable
   */
  lot_id?: number | null;
  /**
   * 帳簿にないロットのロット番号
   * @maxLength 100
   */
  lot_number?: string;
  /**
   * 帳簿にないロットの有効期限
   * @nullable
   */
  expiration_date?: string | null;
  /**
   * ロットの実在庫数
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  actual_quantity: string;
}

/**
 * 在庫棚卸明細の作成用
 *
 * バーコードスキャンのように実在庫数を指定して登録する用途向けのため actual_quantity は必須。
 * 現在庫数を初期値として登録する場合は一括追加 (StockTakingItemBulkAddSerializer) を使用する。
 */
export interface StockTakingItemCreateRequest {
  product_variation: number;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  actual_quantity: string;
  /** ロット管理商品のロット別実在庫(省略時は行なし) */
  lots?: StockTakingItemLotInputRequest[];
}

/**
 * 在庫棚卸明細の更新用
 */
export interface StockTakingItemUpdateRequest {
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  actual_quantity: string;
  /** ロット管理商品のロット別実在庫(省略時は現状維持、指定時は置き換え) */
  lots?: StockTakingItemLotInputRequest[];
}

/**
 * 在庫棚卸明細の一括追加用
 */
export interface StockTakingItemBulkAddRequest {
  /** 商品バリエーションIDのリスト */
  product_variation_ids: number[];
}

/**
 * 在庫棚卸明細の一括追加でスキップされた商品
 */
export interface StockTakingItemBulkAddSkipped {
  product_variation_id: number;
  reason: string;
}

/**
 * 在庫棚卸明細の一括追加結果
 */
export interface StockTakingItemBulkAddResult {
  items: StockTakingItem[];
  skipped: StockTakingItemBulkAddSkipped[];
}

/**
 * 在庫棚卸ステータス更新用
 */
export interface PatchedStockTakingStatusUpdateRequest {
  status?: StockTakingStatus;
  /**
   * 完了日（完了時のみ有効。省略時は当日。過去日はその日の終わり時点の在庫数との差分で調整する）
   * @nullable
   */
  completed_date?: string | null;
}

/**
 * バーコード検索結果用
 */
export interface BarcodeSearchResult {
  readonly id: number;
  /** @nullable */
  readonly product_code: string | null;
  readonly variation_name: string;
  /** @nullable */
  readonly spec: string | null;
  /**
   * 商品バリエーション詳細情報からJANコードを取得
   * @nullable
   */
  readonly jan_code: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly current_quantity: string | null;
  /** @nullable */
  readonly existing_item_id: number | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly existing_actual_quantity: string | null;
  /**
   * 商品のロット管理区分
   *
   * * `NONE` - 対象外
   * * `LOT` - ロット管理
   * * `SERIAL` - シリアル管理
   */
  readonly lot_management_type: LotManagementTypeEnum;
}

/**
 * 請求書メールテンプレート設定
 */
export interface InvoiceEmailTemplateSetting {
  /** デフォルトテンプレートを使用するか */
  use_default: boolean;
  /**
   * カスタムテンプレート本文
   * @maxLength 10000
   * @nullable
   */
  custom_body?: string | null;
  /** システムデフォルト本文 */
  readonly default_body: string;
}

/**
 * 請求書メールテンプレート設定
 */
export interface InvoiceEmailTemplateSettingRequest {
  /** デフォルトテンプレートを使用するか */
  use_default: boolean;
  /**
   * カスタムテンプレート本文
   * @minLength 1
   * @maxLength 10000
   * @nullable
   */
  custom_body?: string | null;
}

/**
 * 請求書メールテンプレートのパラメータ置換済み本文
 */
export interface InvoiceEmailTemplateSettingRender {
  /** パラメータ置換済みのメール本文 */
  rendered_body: string;
}

/**
 * 請求書出力項目
 */
export interface InvoiceExportSettingColumn {
  /**
   * カラムキー名
   * @maxLength 100
   */
  key: string;
  /** ソート順 */
  sort_order: number;
  /**
   * ラベル
   * @maxLength 100
   */
  label?: string;
}

/**
 * 請求書出力設定
 */
export interface InvoiceExportSetting {
  readonly id: number;
  /** @maxLength 100 */
  template_name: string;
  readonly columns: readonly InvoiceExportSettingColumn[];
}

export interface PaginatedInvoiceExportSettingList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InvoiceExportSetting[];
}

/**
 * * `ID` - ID
 * * `INVOICE_NUMBER` - INVOICE_NUMBER
 * * `TITLE` - TITLE
 * * `STATUS` - STATUS
 * * `ISSUE_DATE` - ISSUE_DATE
 * * `SHIPPING_COMPLETION_DATE` - SHIPPING_COMPLETION_DATE
 * * `DUE_DATE` - DUE_DATE
 * * `PAYMENT_TERMS` - PAYMENT_TERMS
 * * `SUBTOTAL` - SUBTOTAL
 * * `TOTAL_AMOUNT` - TOTAL_AMOUNT
 * * `MSRP_SUBTOTAL` - MSRP_SUBTOTAL
 * * `MSRP_TOTAL` - MSRP_TOTAL
 * * `NOTES` - NOTES
 * * `INTERNAL_NOTES` - INTERNAL_NOTES
 * * `TAGS` - TAGS
 * * `RESPONSIBLE_PERSON` - RESPONSIBLE_PERSON
 * * `RESPONSIBLE_PERSON_EMAIL` - RESPONSIBLE_PERSON_EMAIL
 * * `CUSTOMER_PARTNER_NAME` - CUSTOMER_PARTNER_NAME
 * * `CUSTOMER_PARTNER_CODE` - CUSTOMER_PARTNER_CODE
 * * `CUSTOMER_CONTACT_PERSON` - CUSTOMER_CONTACT_PERSON
 * * `CUSTOMER_POSTAL_CODE` - CUSTOMER_POSTAL_CODE
 * * `CUSTOMER_ADDRESS1` - CUSTOMER_ADDRESS1
 * * `CUSTOMER_PHONE` - CUSTOMER_PHONE
 * * `CUSTOMER_FAX` - CUSTOMER_FAX
 * * `CUSTOMER_EMAIL_TO` - CUSTOMER_EMAIL_TO
 * * `CUSTOMER_EMAIL_CC` - CUSTOMER_EMAIL_CC
 * * `CREATED_AT` - CREATED_AT
 * * `UPDATED_AT` - UPDATED_AT
 * * `DEPARTMENT_NAME` - DEPARTMENT_NAME
 * * `PAYMENT_METHOD` - PAYMENT_METHOD
 * * `PROJECT_ID` - PROJECT_ID
 */
export type InvoiceExportColumnTypeEnum =
  (typeof InvoiceExportColumnTypeEnum)[keyof typeof InvoiceExportColumnTypeEnum];

export const InvoiceExportColumnTypeEnum = {
  ID: 'ID',
  INVOICE_NUMBER: 'INVOICE_NUMBER',
  TITLE: 'TITLE',
  STATUS: 'STATUS',
  ISSUE_DATE: 'ISSUE_DATE',
  SHIPPING_COMPLETION_DATE: 'SHIPPING_COMPLETION_DATE',
  DUE_DATE: 'DUE_DATE',
  PAYMENT_TERMS: 'PAYMENT_TERMS',
  SUBTOTAL: 'SUBTOTAL',
  TOTAL_AMOUNT: 'TOTAL_AMOUNT',
  MSRP_SUBTOTAL: 'MSRP_SUBTOTAL',
  MSRP_TOTAL: 'MSRP_TOTAL',
  NOTES: 'NOTES',
  INTERNAL_NOTES: 'INTERNAL_NOTES',
  TAGS: 'TAGS',
  RESPONSIBLE_PERSON: 'RESPONSIBLE_PERSON',
  RESPONSIBLE_PERSON_EMAIL: 'RESPONSIBLE_PERSON_EMAIL',
  CUSTOMER_PARTNER_NAME: 'CUSTOMER_PARTNER_NAME',
  CUSTOMER_PARTNER_CODE: 'CUSTOMER_PARTNER_CODE',
  CUSTOMER_CONTACT_PERSON: 'CUSTOMER_CONTACT_PERSON',
  CUSTOMER_POSTAL_CODE: 'CUSTOMER_POSTAL_CODE',
  CUSTOMER_ADDRESS1: 'CUSTOMER_ADDRESS1',
  CUSTOMER_PHONE: 'CUSTOMER_PHONE',
  CUSTOMER_FAX: 'CUSTOMER_FAX',
  CUSTOMER_EMAIL_TO: 'CUSTOMER_EMAIL_TO',
  CUSTOMER_EMAIL_CC: 'CUSTOMER_EMAIL_CC',
  CREATED_AT: 'CREATED_AT',
  UPDATED_AT: 'UPDATED_AT',
  DEPARTMENT_NAME: 'DEPARTMENT_NAME',
  PAYMENT_METHOD: 'PAYMENT_METHOD',
  PROJECT_ID: 'PROJECT_ID',
} as const;

/**
 * 請求書出力項目 (書き込み用)
 */
export interface InvoiceExportSettingColumnCreateUpdateRequest {
  /**
   * カラムキー名
   *
   * * `ID` - ID
   * * `INVOICE_NUMBER` - INVOICE_NUMBER
   * * `TITLE` - TITLE
   * * `STATUS` - STATUS
   * * `ISSUE_DATE` - ISSUE_DATE
   * * `SHIPPING_COMPLETION_DATE` - SHIPPING_COMPLETION_DATE
   * * `DUE_DATE` - DUE_DATE
   * * `PAYMENT_TERMS` - PAYMENT_TERMS
   * * `SUBTOTAL` - SUBTOTAL
   * * `TOTAL_AMOUNT` - TOTAL_AMOUNT
   * * `MSRP_SUBTOTAL` - MSRP_SUBTOTAL
   * * `MSRP_TOTAL` - MSRP_TOTAL
   * * `NOTES` - NOTES
   * * `INTERNAL_NOTES` - INTERNAL_NOTES
   * * `TAGS` - TAGS
   * * `RESPONSIBLE_PERSON` - RESPONSIBLE_PERSON
   * * `RESPONSIBLE_PERSON_EMAIL` - RESPONSIBLE_PERSON_EMAIL
   * * `CUSTOMER_PARTNER_NAME` - CUSTOMER_PARTNER_NAME
   * * `CUSTOMER_PARTNER_CODE` - CUSTOMER_PARTNER_CODE
   * * `CUSTOMER_CONTACT_PERSON` - CUSTOMER_CONTACT_PERSON
   * * `CUSTOMER_POSTAL_CODE` - CUSTOMER_POSTAL_CODE
   * * `CUSTOMER_ADDRESS1` - CUSTOMER_ADDRESS1
   * * `CUSTOMER_PHONE` - CUSTOMER_PHONE
   * * `CUSTOMER_FAX` - CUSTOMER_FAX
   * * `CUSTOMER_EMAIL_TO` - CUSTOMER_EMAIL_TO
   * * `CUSTOMER_EMAIL_CC` - CUSTOMER_EMAIL_CC
   * * `CREATED_AT` - CREATED_AT
   * * `UPDATED_AT` - UPDATED_AT
   * * `DEPARTMENT_NAME` - DEPARTMENT_NAME
   * * `PAYMENT_METHOD` - PAYMENT_METHOD
   * * `PROJECT_ID` - PROJECT_ID
   */
  key: InvoiceExportColumnTypeEnum;
  /** ソート順 */
  sort_order: number;
  /**
   * ラベル
   * @maxLength 100
   * @nullable
   */
  label?: string | null;
}

/**
 * 請求書出力設定 (書き込み用)
 */
export interface InvoiceExportSettingCreateUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  template_name: string;
  columns: InvoiceExportSettingColumnCreateUpdateRequest[];
}

/**
 * 請求書エクスポート用シリアライザー
 *
 * エクスポート対象の決定は次の優先順位:
 *   1. ids 指定あり    -> その ID のみ (選択エクスポート。フィルタ項目は無視)
 *   2. フィルタ項目あり -> 一覧と同じ絞り込み・対応ステータスタブにマッチした全件
 *   3. いずれも無し     -> 組織内の全件
 */
export interface InvoiceExportRequest {
  /**
   * ステータス (DRAFT/ISSUED)
   * @minLength 1
   */
  status?: string;
  /**
   * 発行日の開始 (YYYY-MM-DD)
   * @minLength 1
   */
  from_date?: string;
  /**
   * 発行日の終了 (YYYY-MM-DD)
   * @minLength 1
   */
  to_date?: string;
  /**
   * 請求書番号 (部分一致)
   * @minLength 1
   */
  invoice_number?: string;
  /**
   * 請求先名 (部分一致)
   * @minLength 1
   */
  customer_name?: string;
  /**
   * 旧請求先スナップショット名 (部分一致。旧クライアント互換用)
   * @minLength 1
   */
  bill_to_name?: string;
  /**
   * 件名 (部分一致)
   * @minLength 1
   */
  title?: string;
  /** 決済方法ID */
  payment_method_id?: number;
  /**
   * 合計金額(税込)の下限
   * @minLength 1
   */
  min_amount?: string;
  /**
   * 合計金額(税込)の上限
   * @minLength 1
   */
  max_amount?: string;
  /**
   * 小計(税抜)の下限
   * @minLength 1
   */
  min_subtotal?: string;
  /**
   * 小計(税抜)の上限
   * @minLength 1
   */
  max_subtotal?: string;
  /**
   * 消込金額の下限
   * @minLength 1
   */
  min_allocated_amount?: string;
  /**
   * 消込金額の上限
   * @minLength 1
   */
  max_allocated_amount?: string;
  /**
   * 差額(未消込金額)の下限
   * @minLength 1
   */
  min_unallocated_amount?: string;
  /**
   * 差額(未消込金額)の上限
   * @minLength 1
   */
  max_unallocated_amount?: string;
  /**
   * 支払期限の開始 (YYYY-MM-DD)
   * @minLength 1
   */
  due_date_from?: string;
  /**
   * 支払期限の終了 (YYYY-MM-DD)
   * @minLength 1
   */
  due_date_to?: string;
  /** 部門ID */
  responsible_department?: number;
  /**
   * タグ名 (部分一致)
   * @minLength 1
   */
  tag_name?: string;
  /**
   * 消込ステータス (UNALLOCATED/PARTIALLY_ALLOCATED/ALL_ALLOCATED)
   * @minLength 1
   */
  allocation_status?: string;
  /**
   * 対応ステータスタブ (all/in_progress/completed)
   * @minLength 1
   */
  handling_status?: string;
  /**
   * フォーマットタイプ
   *
   * * `csv` - csv
   * * `excel` - excel
   */
  format_type: FormatTypeEnum;
  ids?: number[];
  /**
   * 出力項目設定ID(未指定時はデフォルトカラム)
   * @nullable
   */
  export_settings_id?: number | null;
}

/**
 * * `SMBC_URKPC` - SMBC_URKPC
 */
export type InvoiceExportPresetTypeEnum =
  (typeof InvoiceExportPresetTypeEnum)[keyof typeof InvoiceExportPresetTypeEnum];

export const InvoiceExportPresetTypeEnum = {
  SMBC_URKPC: 'SMBC_URKPC',
} as const;

/**
 * 請求書プリセットエクスポートのリクエスト
 *
 * システム側で定義された固定フォーマット (例: SMBC_URKPC) でエクスポートする際に使う。
 * ユーザー定義の出力項目設定を使う通常のエクスポートとは別エンドポイント。
 * エクスポート対象の決定は通常エクスポートと同じ優先順位
 * (明示ids > 一覧フィルタ > プリセット条件のみ) で、基底クラスの一覧フィルタ項目を反映する。
 */
export interface InvoiceExportPresetRequestRequest {
  /**
   * ステータス (DRAFT/ISSUED)
   * @minLength 1
   */
  status?: string;
  /**
   * 発行日の開始 (YYYY-MM-DD)
   * @minLength 1
   */
  from_date?: string;
  /**
   * 発行日の終了 (YYYY-MM-DD)
   * @minLength 1
   */
  to_date?: string;
  /**
   * 請求書番号 (部分一致)
   * @minLength 1
   */
  invoice_number?: string;
  /**
   * 請求先名 (部分一致)
   * @minLength 1
   */
  customer_name?: string;
  /**
   * 旧請求先スナップショット名 (部分一致。旧クライアント互換用)
   * @minLength 1
   */
  bill_to_name?: string;
  /**
   * 件名 (部分一致)
   * @minLength 1
   */
  title?: string;
  /** 決済方法ID */
  payment_method_id?: number;
  /**
   * 合計金額(税込)の下限
   * @minLength 1
   */
  min_amount?: string;
  /**
   * 合計金額(税込)の上限
   * @minLength 1
   */
  max_amount?: string;
  /**
   * 小計(税抜)の下限
   * @minLength 1
   */
  min_subtotal?: string;
  /**
   * 小計(税抜)の上限
   * @minLength 1
   */
  max_subtotal?: string;
  /**
   * 消込金額の下限
   * @minLength 1
   */
  min_allocated_amount?: string;
  /**
   * 消込金額の上限
   * @minLength 1
   */
  max_allocated_amount?: string;
  /**
   * 差額(未消込金額)の下限
   * @minLength 1
   */
  min_unallocated_amount?: string;
  /**
   * 差額(未消込金額)の上限
   * @minLength 1
   */
  max_unallocated_amount?: string;
  /**
   * 支払期限の開始 (YYYY-MM-DD)
   * @minLength 1
   */
  due_date_from?: string;
  /**
   * 支払期限の終了 (YYYY-MM-DD)
   * @minLength 1
   */
  due_date_to?: string;
  /** 部門ID */
  responsible_department?: number;
  /**
   * タグ名 (部分一致)
   * @minLength 1
   */
  tag_name?: string;
  /**
   * 消込ステータス (UNALLOCATED/PARTIALLY_ALLOCATED/ALL_ALLOCATED)
   * @minLength 1
   */
  allocation_status?: string;
  /**
   * 対応ステータスタブ (all/in_progress/completed)
   * @minLength 1
   */
  handling_status?: string;
  /**
   * プリセット種別 (例: SMBC_URKPC)
   *
   * * `SMBC_URKPC` - SMBC_URKPC
   */
  preset_type: InvoiceExportPresetTypeEnum;
  /**
   * フォーマットタイプ
   *
   * * `csv` - csv
   * * `excel` - excel
   */
  format_type: FormatTypeEnum;
  /**
   * 三井住友コード (6桁数字)。このコードを持つ締めグループに属する得意先(請求先)の請求書を出力対象とし、エクスポートファイル名 `URKPCnnnnnn_yyyymm` の nnnnnn 部分に使用する
   * @minLength 1
   * @pattern ^[0-9]{6}$
   */
  smbc_code: string;
  /** エクスポート対象IDリスト */
  ids?: number[];
}

/**
 * 請求インポートログシリアライザ
 */
export interface InvoiceImportLog {
  readonly id: number;
  readonly status: ImportLogStatusEnum;
  readonly is_success: boolean;
  readonly imported_count: number;
  readonly imported_items_count: number;
  readonly row_count: number;
  readonly errors: unknown;
  /** @nullable */
  readonly filename: string | null;
  /** エラーCSVがダウンロード可能か（object_keyが存在するか） */
  readonly has_error_file: boolean;
  readonly created_at: string;
}

export interface PaginatedInvoiceImportLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InvoiceImportLog[];
}

/**
 * 請求書タグシリアライザー
 */
export interface InvoiceTag {
  readonly id: number;
  /** @maxLength 250 */
  name: string;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedInvoiceTagList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InvoiceTag[];
}

/**
 * 請求書タグシリアライザー
 */
export interface InvoiceTagRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
}

/**
 * * `DRAFT` - 下書き
 * * `ISSUED` - 発行済
 */
export type InvoiceStatusEnum = (typeof InvoiceStatusEnum)[keyof typeof InvoiceStatusEnum];

export const InvoiceStatusEnum = {
  DRAFT: 'DRAFT',
  ISSUED: 'ISSUED',
} as const;

/**
 * * `FREE_TEXT` - テキスト
 * * `MULTI_SELECT` - マルチセレクト
 * * `SELECT` - セレクト
 * * `URL` - URL
 * * `NUMBER` - 数値
 * * `MEMBER` - メンバー
 * * `BOOLEAN` - ブール値
 */
export type OrderCustomPropertyFieldTypeEnum =
  (typeof OrderCustomPropertyFieldTypeEnum)[keyof typeof OrderCustomPropertyFieldTypeEnum];

export const OrderCustomPropertyFieldTypeEnum = {
  FREE_TEXT: 'FREE_TEXT',
  MULTI_SELECT: 'MULTI_SELECT',
  SELECT: 'SELECT',
  URL: 'URL',
  NUMBER: 'NUMBER',
  MEMBER: 'MEMBER',
  BOOLEAN: 'BOOLEAN',
} as const;

/**
 * 請求書カスタムプロパティ定義用シリアライザ（読み取り用）
 */
export interface InvoiceCustomProperty {
  readonly id: number;
  /** @maxLength 100 */
  label: string;
  readonly property_type: number;
  field_type: OrderCustomPropertyFieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 請求書カスタムプロパティ値用シリアライザ（読み取り）
 */
export interface InvoiceCustomPropertyValue {
  readonly id: number;
  invoice: number;
  custom_property: number;
  readonly custom_property_detail: InvoiceCustomProperty;
  readonly member_detail: User | null;
  /** @nullable */
  value?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 請求書一覧用シリアライザー
 */
export interface InvoiceList {
  readonly id: number;
  /** @maxLength 100 */
  title?: string;
  /** @nullable */
  readonly project_name: string | null;
  readonly bank_account: BankAccount | null;
  readonly payment_method: PaymentMethod | null;
  /** @maxLength 100 */
  invoice_number: string;
  status?: InvoiceStatusEnum;
  issue_date?: string;
  /** @nullable */
  due_date?: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  subtotal?: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  total_amount?: string;
  /**
   * 消込済金額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly allocated_amount: string;
  /**
   * 未入金額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly unallocated_amount: string;
  /**
   * 消込ステータス
   *
   * * `UNALLOCATED` - 未消込
   * * `PARTIALLY_ALLOCATED` - 一部消込
   * * `ALL_ALLOCATED` - 消込済
   */
  readonly allocation_status: AllocationStatusEnum;
  readonly supplier_partner_customer_name: string;
  /** @nullable */
  readonly supplier_partner_customer_id: number | null;
  readonly supplier_partner_bill_to_name: string;
  /**
   * 請求先（取引先マスタ）の支払手数料率（%）。未設定時はnull
   * @nullable
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  readonly supplier_partner_bill_to_payment_fee_rate: string | null;
  readonly responsible_department: number;
  /** @nullable */
  readonly responsible_department_name: string | null;
  readonly tags: readonly InvoiceTag[];
  readonly custom_properties: readonly InvoiceCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedInvoiceListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InvoiceList[];
}

/**
 * 請求書作成用シリアライザー
 */
export interface InvoiceCreateRequest {
  /**
   * 案件ID（オプション）
   * @nullable
   */
  project_id?: number | null;
}

/**
 * * `FREE_TEXT` - テキスト
 * * `SELECT` - セレクト
 * * `MULTI_SELECT` - マルチセレクト
 * * `URL` - URL
 * * `NUMBER` - 数値
 * * `MEMBER` - メンバー
 * * `DATETIME` - 日時
 * * `MULTI_LINE_TEXT` - 複数行テキスト
 * * `BOOLEAN` - ブール値
 * * `ADDRESS` - 住所
 * * `WEBHOOK` - Webhook通知
 */
export type FieldTypeEnum = (typeof FieldTypeEnum)[keyof typeof FieldTypeEnum];

export const FieldTypeEnum = {
  FREE_TEXT: 'FREE_TEXT',
  SELECT: 'SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  URL: 'URL',
  NUMBER: 'NUMBER',
  MEMBER: 'MEMBER',
  DATETIME: 'DATETIME',
  MULTI_LINE_TEXT: 'MULTI_LINE_TEXT',
  BOOLEAN: 'BOOLEAN',
  ADDRESS: 'ADDRESS',
  WEBHOOK: 'WEBHOOK',
} as const;

/**
 * 案件カスタムプロパティ定義用シリアライザ（作成・読み取り用）
 */
export interface ProjectCustomProperty {
  readonly id: number;
  /** @maxLength 100 */
  label: string;
  readonly property_type: number;
  field_type?: FieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 案件カスタムプロパティ値用シリアライザ
 */
export interface ProjectCustomPropertyValue {
  readonly id: number;
  project: number;
  custom_property: number;
  readonly custom_property_detail: ProjectCustomProperty;
  /** @nullable */
  value?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 案件のシリアライザー
 *
 * 主に詳細以外で使用する用途
 */
export interface Project {
  readonly id: number;
  /** 自動採番または手動入力 */
  project_id?: string;
  /** @maxLength 200 */
  name: string;
  status: number;
  readonly status_name: string;
  partners?: number[];
  readonly partners_names: readonly string[];
  /** @nullable */
  assigned_to?: number | null;
  /** @nullable */
  lead_source?: number | null;
  /** @nullable */
  readonly lead_source_name: string | null;
  /** @nullable */
  order_accuracy?: number | null;
  /** @nullable */
  readonly order_accuracy_name: string | null;
  notes?: string;
  /** @pattern ^-?\d{0,13}(?:\.\d{0,2})?$ */
  prospect_amount?: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly ordered_amount: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly invoiced_amount: string | null;
  readonly custom_properties: readonly ProjectCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 請求残高台帳のスナップショット（ボウクス個社帳票の繰越表示用）
 */
export interface InvoiceBillingSummary {
  /**
   * 前回御請求額(前回の今回御請求額)
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly previous_billing_amount: string;
  /**
   * 当月御入金額(前回確定時点からの累計消込額の増分)
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly payment_amount: string;
  /**
   * 繰越額(前回御請求額 − 当月御入金額)
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly carryover_amount: string;
}

/**
 * * `EXCLUSIVE` - 外税
 * * `INCLUSIVE` - 内税
 */
export type TaxCalculationTypeEnum = (typeof TaxCalculationTypeEnum)[keyof typeof TaxCalculationTypeEnum];

export const TaxCalculationTypeEnum = {
  EXCLUSIVE: 'EXCLUSIVE',
  INCLUSIVE: 'INCLUSIVE',
} as const;

/**
 * * `SAMA` - 様
 * * `ONCHU` - 御中
 */
export type HonorificTypeEnum = (typeof HonorificTypeEnum)[keyof typeof HonorificTypeEnum];

export const HonorificTypeEnum = {
  SAMA: 'SAMA',
  ONCHU: 'ONCHU',
} as const;

/**
 * 取引先シリアライザ（他ドメインの詳細画面等で使用する参照用の最小限の項目のみ）
 */
export interface PartnerThin {
  readonly id: number;
  /** @maxLength 100 */
  code: string;
  /** @maxLength 250 */
  partner_name: string;
  /** 得意先の場合はTrue */
  is_customer?: boolean;
  /** 仕入先の場合はTrue */
  is_supplier?: boolean;
  /** @nullable */
  readonly department_name: string | null;
  /** @nullable */
  readonly contact_person_position: string | null;
  /** @nullable */
  readonly contact_person: string | null;
  /**
   * @maxLength 8
   * @nullable
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  mobile_phone?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  fax?: string | null;
  email_to?: string | null;
  /**
   * カンマ区切りで複数のメールアドレスを保存
   * @nullable
   */
  email_cc?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  employee_size?: string | null;
  /**
   * 取引先の敬称を選択します
   *
   * * `SAMA` - 様
   * * `ONCHU` - 御中
   */
  honorific_type?: HonorificTypeEnum;
  readonly updated_at: string;
}

/**
 * 取引先のメイン担当者表示用シリアライザ
 */
export interface ContactPersonMinimal {
  readonly id: number;
  readonly name: string;
  /** @nullable */
  readonly name_kana: string | null;
  /** @nullable */
  readonly department_name: string | null;
  /** @nullable */
  readonly position: string | null;
  /** @nullable */
  readonly email: string | null;
  /** @nullable */
  readonly phone: string | null;
  /** @nullable */
  readonly notes: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 請求書の取引先情報用シリアライザー
 */
export interface InvoiceSupplierPartnerDetail {
  readonly id: number;
  /**
   * @maxLength 250
   * @nullable
   */
  name?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  contact_person?: string | null;
  /**
   * @maxLength 8
   * @nullable
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  mobile_phone?: string | null;
  readonly partner: PartnerThin | null;
  readonly partner_contact_person: ContactPersonMinimal | null;
}

/**
 * バリエーション値
 */
export interface VariationValue {
  readonly id: number;
  /** @maxLength 100 */
  value: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  value_id?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  sort_order?: number;
  variation_type_name: string;
  variation_type_sort_order: number;
}

/**
 * ランク別単価候補（価格グループごとのランク別単価）
 */
export interface ProductVariationRankPrice {
  price_group_id: number;
  price_group_code: string;
  price_group_name: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
}

/**
 * * `UNIT` - 通常単価
 * * `CUSTOMER` - 得意先別単価
 * * `COST` - 原価
 * * `SUPPLIER` - 仕入先別単価
 */
export type ReservedPriceTypeEnum = (typeof ReservedPriceTypeEnum)[keyof typeof ReservedPriceTypeEnum];

export const ReservedPriceTypeEnum = {
  UNIT: 'UNIT',
  CUSTOMER: 'CUSTOMER',
  COST: 'COST',
  SUPPLIER: 'SUPPLIER',
} as const;

/**
 * 予約単価候補（価格改定で予約された、マスタへ未反映の標準単価・取引先別単価・原価・仕入先別単価）
 */
export interface ProductVariationReservedPrice {
  price_revision_id: number;
  title: string;
  price_type: ReservedPriceTypeEnum;
  start_date: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
}

/**
 * 数量別単価
 */
export interface ProductVariationQuantityPrice {
  readonly id: number;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  min_quantity: number;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  max_quantity?: number | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
  readonly updated_at: string;
}

/**
 * BOWCS数量計算マスタ(単位・係数)
 *
 * 係数はDecimalだが、保存時に文字列へ正規化されているため文字列で返す。
 */
export interface BowcsCalc {
  /** 単位 */
  unit: string;
  /** 係数 */
  coefficient: string;
}

/**
 * 設計価格マスタ(設計価格・設計価格単位)
 *
 * 設計価格はDecimalだが、保存時に文字列へ正規化されているため文字列で返す。
 */
export interface DesignPrice {
  /** 設計価格 */
  price: string;
  /** 設計価格単位 */
  unit: string;
}

/**
 * 商品バリエーションの機能拡張データ
 *
 * 機能フラグが有効なキーのみが含まれる。
 */
export interface ProductVariationFeatures {
  /** BOWCS数量計算マスタ */
  bowcs_calc?: BowcsCalc | null;
  /** 設計価格マスタ */
  design_price?: DesignPrice | null;
}

/**
 * 商品バリエーション
 */
export interface ProductVariation {
  readonly id: number;
  /** @nullable */
  unit?: number | null;
  /** @nullable */
  readonly unit_name: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  cost_price: string;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  manufacturer?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp: string;
  /** @nullable */
  packaging_type_id?: number | null;
  /** @nullable */
  readonly packaging_type_name: string | null;
  variation_values: VariationValue[];
  readonly variation_name: string;
  /** @nullable */
  readonly customer_price_id: number | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly customer_price: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly rank_price: string | null;
  readonly rank_prices: readonly ProductVariationRankPrice[];
  readonly reserved_prices: readonly ProductVariationReservedPrice[];
  /** @nullable */
  readonly customer_model_number: string | null;
  readonly quantity_prices: readonly ProductVariationQuantityPrice[];
  tax_class?: TaxClassEnum;
  readonly lot_management_type: LotManagementTypeEnum;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  msrp?: string | null;
  /** MSRPがオープン価格の場合はTrue */
  is_open_price?: boolean;
  /** @nullable */
  readonly external_id: string | null;
  /** @nullable */
  readonly external_url: string | null;
  readonly features: ProductVariationFeatures;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 数量単位マスタ
 *
 * 項目が多くないのでList,Detail共通のものを使用する
 */
export interface QuantityUnitMaster {
  readonly id: number;
  /** @maxLength 50 */
  name: string;
}

/**
 * 請求明細の元受注に紐づくカスタム項目（帳票の備考欄表示用）
 */
export interface InvoiceItemSalesOrderCustomProperty {
  /** カスタム項目のラベル */
  readonly label: string;
  /** 表示用に整形済みの値 */
  readonly value: string;
  /**
   * フィールドタイプ
   *
   * * `FREE_TEXT` - テキスト
   * * `SELECT` - セレクト
   * * `MULTI_SELECT` - マルチセレクト
   * * `URL` - URL
   * * `NUMBER` - 数値
   * * `MEMBER` - メンバー
   * * `DATETIME` - 日時
   * * `MULTI_LINE_TEXT` - 複数行テキスト
   * * `BOOLEAN` - ブール値
   * * `ADDRESS` - 住所
   * * `WEBHOOK` - Webhook通知
   */
  readonly field_type: FieldTypeEnum;
}

/**
 * 請求明細用シリアライザー
 */
export interface InvoiceItem {
  /** @nullable */
  id?: number | null;
  readonly product_variation: ProductVariation;
  /** @nullable */
  readonly product_id: number | null;
  /** @maxLength 500 */
  name: string;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity?: string;
  readonly unit: QuantityUnitMaster;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_cost_price?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp?: string;
  /** @nullable */
  packaging_type_id?: number | null;
  /** @nullable */
  readonly packaging_type_name: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly msrp: string | null;
  readonly is_open_price: boolean;
  tax_class?: TaxClassEnum;
  /**
   * @maxLength 250
   * @nullable
   */
  summary?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  header?: string | null;
  /**
   * 明細の商品を納品した日。帳票の明細行に表示する
   * @nullable
   */
  delivery_date?: string | null;
  /**
   * 明細の表示順序。nullの場合はIDでソート
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  sort_order?: number | null;
  /**
   * 元出荷ID（伝票単位の税計算グループキーとして使用）
   * @nullable
   */
  readonly source_shipment_id: number | null;
  /**
   * 元受注明細が属する受注書ID＝受注No.（ボウクス個社帳票の伝票No.列に使用）
   * @nullable
   */
  readonly source_sales_order_id: number | null;
  /**
   * 元受注明細に紐づく出荷の出荷日（ボウクス個社帳票の年月日列に使用）
   * @nullable
   */
  readonly source_shipped_date: string | null;
  /** 元受注のカスタム項目（帳票表示ONかつ値ありのもののみ、property_type順）。ボウクス個社請求書の備考列に使用。元受注明細の紐付きが無い明細は空配列 */
  readonly sales_order_custom_properties: readonly InvoiceItemSalesOrderCustomProperty[];
  /**
   * 元受注に紐づく案件ID（ボウクス工事請求書で案件ごとに明細を集約するのに使用）
   * @nullable
   */
  readonly source_project_id: number | null;
  /**
   * 元受注に紐づく案件名（ボウクス工事請求書の集約行の品名に使用）
   * @nullable
   */
  readonly source_project_name: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly tax_correction: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 請求書送料項目のシリアライザー
 */
export interface InvoiceShippingItem {
  readonly id: number;
  /** @maxLength 255 */
  name: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  amount: string;
  tax_class?: TaxClassEnum;
}

/**
 * 請求書詳細用シリアライザー
 */
export interface InvoiceDetail {
  readonly id: number;
  readonly project: Project;
  readonly bank_account: BankAccount | null;
  readonly payment_method: PaymentMethod | null;
  /** @maxLength 100 */
  invoice_number: string;
  /** @maxLength 100 */
  title?: string;
  status?: InvoiceStatusEnum;
  /** @nullable */
  responsible_person?: number | null;
  readonly responsible_department: number;
  issue_date?: string;
  /** @nullable */
  due_date?: string | null;
  /**
   * 締め→請求書連携がある場合の締め期間終了日(締切日)。連携が無ければnull
   * @nullable
   */
  readonly closing_date: string | null;
  /** 請求残高台帳のスナップショット。締め→請求書連携が無ければnull */
  readonly billing_summary: InvoiceBillingSummary | null;
  /**
   * 消込ステータス
   *
   * * `UNALLOCATED` - 未消込
   * * `PARTIALLY_ALLOCATED` - 一部消込
   * * `ALL_ALLOCATED` - 消込済
   */
  readonly allocation_status: AllocationStatusEnum;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  subtotal?: string;
  tax_breakdown?: unknown;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  total_amount?: string;
  tax_calculation_type?: TaxCalculationTypeEnum;
  /**
   * 請求に紐づく最新の入金ID（入金がない場合はnull）
   * @nullable
   */
  readonly latest_incoming_payment_id: number | null;
  notes?: string;
  internal_notes?: string;
  payment_terms?: string;
  readonly supplier_partner_customer: InvoiceSupplierPartnerDetail;
  readonly supplier_partner_bill_to: InvoiceSupplierPartnerDetail;
  readonly items: readonly InvoiceItem[];
  readonly shipping_items: readonly InvoiceShippingItem[];
  readonly tags: readonly InvoiceTag[];
  /** @nullable */
  document_template?: number | null;
  /** 紐づく受注書のID一覧(新しい順) */
  readonly related_sales_orders: readonly number[];
  readonly custom_properties: readonly InvoiceCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 請求書の取引先情報用シリアライザー(更新用)
 */
export interface InvoiceSupplierPartnerDetailUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 250
   * @nullable
   */
  name?: string | null;
  /**
   * @minLength 1
   * @maxLength 100
   * @nullable
   */
  contact_person?: string | null;
  /**
   * @minLength 1
   * @maxLength 8
   * @nullable
   */
  postal_code?: string | null;
  /**
   * @minLength 1
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @minLength 1
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @minLength 1
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * @minLength 1
   * @maxLength 22
   * @nullable
   */
  phone2?: string | null;
  /**
   * @minLength 1
   * @maxLength 22
   * @nullable
   */
  mobile_phone?: string | null;
  /** @nullable */
  partner_id?: number | null;
  /** @nullable */
  partner_contact_person_id?: number | null;
}

/**
 * 請求明細用シリアライザー
 */
export interface InvoiceItemRequest {
  /** @nullable */
  id?: number | null;
  /** @nullable */
  product_variation_id?: number | null;
  /**
   * @minLength 1
   * @maxLength 500
   */
  name: string;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity?: string;
  /** @nullable */
  unit_id?: number | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_cost_price?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp?: string;
  /** @nullable */
  packaging_type_id?: number | null;
  tax_class?: TaxClassEnum;
  /**
   * @maxLength 250
   * @nullable
   */
  summary?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  header?: string | null;
  /**
   * 明細の商品を納品した日。帳票の明細行に表示する
   * @nullable
   */
  delivery_date?: string | null;
  /**
   * 明細の表示順序。nullの場合はIDでソート
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  sort_order?: number | null;
}

/**
 * 請求書カスタムプロパティ値更新用シリアライザ
 */
export interface InvoiceCustomPropertyUpdateRequest {
  custom_property_id: number;
  /** @nullable */
  value: string | null;
}

/**
 * 請求書更新用シリアライザー
 *
 * ステータスは扱わない。発行時には繰越サマリーの確定など付随処理が必要なため、
 * 遷移はステータス更新API(update-status)に一本化する。
 */
export interface InvoiceUpdateRequest {
  /** @nullable */
  project_id?: number | null;
  /** @maxLength 100 */
  title?: string;
  /** @nullable */
  responsible_person?: number | null;
  /**
   * 振込先口座ID（オプション）
   * @nullable
   */
  bank_account_id?: number | null;
  /**
   * 決済方法ID（オプション）
   * @nullable
   */
  payment_method_id?: number | null;
  /** 関連する受注書IDのリスト */
  sales_order_ids?: number[];
  issue_date?: string;
  /** @nullable */
  due_date?: string | null;
  tax_calculation_type?: TaxCalculationTypeEnum;
  notes?: string;
  internal_notes?: string;
  payment_terms?: string;
  supplier_partner_customer?: InvoiceSupplierPartnerDetailUpdateRequest | null;
  supplier_partner_bill_to?: InvoiceSupplierPartnerDetailUpdateRequest | null;
  items?: InvoiceItemRequest[];
  /** カスタムプロパティ値の更新データ */
  custom_properties?: InvoiceCustomPropertyUpdateRequest[];
  /**
   * 部門ID
   * @nullable
   */
  responsible_department_id?: number | null;
  /** タグIDのリスト */
  tag_ids?: number[];
}

/**
 * * `PROCESSING` - 処理中
 * * `COMPLETED` - 処理完了
 */
export type FaxSendStatus = (typeof FaxSendStatus)[keyof typeof FaxSendStatus];

export const FaxSendStatus = {
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
} as const;

/**
 * * `OK` - 送信OK
 * * `ERROR` - 送信エラー
 */
export type FaxSendResultType = (typeof FaxSendResultType)[keyof typeof FaxSendResultType];

export const FaxSendResultType = {
  OK: 'OK',
  ERROR: 'ERROR',
} as const;

/**
 * @nullable
 */
export type NullEnum = null;

/**
 * 請求書メール送信ログのシリアライザー
 */
export interface InvoiceEmailLog {
  readonly id: number;
  readonly invoice: number;
  readonly from_name: string;
  /** カンマ区切りで複数のメールアドレスを保存 */
  readonly to_emails: string;
  /**
   * カンマ区切りで複数のメールアドレスを保存
   * @nullable
   */
  readonly cc_emails: string | null;
  readonly send_status: FaxSendStatus;
  readonly send_result: FaxSendResultType | NullEnum;
  /** @nullable */
  readonly sent_at: string | null;
  readonly created_at: string;
}

export interface PaginatedInvoiceEmailLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: InvoiceEmailLog[];
}

/**
 * シンプルなメール送信用シリアライザー
 */
export interface EmailRequest {
  /**
   * 宛先メールアドレスのリスト
   * @items.minLength 1
   */
  to_emails: string[];
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  message: string;
  /** @minLength 1 */
  reply_to?: string;
  /**
   * CCメールアドレスのリスト
   * @items.minLength 1
   */
  cc_emails?: string[];
  /**
   * 差出人名
   * @minLength 1
   */
  from_name?: string;
}

/**
 * 請求書と振込先口座の紐付け用シリアライザー
 */
export interface InvoiceBankAccountLinkRequest {
  /** 紐付ける振込先口座ID */
  bank_account_id: number;
}

/**
 * 売上(出荷)から請求書への変換用シリアライザー
 */
export interface ShipmentToInvoiceRequest {
  /** 変換元の出荷(=売上)ID */
  shipment_id: number;
}

/**
 * 請求書消込（手数料対応）用シリアライザー
 *
 * 「請求から消込」画面でチェックした請求書を1件ずつ消し込むためのシリアライザー。
 * クイック入金の項目に加えて手数料（手数料率由来の控除額）と
 * 手数料2（振込手数料等の固定額の控除額）を受け取る。
 */
export interface InvoicePaymentWithFeeRequest {
  /** 入金日 */
  payment_date: string;
  /**
   * 入金金額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  amount: string;
  /** 決済方法ID */
  payment_method: number;
  /**
   * 振込先口座ID
   * @nullable
   */
  bank_account?: number | null;
  /**
   * 担当者ID（未指定時は担当者なし）
   * @nullable
   */
  responsible_person?: number | null;
  /**
   * 部門ID
   * @nullable
   */
  department?: number | null;
  /**
   * 摘要
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
  /**
   * 取引先ID
   * @nullable
   */
  partner?: number | null;
  /**
   * 手数料（手数料率から算出する控除額）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  fee?: string;
  /**
   * 手数料2（振込手数料等の固定額の控除額）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  fee2?: string;
}

/**
 * 請求書クイック入金レスポンス
 */
export interface InvoiceQuickPaymentResponse {
  /** 作成された入金ID */
  incoming_payment_id: number;
}

/**
 * 請求書クイック入金用シリアライザー
 */
export interface InvoiceQuickPaymentRequest {
  /** 入金日 */
  payment_date: string;
  /**
   * 入金金額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  amount: string;
  /** 決済方法ID */
  payment_method: number;
  /**
   * 振込先口座ID
   * @nullable
   */
  bank_account?: number | null;
  /**
   * 担当者ID（未指定時は担当者なし）
   * @nullable
   */
  responsible_person?: number | null;
  /**
   * 部門ID
   * @nullable
   */
  department?: number | null;
  /**
   * 摘要
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
  /**
   * 取引先ID
   * @nullable
   */
  partner?: number | null;
}

/**
 * 請求書テンプレート設定取得用
 */
export interface InvoiceTemplateSetting {
  template: DocumentTemplate | null;
}

/**
 * 請求書テンプレート設定更新用
 */
export interface InvoiceTemplateSettingUpdateRequest {
  /**
   * テンプレートID（nullで組織デフォルトにリセット）
   * @nullable
   */
  template: number | null;
}

/**
 * 請求書ステータス更新用シリアライザー
 */
export interface InvoiceStatusUpdateRequest {
  /**
   * 新しいステータス
   *
   * * `DRAFT` - 下書き
   * * `ISSUED` - 発行済
   */
  status: InvoiceStatusEnum;
}

/**
 * 複数の受注書から請求書を作成するシリアライザー
 */
export interface ConsolidatedInvoiceCreateRequest {
  /**
   * まとめて請求書を作成する受注書IDのリスト
   * @minItems 1
   */
  sales_order_ids: number[];
}

/**
 * 受注書から請求書への変換用シリアライザー
 */
export interface SalesOrderToInvoiceRequest {
  /** 変換元の受注書ID */
  sales_order_id: number;
  /**
   * 指定しない場合は自動採番
   * @minLength 1
   * @maxLength 100
   */
  invoice_number?: string;
  /** 指定しない場合は今日の日付 */
  issue_date?: string;
  /** 指定しない場合は請求日から30日後 */
  due_date?: string;
  /** 受注書の備考を上書きする場合に指定 */
  notes?: string;
  /** 受注書の社内メモを上書きする場合に指定 */
  internal_notes?: string;
}

/**
 * 複数の売上(出荷)から請求書への変換用シリアライザー
 */
export interface ShipmentsToInvoiceRequest {
  /**
   * 変換元の出荷(=売上)IDのリスト(最大100件)
   * @maxItems 100
   */
  shipment_ids: number[];
  /** 請求書に設定する案件のID */
  project_id: number;
}

/**
 * 請求書の入金状況サマリー
 *
 * 請求書IDを指定して入金状況だけをまとめて引くための軽量レスポンス。
 * 受注詳細のように「紐づく請求書ID」だけを持っている画面から、請求額・入金額・
 * 未入金額を1リクエストで解決する用途で使う。
 */
export interface InvoicePaymentSummary {
  readonly id: number;
  readonly invoice_number: string;
  readonly status: InvoiceStatusEnum;
  readonly issue_date: string;
  /** @nullable */
  readonly due_date: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly total_amount: string;
  /**
   * 消込済金額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly allocated_amount: string;
  /**
   * 未入金額
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly unallocated_amount: string;
  /**
   * 消込ステータス
   *
   * * `UNALLOCATED` - 未消込
   * * `PARTIALLY_ALLOCATED` - 一部消込
   * * `ALL_ALLOCATED` - 消込済
   */
  readonly allocation_status: AllocationStatusEnum;
  /**
   * 入金日が最新の入金ID（入金がない場合はnull）
   * @nullable
   */
  readonly latest_incoming_payment_id: number | null;
  /**
   * 最新の入金日（入金がない場合はnull）
   * @nullable
   */
  readonly latest_payment_date: string | null;
}

/**
 * 請求書合計金額レスポンス用シリアライザー
 */
export interface InvoiceSummary {
  /** 合計金額計算対象の請求書の件数 */
  readonly count: number;
  /**
   * 小計（税抜き金額）の合計
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly subtotal_sum: string;
  /**
   * 合計金額（税込み）の合計
   * @pattern ^-?\d{0,13}(?:\.\d{0,2})?$
   */
  readonly total_amount_sum: string;
}

/**
 * 住所→郵便番号変換のリクエスト。都道府県・住所1は必須、住所2は任意
 */
export interface AddressLookupRequestRequest {
  /** @minLength 1 */
  prefecture: string;
  /** @minLength 1 */
  address1: string;
  address2?: string;
}

/**
 * 住所→郵便番号変換のレスポンス。該当なしは found=False のみ返す
 */
export interface AddressLookupResponse {
  found: boolean;
  postal_code?: string;
}

/**
 * 郵便番号→住所変換のレスポンス。該当なしは found=False のみ返す
 */
export interface ZipcodeLookupResponse {
  found: boolean;
  prefecture?: string;
  address1?: string;
  address2?: string;
}

export interface Location {
  readonly id: number;
  /** @maxLength 250 */
  name: string;
  /**
   * @maxLength 8
   * @nullable
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /** デフォルトの本社データはFalseに設定される */
  readonly can_delete: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedLocationList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: Location[];
}

export interface LocationRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
  /**
   * @maxLength 8
   * @nullable
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
}

/**
 * 生産発注カスタムプロパティ定義用シリアライザ（作成・読み取り用）
 */
export interface ManufacturingOrderCustomProperty {
  readonly id: number;
  /** @maxLength 100 */
  label: string;
  readonly property_type: number;
  field_type: OrderCustomPropertyFieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedManufacturingOrderCustomPropertyList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ManufacturingOrderCustomProperty[];
}

/**
 * 生産発注カスタムプロパティ定義用シリアライザ（作成・読み取り用）
 */
export interface ManufacturingOrderCustomPropertyRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  label: string;
  field_type: OrderCustomPropertyFieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
}

/**
 * 生産発注カスタムプロパティ定義更新用シリアライザ（field_type は変更不可）
 */
export interface ManufacturingOrderCustomPropertyDefinitionUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  label: string;
  datas?: unknown;
  is_active?: boolean;
}

/**
 * * `DRAFT` - 下書き
 * * `IN_PROGRESS` - 生産中
 * * `COMPLETED` - 完了
 */
export type ManufacturingOrderStatusEnum =
  (typeof ManufacturingOrderStatusEnum)[keyof typeof ManufacturingOrderStatusEnum];

export const ManufacturingOrderStatusEnum = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

/**
 * * `NO_STOCK` - No Stock
 * * `IN_STOCK_PREPARATION` - In Stock Preparation
 * * `IN_STOCK` - In Stock
 */
export type SalesOrderStockStatusEnum =
  (typeof SalesOrderStockStatusEnum)[keyof typeof SalesOrderStockStatusEnum];

export const SalesOrderStockStatusEnum = {
  NO_STOCK: 'NO_STOCK',
  IN_STOCK_PREPARATION: 'IN_STOCK_PREPARATION',
  IN_STOCK: 'IN_STOCK',
} as const;

/**
 * 生産対象バリエーションの軽量参照
 */
export interface ManufacturingOrderTargetVariation {
  id: number;
  variation_name: string;
  /** @nullable */
  product_code: string | null;
  product_id: number;
  product_name: string;
  readonly lot_management_type: LotManagementTypeEnum;
}

/**
 * 生産発注一覧用
 */
export interface ManufacturingOrderList {
  readonly id: number;
  readonly uid: string;
  readonly manufacturing_number: string;
  readonly target_variation: ManufacturingOrderTargetVariation;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
  readonly location: Location;
  status: ManufacturingOrderStatusEnum;
  stock_status: SalesOrderStockStatusEnum;
  /** @nullable */
  readonly stock_ready_date: string | null;
  readonly expected_completion_date: string;
  /** @nullable */
  readonly production_completed_at: string | null;
  readonly notes: string;
  /** @nullable */
  readonly linked_sales_order_item_id: number | null;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedManufacturingOrderListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ManufacturingOrderList[];
}

/**
 * 生産発注 新規作成用
 */
export interface ManufacturingOrderCreateRequest {
  target_variation_id: number;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity: string;
  location_id: number;
  expected_completion_date: string;
  notes?: string;
  internal_notes?: string;
  /**
   * 紐付ける受注明細ID（在庫を優先割当する場合に指定）
   * @nullable
   */
  linked_sales_order_item_id?: number | null;
}

/**
 * 完成品ロット(詳細用)
 */
export interface ManufacturingOrderLot {
  readonly id: number;
  readonly lot_number: string;
  /** @nullable */
  readonly expiration_date: string | null;
}

/**
 * 受注書一覧取得APIおよび詳細取得APIの取引先情報
 */
export interface SalesOrderSupplierPartnerDetail {
  readonly id: number;
  /**
   * @maxLength 250
   * @nullable
   */
  name?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  contact_person?: string | null;
  /**
   * @maxLength 8
   * @nullable
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  mobile_phone?: string | null;
  partner?: PartnerThin | null;
  readonly partner_contact_person: ContactPersonMinimal | null;
}

/**
 * 生産発注に紐付く受注明細のサマリー情報
 */
export interface LinkedSalesOrderItemSummary {
  /** 受注明細ID */
  id: number;
  /** 受注ID */
  sales_order_id: number;
  /**
   * 納入期日
   * @nullable
   */
  delivery_date: string | null;
  /** 受注書の得意先情報（取引先マスタ参照を含む） */
  customer: SalesOrderSupplierPartnerDetail | null;
}

/**
 * 構成部品バリエーションの軽量参照
 */
export interface ManufacturingOrderComponentVariation {
  id: number;
  variation_name: string;
  /** @nullable */
  product_code: string | null;
  product_id: number;
  product_name: string;
  readonly lot_management_type: LotManagementTypeEnum;
}

/**
 * 生産発注明細(構成部品)の消費ロット(詳細用)。番号・期限はロットの値
 */
export interface ManufacturingOrderItemLot {
  readonly id: number;
  readonly lot: number;
  readonly lot_number: string;
  /** @nullable */
  readonly expiration_date: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
  readonly is_auto_generated: boolean;
}

/**
 * 生産発注明細(詳細用)
 */
export interface ManufacturingOrderItem {
  readonly id: number;
  readonly component_variation: ManufacturingOrderComponentVariation;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly component_quantity: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly required_quantity: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly cost_price: string;
  /** @nullable */
  readonly unit_name: string | null;
  /** @nullable */
  readonly model_number: string | null;
  stock_status: StockStatusEnum;
  /** @nullable */
  readonly stock_ready_date: string | null;
  readonly sort_order: number;
  /** 構成部品の消費ロット。完了前は指定(未指定の分は完了時に自動割当)、完了後は消費実績 */
  readonly lots: readonly ManufacturingOrderItemLot[];
  /**
   * 完了前のロット管理対象の構成部品の、所要量のうちロットを指定していない数量。他は 0
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly unallocated_lot_quantity: string;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 生産発注カスタムプロパティ値用シリアライザ（読み取り）
 */
export interface ManufacturingOrderCustomPropertyValue {
  readonly id: number;
  manufacturing_order: number;
  custom_property: number;
  readonly custom_property_detail: ManufacturingOrderCustomProperty;
  readonly member_detail: User | null;
  /** @nullable */
  value?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 生産発注 詳細用
 */
export interface ManufacturingOrderDetail {
  readonly id: number;
  readonly uid: string;
  readonly manufacturing_number: string;
  readonly target_variation: ManufacturingOrderTargetVariation;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
  readonly location: Location;
  status: ManufacturingOrderStatusEnum;
  stock_status: SalesOrderStockStatusEnum;
  /** @nullable */
  readonly stock_ready_date: string | null;
  readonly expected_completion_date: string;
  /** @nullable */
  readonly production_completed_at: string | null;
  /** 完成品ロット(ロット管理商品の完了後のみ) */
  readonly lot: ManufacturingOrderLot | null;
  readonly notes: string;
  readonly internal_notes: string;
  /** @nullable */
  readonly linked_sales_order_item_id: number | null;
  readonly linked_sales_order_item: LinkedSalesOrderItemSummary | null;
  readonly items: readonly ManufacturingOrderItem[];
  readonly custom_properties: readonly ManufacturingOrderCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 明細へのロット指定の入力(既存ロットの id と数量)。受注明細の割当・生産発注明細の消費ロットで使う
 */
export interface LotQuantityInputRequest {
  /** 既存ロットのID */
  lot_id: number;
  /**
   * 数量
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  quantity: string;
}

/**
 * 生産発注明細 更新用(構成数・原価は下書きのみ、ロットは完了前)
 */
export interface ManufacturingOrderItemUpdateRequest {
  /** 更新対象の生産発注明細ID */
  id: number;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  component_quantity?: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  cost_price?: string;
  /** 構成部品の消費ロット(ロット管理対象の構成部品のみ・完了前のみ)。キー無し=現状維持、指定あり=置き換え、空=指定なし(完了時に自動割当)。合計は所要量以下(不足分は完了時に自動割当で補う) */
  lots?: LotQuantityInputRequest[];
}

/**
 * 生産発注カスタムプロパティ値更新用シリアライザ
 */
export interface ManufacturingOrderCustomPropertyUpdateRequest {
  custom_property_id: number;
  /** @nullable */
  value: string | null;
}

/**
 * 生産発注 更新用
 */
export interface PatchedManufacturingOrderUpdateRequest {
  target_variation_id?: number;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity?: string;
  location_id?: number;
  expected_completion_date?: string;
  production_completed_at?: string;
  notes?: string;
  internal_notes?: string;
  /**
   * 紐付ける受注明細ID（明示的に null を渡すと紐付け解除）
   * @nullable
   */
  linked_sales_order_item_id?: number | null;
  /** 構成部品明細の構成数・原価の更新（下書きの間のみ指定可能） */
  items?: ManufacturingOrderItemUpdateRequest[];
  /** カスタムプロパティ値の更新データ */
  custom_properties?: ManufacturingOrderCustomPropertyUpdateRequest[];
}

/**
 * 完成品ロットの見込み
 */
export interface ManufacturingOrderFinishedLotPreview {
  /** 完了時に使われる番号(未指定なら既定の番号) */
  lot_number: string;
  /**
   * 完成品ロットの単位原価(Σ 構成部品原価 × 所要量 ÷ 生産数量)
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  unit_cost: string;
  /**
   * 同番号の既存ロットの ID(期限・倉庫別残高・入荷元は v2 のロット詳細で取る)。無ければ null
   * @nullable
   */
  existing_lot_id: number | null;
  /** 同番号の既存ロットと単位原価が異なり、その番号では完了できない */
  unit_cost_conflict: boolean;
  /**
   * 単位原価が異なるときの別番号の候補(同原価の枝番か未使用の枝番)
   * @nullable
   */
  alternative_lot_number: string | null;
}

/**
 * 生産発注 ステータス遷移用
 */
export interface PatchedManufacturingOrderStatusTransitionRequest {
  status?: ManufacturingOrderStatusEnum;
  production_completed_at?: string;
  /**
   * 完了時の完成品ロット番号(生産対象がロット管理商品のとき)。未指定・空は完了日(YYYYMMDD)
   * @maxLength 100
   */
  lot_number?: string;
  /**
   * 完成品ロットの有効期限(新規ロットのとき)
   * @nullable
   */
  lot_expiration_date?: string | null;
  /** 完成品ロットの備考(新規ロットのとき) */
  lot_note?: string;
}

/**
 * * `ROUND_DOWN` - ROUND_DOWN
 * * `ROUND_UP` - ROUND_UP
 * * `ROUND_HALF_UP` - ROUND_HALF_UP
 */
export type RoundingModeEnum = (typeof RoundingModeEnum)[keyof typeof RoundingModeEnum];

export const RoundingModeEnum = {
  ROUND_DOWN: 'ROUND_DOWN',
  ROUND_UP: 'ROUND_UP',
  ROUND_HALF_UP: 'ROUND_HALF_UP',
} as const;

/**
 * * `ITEM` - 明細単位
 * * `SLIP` - 伝票単位
 * * `BILLING` - 請求単位
 */
export type TaxCalculationUnitEnum = (typeof TaxCalculationUnitEnum)[keyof typeof TaxCalculationUnitEnum];

export const TaxCalculationUnitEnum = {
  ITEM: 'ITEM',
  SLIP: 'SLIP',
  BILLING: 'BILLING',
} as const;

/**
 * 一括更新用の個別設定シリアライザー
 */
export interface AmountCalculationSettingUpdateItemRequest {
  amount_rounding_mode: RoundingModeEnum;
  tax_rounding_mode: RoundingModeEnum;
  tax_calculation_unit: TaxCalculationUnitEnum;
}

/**
 * 金額計算設定の一括更新用シリアライザー（CUSTOMER/SUPPLIER をまとめて更新）
 */
export interface AmountCalculationSettingBulkUpdateRequest {
  customer?: AmountCalculationSettingUpdateItemRequest;
  supplier?: AmountCalculationSettingUpdateItemRequest;
}

/**
 * * `CUSTOMER` - 得意先
 * * `SUPPLIER` - 仕入先
 */
export type SettingTypeEnum = (typeof SettingTypeEnum)[keyof typeof SettingTypeEnum];

export const SettingTypeEnum = {
  CUSTOMER: 'CUSTOMER',
  SUPPLIER: 'SUPPLIER',
} as const;

/**
 * 金額計算設定のシリアライザー
 */
export interface AmountCalculationSetting {
  readonly setting_type: SettingTypeEnum;
  amount_rounding_mode: RoundingModeEnum;
  tax_rounding_mode: RoundingModeEnum;
  tax_calculation_unit?: TaxCalculationUnitEnum;
}

export type DepartmentChildrenItem = { [key: string]: unknown };

/**
 * 部署のシリアライザー
 */
export interface Department {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  code?: string | null;
  /** @nullable */
  parent?: number | null;
  /** @nullable */
  readonly parent_name: string | null;
  /** 子部署の取得 */
  readonly children: readonly DepartmentChildrenItem[];
  readonly default_shipping_location: Location | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  fax?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedDepartmentList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: Department[];
}

/**
 * 部署のシリアライザー
 */
export interface DepartmentRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  code?: string | null;
  /** @nullable */
  parent?: number | null;
  /** @nullable */
  default_shipping_location_id?: number | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  fax?: string | null;
}

/**
 * EDI通知先のシリアライザ
 */
export interface EdiNotificationRecipient {
  readonly id: number;
  /** @maxLength 254 */
  email: string;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * EDI通知先のシリアライザ
 */
export interface EdiNotificationRecipientRequest {
  /**
   * @minLength 1
   * @maxLength 254
   */
  email: string;
}

/**
 * * `1` - 1番目
 * * `2` - 2番目
 */
export type HeaderMenuPositionEnum = (typeof HeaderMenuPositionEnum)[keyof typeof HeaderMenuPositionEnum];

export const HeaderMenuPositionEnum = {
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;

/**
 * * `SOLID` - 塗り
 * * `OUTLINE` - 線
 */
export type HeaderMenuIconVariantEnum =
  (typeof HeaderMenuIconVariantEnum)[keyof typeof HeaderMenuIconVariantEnum];

export const HeaderMenuIconVariantEnum = {
  SOLID: 'SOLID',
  OUTLINE: 'OUTLINE',
} as const;

/**
 * ヘッダーメニューのシリアライザー
 */
export interface HeaderMenu {
  readonly position: HeaderMenuPositionEnum;
  readonly icon_variant: HeaderMenuIconVariantEnum;
  readonly icon_name: string;
  readonly label: string;
  readonly url: string;
}

/**
 * ヘッダーメニュー1件分の入力シリアライザー
 */
export interface HeaderMenuInputRequest {
  icon_variant: HeaderMenuIconVariantEnum;
  /**
   * @minLength 1
   * @maxLength 50
   */
  icon_name: string;
  /**
   * @minLength 1
   * @maxLength 4
   */
  label: string;
  /**
   * http(s):// から始まる外部URL、または / から始まる社内パス
   * @minLength 1
   * @maxLength 2000
   */
  url: string;
}

/**
 * ヘッダーメニューの一括置き換え用シリアライザー(並び順がそのまま表示位置になる)
 */
export interface HeaderMenuBulkUpdateRequest {
  menus: HeaderMenuInputRequest[];
}

/**
 * 組織メンバー情報のレスポンス用シリアライザー
 */
export interface OrganizationMember {
  id: number;
  name: string;
  email: string;
  role?: UserRoleEnum;
  readonly is_active: boolean;
  /** @nullable */
  readonly department_id: number | null;
  /** @nullable */
  readonly department_name: string | null;
  /** @nullable */
  readonly phone: string | null;
  readonly mfa_enabled: boolean;
}

/**
 * 組織メンバー編集用シリアライザー（名前・部署・電話番号のみ編集可能）
 */
export interface PatchedOrganizationMemberEditRequest {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  /** @nullable */
  department_id?: number | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
}

/**
 * 招待中のメンバー情報のシリアライザー
 */
export interface PendingInvitation {
  readonly id: number;
  /**
   * 招待を送信するメールアドレス
   * @maxLength 254
   */
  invited_email: string;
  /**
   * 招待時に付与する役割
   *
   * * `ADMIN` - 管理者
   * * `MEMBER` - メンバー
   */
  invited_role?: UserRoleEnum;
}

/**
 * * `CRM` - CRM
 * * `RESEARCHER_JP` - 日本の研究.com
 * * `EDI` - EDI
 * * `MANUAL_ITEM_INPUT` - 手入力明細
 * * `BOWCS_CALC` - ボウクス数量計算
 * * `BOWCS_CONSTRUCTION` - ボウクス工事機能
 * * `SMBC_BILLING` - 三井住友請求
 * * `AUTO_INVOICE_ON_SHIPMENT` - 出荷時請求書自動作成
 * * `AUDIT_LOG` - 監査ログ
 * * `EXTENSION_METADATA` - 拡張メタデータ
 */
export type FeatureTypeEnum = (typeof FeatureTypeEnum)[keyof typeof FeatureTypeEnum];

export const FeatureTypeEnum = {
  CRM: 'CRM',
  RESEARCHER_JP: 'RESEARCHER_JP',
  EDI: 'EDI',
  MANUAL_ITEM_INPUT: 'MANUAL_ITEM_INPUT',
  BOWCS_CALC: 'BOWCS_CALC',
  BOWCS_CONSTRUCTION: 'BOWCS_CONSTRUCTION',
  SMBC_BILLING: 'SMBC_BILLING',
  AUTO_INVOICE_ON_SHIPMENT: 'AUTO_INVOICE_ON_SHIPMENT',
  AUDIT_LOG: 'AUDIT_LOG',
  EXTENSION_METADATA: 'EXTENSION_METADATA',
} as const;

/**
 * 機能フラグのシリアライザー
 */
export interface FeatureFlag {
  readonly feature_type: FeatureTypeEnum;
  readonly is_enabled: boolean;
}

/**
 * * `PROJECTS` - 案件
 * * `ORDERS` - 受注
 * * `PURCHASE_ORDERS` - 発注
 * * `INVENTORY` - 在庫
 * * `MANUFACTURING` - 生産
 * * `PRODUCTS` - 商品
 * * `CUSTOMERS` - 取引先
 * * `EXPLORE` - 探索
 */
export type MenuTypeEnum = (typeof MenuTypeEnum)[keyof typeof MenuTypeEnum];

export const MenuTypeEnum = {
  PROJECTS: 'PROJECTS',
  ORDERS: 'ORDERS',
  PURCHASE_ORDERS: 'PURCHASE_ORDERS',
  INVENTORY: 'INVENTORY',
  MANUFACTURING: 'MANUFACTURING',
  PRODUCTS: 'PRODUCTS',
  CUSTOMERS: 'CUSTOMERS',
  EXPLORE: 'EXPLORE',
} as const;

/**
 * メニュー表示制御のシリアライザー
 */
export interface MenuVisibilitySetting {
  readonly menu_type: MenuTypeEnum;
  readonly is_hidden: boolean;
}

/**
 * 組織情報のシリアライザ
 */
export interface Organization {
  readonly id: number;
  /** @maxLength 250 */
  name: string;
  corporate_number?: string | null;
  /** インボイス番号(T+13桁の数字) */
  invoice_number?: string | null;
  /**
   * @maxLength 8
   * @nullable
   * @pattern ^[0-9]{3}-[0-9]{4}$
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  fax?: string | null;
  reply_email?: string | null;
  /** @nullable */
  description?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  logo_url?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,4}(?:\.\d{0,1})?$
   */
  target_gross_margin?: string | null;
  /**
   * 1-12の整数
   * @minimum 1
   * @maximum 12
   */
  fiscal_month?: number;
  readonly feature_flags: readonly FeatureFlag[];
  readonly menu_visibility_settings: readonly MenuVisibilitySetting[];
  readonly inventory_settings: InventorySettings;
  readonly amount_calculation_settings: readonly AmountCalculationSetting[];
  readonly header_menus: readonly HeaderMenu[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 組織情報のシリアライザ
 */
export interface OrganizationRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
  corporate_number?: string | null;
  /** インボイス番号(T+13桁の数字) */
  invoice_number?: string | null;
  /**
   * @minLength 1
   * @maxLength 8
   * @nullable
   * @pattern ^[0-9]{3}-[0-9]{4}$
   */
  postal_code?: string | null;
  /**
   * @maxLength 10
   * @nullable
   */
  prefecture?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address1?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  address2?: string | null;
  /**
   * @minLength 1
   * @maxLength 22
   * @nullable
   */
  phone?: string | null;
  /**
   * @maxLength 22
   * @nullable
   */
  fax?: string | null;
  reply_email?: string | null;
  /** @nullable */
  description?: string | null;
  /**
   * @maxLength 200
   * @nullable
   */
  logo_url?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,4}(?:\.\d{0,1})?$
   */
  target_gross_margin?: string | null;
  /**
   * 1-12の整数
   * @minimum 1
   * @maximum 12
   */
  fiscal_month?: number;
}

/**
 * 帳票設定のシリアライザ
 */
export interface DocumentSetting {
  readonly id: number;
  enable_stamp_seal?: boolean;
  /**
   * 印影ファイルのダウンロード用pre-signed URL
   * @nullable
   */
  stamp_seal_image_url?: string | null;
  /**
   * ロゴファイルのダウンロード用pre-signed URL
   * @nullable
   */
  logo_image_url?: string | null;
}

/**
 * 帳票設定 印影ファイルアップロードリクエスト用
 */
export interface DocumentSettingStampSealUploadUrlRequest {
  /**
   * ファイルタイプ. ex.) 'image/png'
   * @minLength 1
   * @maxLength 50
   */
  content_type: string;
  /**
   * ファイルサイズ(バイト)。アップロードURLの署名に含め、この値と異なるサイズのPUTを拒否する
   * @minimum 1
   * @maximum 5242880
   */
  file_size: number;
}

/**
 * 帳票設定のシリアライザ
 */
export interface DocumentSettingRequest {
  enable_stamp_seal?: boolean;
  /**
   * 印影ファイルのダウンロード用pre-signed URL
   * @minLength 1
   * @nullable
   */
  stamp_seal_image_url?: string | null;
  /**
   * ロゴファイルのダウンロード用pre-signed URL
   * @minLength 1
   * @nullable
   */
  logo_image_url?: string | null;
}

/**
 * 出金インポートログシリアライザ
 */
export interface OutgoingPaymentImportLog {
  readonly id: number;
  readonly status: ImportLogStatusEnum;
  readonly is_success: boolean;
  readonly imported_count: number;
  readonly skipped_count: number;
  readonly row_count: number;
  readonly errors: unknown;
  /** @nullable */
  readonly filename: string | null;
  /** エラーCSVがダウンロード可能か（object_keyが存在するか） */
  readonly has_error_file: boolean;
  readonly created_at: string;
}

export interface PaginatedOutgoingPaymentImportLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: OutgoingPaymentImportLog[];
}

/**
 * 出金明細シリアライザー
 */
export interface OutgoingPaymentItem {
  readonly id: number;
  payment_type?: PaymentTypeEnum;
  /**
   * 符号付き（相殺・手数料などの控除はマイナス）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  amount: string;
  /** @nullable */
  account_title?: number | null;
  /** @nullable */
  readonly account_title_name: string | null;
  /** @nullable */
  bill_due_date?: string | null;
  /**
   * @maxLength 30
   * @nullable
   */
  bill_no?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
  /**
   * @minimum 0
   * @maximum 32767
   */
  sort_order: number;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 出金一覧用シリアライザー
 */
export interface OutgoingPaymentList {
  readonly id: number;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  payment_no: number;
  payment_date: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  amount?: string;
  /** @nullable */
  readonly partner_code: string | null;
  /** @nullable */
  readonly partner_name: string | null;
  readonly payment_method_name: string;
  /**
   * 担当者名
   * @nullable
   */
  readonly responsible_person_name: string | null;
  notes?: string;
  readonly items: readonly OutgoingPaymentItem[];
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedOutgoingPaymentListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: OutgoingPaymentList[];
}

/**
 * 出金詳細用シリアライザー
 */
export interface OutgoingPaymentDetail {
  readonly id: number;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  payment_no: number;
  payment_date: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  amount?: string;
  /** @nullable */
  partner?: number | null;
  /** @nullable */
  readonly partner_name: string | null;
  /** @nullable */
  readonly partner_code: string | null;
  readonly payment_method: PaymentMethod;
  readonly bank_account: BankAccount | null;
  readonly account_title: AccountTitleMaster | null;
  readonly responsible_person: User;
  /** @nullable */
  department?: number | null;
  /** @nullable */
  readonly department_name: string | null;
  notes?: string;
  readonly items: readonly OutgoingPaymentItem[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 出金明細更新用シリアライザー
 */
export interface OutgoingPaymentItemUpdateRequest {
  /** 既存明細ID（更新時のみ） */
  id?: number;
  /**
   * 出金区分
   *
   * * `cash` - 現金
   * * `transfer` - 振込
   * * `fee` - 手数料
   * * `check` - 小切手
   * * `bill` - 手形
   * * `offset` - 相殺
   * * `electronic` - 電債
   * * `other` - その他
   */
  payment_type: PaymentTypeEnum;
  /**
   * 金額（符号付き）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  amount: string;
  /**
   * 勘定科目ID
   * @nullable
   */
  account_title?: number | null;
  /**
   * 手形期日
   * @nullable
   */
  bill_due_date?: string | null;
  /**
   * 手形No
   * @maxLength 30
   * @nullable
   */
  bill_no?: string | null;
  /**
   * 行摘要
   * @maxLength 255
   * @nullable
   */
  summary?: string | null;
}

/**
 * 出金更新用シリアライザー
 */
export interface OutgoingPaymentUpdateRequest {
  payment_date: string;
  /** 出金明細リスト */
  items: OutgoingPaymentItemUpdateRequest[];
  responsible_person: number;
  /** @nullable */
  department?: number | null;
  /** @nullable */
  partner?: number | null;
  payment_method: number;
  /** @nullable */
  bank_account?: number | null;
  notes?: string;
}

/**
 * CSVカラムとデータ項目のマッピング
 */
export type OutgoingPaymentBulkImportRequestMapping = { [key: string]: number };

/**
 * 出金一括登録用シリアライザ
 */
export interface OutgoingPaymentBulkImportRequest {
  /**
   * アップロードされたCSVファイルのオブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: OutgoingPaymentBulkImportRequestMapping;
  /** アップロードファイル名 */
  filename?: string;
}

/**
 * 出金一括登録レスポンス用シリアライザ
 */
export interface OutgoingPaymentBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** インポートログID */
  import_log_id?: number;
  /** 新規登録された件数 */
  imported_count?: number;
  /** スキップされた件数 */
  skipped_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

export interface PaginatedPaymentMethodList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: PaymentMethod[];
}

/**
 * 決済方法のシリアライザー
 */
export interface PaymentMethodRequest {
  /**
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  is_default?: boolean;
}

/**
 * 商品ランク別価格設定
 */
export interface ProductPartnerPriceGroup {
  readonly id: number;
  product: number;
  price_group: number;
  readonly price_group_code: string;
  readonly price_group_name: string;
  /**
   * 基本単価に対する掛け率（例: 80.00 = 80%）
   * @pattern ^-?\d{0,3}(?:\.\d{0,2})?$
   */
  discount_rate: string;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedProductPartnerPriceGroupList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductPartnerPriceGroup[];
}

/**
 * 商品ランク別価格設定の一括更新用アイテム
 */
export interface ProductPartnerPriceGroupBulkItemRequest {
  /** @nullable */
  id?: number | null;
  price_group: number;
  /** @pattern ^-?\d{0,3}(?:\.\d{0,2})?$ */
  discount_rate: string;
}

/**
 * 商品ランク別価格設定の一括更新用
 */
export interface ProductPartnerPriceGroupBulkUpdateRequest {
  price_groups: ProductPartnerPriceGroupBulkItemRequest[];
}

/**
 * * `CREATED` - 設定
 * * `UPDATED` - 変更
 * * `DELETED` - 解除
 */
export type PriceChangeTypeEnum = (typeof PriceChangeTypeEnum)[keyof typeof PriceChangeTypeEnum];

export const PriceChangeTypeEnum = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  DELETED: 'DELETED',
} as const;

/**
 * * `UNIT` - 通常単価
 * * `QUANTITY` - 数量別単価
 * * `CUSTOMER` - 得意先別単価
 * * `RANK` - ランク別単価
 * * `COST` - 原価
 * * `SUPPLIER` - 仕入先別単価
 */
export type PriceChangeTargetTypeEnum =
  (typeof PriceChangeTargetTypeEnum)[keyof typeof PriceChangeTargetTypeEnum];

export const PriceChangeTargetTypeEnum = {
  UNIT: 'UNIT',
  QUANTITY: 'QUANTITY',
  CUSTOMER: 'CUSTOMER',
  RANK: 'RANK',
  COST: 'COST',
  SUPPLIER: 'SUPPLIER',
} as const;

/**
 * * `AMOUNT` - 金額
 * * `RATE` - 掛け率
 */
export type PriceValueTypeEnum = (typeof PriceValueTypeEnum)[keyof typeof PriceValueTypeEnum];

export const PriceValueTypeEnum = {
  AMOUNT: 'AMOUNT',
  RATE: 'RATE',
} as const;

export type BlankEnum = (typeof BlankEnum)[keyof typeof BlankEnum];

export const BlankEnum = {
  '': '',
} as const;

/**
 * * `UI` - 画面操作
 * * `CSV_IMPORT` - CSVインポート
 * * `EXTERNAL_API` - 外部API
 * * `EXTERNAL_INTEGRATION` - 外部サービス連携
 * * `PRICE_REVISION` - 価格改定
 */
export type PriceChangeSourceEnum = (typeof PriceChangeSourceEnum)[keyof typeof PriceChangeSourceEnum];

export const PriceChangeSourceEnum = {
  UI: 'UI',
  CSV_IMPORT: 'CSV_IMPORT',
  EXTERNAL_API: 'EXTERNAL_API',
  EXTERNAL_INTEGRATION: 'EXTERNAL_INTEGRATION',
  PRICE_REVISION: 'PRICE_REVISION',
} as const;

export const ProductPriceChangeLogBeforeValueType = { ...PriceValueTypeEnum, ...BlankEnum } as const;
export const ProductPriceChangeLogAfterValueType = { ...PriceValueTypeEnum, ...BlankEnum } as const;
/**
 * 単価変更ログ一覧のレスポンス
 *
 * 取引先・価格グループ・実行者は変更時点の名称スナップショットだけを返し、参照先のIDは返さない。
 * 参照先は削除され得る (SET_NULL) ため、1レコードだけで内容が読めるスナップショット側を正とする。
 *
 * バリエーションは CASCADE で必ず生存しているため名称を参照先から引く。商品単位のランク別価格設定
 * (`ProductPartnerPriceGroup`) だけはバリエーションを持たないので null になる。
 */
export interface ProductPriceChangeLog {
  readonly id: number;
  /** @nullable */
  readonly product_variation: number | null;
  /** @nullable */
  readonly variation_name: string | null;
  /** @nullable */
  readonly model_number: string | null;
  readonly price_type: PriceChangeTargetTypeEnum;
  readonly change_type: PriceChangeTypeEnum;
  /** 変更時点の取引先名。取引先が削除された後もログを読めるように保持する */
  readonly customer_name: string;
  /** 変更時点の仕入先名。仕入先が削除された後もログを読めるように保持する */
  readonly supplier_name: string;
  /** 変更時点の価格グループコード */
  readonly price_group_code: string;
  /** 変更時点の価格グループのラベル名 */
  readonly price_group_name: string;
  /** @nullable */
  readonly min_quantity: number | null;
  /** @nullable */
  readonly max_quantity: number | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly before_value: string | null;
  readonly before_value_type: (typeof ProductPriceChangeLogBeforeValueType)[keyof typeof ProductPriceChangeLogBeforeValueType];
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly after_value: string | null;
  readonly after_value_type: (typeof ProductPriceChangeLogAfterValueType)[keyof typeof ProductPriceChangeLogAfterValueType];
  /** 変更時点の実行者名。ユーザーが削除された後もログを読めるように保持する */
  readonly user_name: string;
  readonly source: PriceChangeSourceEnum;
  readonly logged_at: string;
}

export interface PaginatedProductPriceChangeLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductPriceChangeLog[];
}

/**
 * 商品データインポートログ
 */
export interface ProductImportLog {
  readonly id: number;
  readonly status: ImportLogStatusEnum;
  readonly is_success: boolean;
  readonly imported_count: number;
  readonly updated_count: number;
  readonly row_count: number;
  readonly errors: unknown;
  /** @nullable */
  readonly filename: string | null;
  readonly created_at: string;
}

export interface PaginatedProductImportLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductImportLog[];
}

/**
 * 商品詳細情報カスタムプロパティグループ用
 */
export interface ProductCatalogCustomPropertyGroup {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  /** @nullable */
  readonly sort_order: number | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 商品詳細情報カスタムプロパティ定義用
 */
export interface ProductCatalogCustomProperty {
  readonly id: number;
  /** @maxLength 100 */
  label: string;
  /**
   * @maxLength 100
   * @nullable
   */
  key?: string | null;
  readonly property_type: number;
  field_type?: FieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
  /** @nullable */
  readonly sort_order: number | null;
  /**
   * カスタムプロパティグループID
   * @nullable
   */
  group?: number | null;
  readonly group_detail: ProductCatalogCustomPropertyGroup | null;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedProductCatalogCustomPropertyList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductCatalogCustomProperty[];
}

/**
 * 商品詳細情報カスタムプロパティ定義用
 */
export interface ProductCatalogCustomPropertyRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  label: string;
  /**
   * @maxLength 100
   * @nullable
   */
  key?: string | null;
  field_type?: FieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
  /**
   * カスタムプロパティグループID
   * @nullable
   */
  group?: number | null;
}

/**
 * 商品詳細情報カスタムプロパティ一括登録用
 */
export interface ProductCatalogCustomPropertyBulkImportRequest {
  /**
   * アップロードされたCSVファイルのオブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: unknown;
}

/**
 * 商品詳細情報カスタムプロパティ一括登録レスポンス用
 */
export interface ProductCatalogCustomPropertyBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** 新規登録された件数 */
  imported_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラーになった行の総数 */
  error_count?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

/**
 * 商品詳細情報カスタムプロパティ表示順更新用のアイテム
 */
export interface ProductCatalogCustomPropertyReorderItemRequest {
  /**
   * カスタムプロパティID
   * @minimum 1
   */
  id: number;
  /**
   * 表示順序
   * @minimum 1
   */
  sort_order: number;
}

/**
 * 商品詳細情報カスタムプロパティ表示順更新用のシリアライザー
 */
export interface ProductCatalogCustomPropertyReorderRequest {
  /**
   * カスタムプロパティIDと表示順のリスト
   * @minItems 1
   */
  property_orders: ProductCatalogCustomPropertyReorderItemRequest[];
}

export interface PaginatedProductCatalogCustomPropertyGroupList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductCatalogCustomPropertyGroup[];
}

/**
 * 商品詳細情報カスタムプロパティグループ用
 */
export interface ProductCatalogCustomPropertyGroupRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
}

/**
 * 商品詳細情報カスタムプロパティグループ表示順更新用のアイテム
 */
export interface ProductCatalogCustomPropertyGroupReorderItemRequest {
  /**
   * カスタムプロパティグループID
   * @minimum 1
   */
  id: number;
  /**
   * 表示順序
   * @minimum 1
   */
  sort_order: number;
}

/**
 * 商品詳細情報カスタムプロパティグループ表示順更新用のシリアライザー
 */
export interface ProductCatalogCustomPropertyGroupReorderRequest {
  /**
   * カスタムプロパティグループIDと表示順のリスト
   * @minItems 1
   */
  group_orders: ProductCatalogCustomPropertyGroupReorderItemRequest[];
}

/**
 * * `TYPE_1` - 分類1
 * * `TYPE_2` - 分類2
 * * `TYPE_3` - 分類3
 */
export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];

export const TypeEnum = {
  TYPE_1: 'TYPE_1',
  TYPE_2: 'TYPE_2',
  TYPE_3: 'TYPE_3',
} as const;

/**
 * 商品カテゴリマスタ
 *
 * 項目が多くないのでList,Detail共通のものを使用する
 */
export interface CategoryMaster {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  type: TypeEnum;
}

export interface PaginatedCategoryMasterList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: CategoryMaster[];
}

/**
 * 商品カテゴリマスタ
 *
 * 項目が多くないのでList,Detail共通のものを使用する
 */
export interface CategoryMasterRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  type: TypeEnum;
}

/**
 * 得意先別単価インポートログ
 */
export interface ProductVariationCustomerPriceImportLog {
  readonly id: number;
  readonly status: ImportLogStatusEnum;
  readonly is_success: boolean;
  readonly imported_count: number;
  readonly updated_count: number;
  readonly row_count: number;
  readonly errors: unknown;
  /** @nullable */
  readonly filename: string | null;
  readonly created_at: string;
}

export interface PaginatedProductVariationCustomerPriceImportLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductVariationCustomerPriceImportLog[];
}

/**
 * 表示項目設定の各項目
 */
export interface DisplayColumnItem {
  key: string;
  label: string;
  visible: boolean;
  sort_order: number;
  required?: boolean;
}

/**
 * 表示項目設定
 */
export interface DisplayColumns {
  columns: DisplayColumnItem[];
}

/**
 * 明細行項目表示設定のシリアライザ
 */
export interface ItemDisplaySetting {
  readonly id: number;
  display_columns: DisplayColumns;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 表示項目設定の各項目
 */
export interface DisplayColumnItemRequest {
  /** @minLength 1 */
  key: string;
  /** @minLength 1 */
  label: string;
  visible: boolean;
  sort_order: number;
  required?: boolean;
}

/**
 * 表示項目設定
 */
export interface DisplayColumnsRequest {
  columns: DisplayColumnItemRequest[];
}

/**
 * 明細行項目表示設定のシリアライザ
 */
export interface ItemDisplaySettingRequest {
  display_columns: DisplayColumnsRequest;
}

/**
 * 荷姿
 *
 * 項目が多くないのでList,Detail共通のものを使用する
 */
export interface PackagingTypeMaster {
  readonly id: number;
  /** @maxLength 250 */
  name: string;
}

export interface PaginatedPackagingTypeMasterList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: PackagingTypeMaster[];
}

/**
 * 荷姿
 *
 * 項目が多くないのでList,Detail共通のものを使用する
 */
export interface PackagingTypeMasterRequest {
  /**
   * @minLength 1
   * @maxLength 250
   */
  name: string;
}

/**
 * * `FREE_TEXT` - テキスト
 * * `MULTI_SELECT` - マルチセレクト
 * * `SELECT` - セレクト
 * * `URL` - URL
 * * `NUMBER` - 数値
 * * `BOOLEAN` - ブール値
 */
export type PriceRevisionCustomPropertyFieldTypeEnum =
  (typeof PriceRevisionCustomPropertyFieldTypeEnum)[keyof typeof PriceRevisionCustomPropertyFieldTypeEnum];

export const PriceRevisionCustomPropertyFieldTypeEnum = {
  FREE_TEXT: 'FREE_TEXT',
  MULTI_SELECT: 'MULTI_SELECT',
  SELECT: 'SELECT',
  URL: 'URL',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
} as const;

/**
 * 価格改定カスタムプロパティ定義用シリアライザ（作成・読み取り用）
 */
export interface ProductPriceRevisionCustomProperty {
  readonly id: number;
  /** @maxLength 100 */
  label: string;
  readonly property_type: number;
  field_type: PriceRevisionCustomPropertyFieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedProductPriceRevisionCustomPropertyList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductPriceRevisionCustomProperty[];
}

/**
 * 価格改定カスタムプロパティ定義用シリアライザ（作成・読み取り用）
 */
export interface ProductPriceRevisionCustomPropertyRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  label: string;
  field_type: PriceRevisionCustomPropertyFieldTypeEnum;
  datas?: unknown;
  is_active?: boolean;
}

/**
 * 価格改定カスタムプロパティ定義更新用シリアライザ（field_type は変更不可）
 */
export interface ProductPriceRevisionCustomPropertyDefinitionUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  label: string;
  datas?: unknown;
  is_active?: boolean;
}

/**
 * * `DRAFT` - 下書き
 * * `IN_PROGRESS` - 対応中
 * * `COMPLETED` - 完了
 */
export type ProductPriceRevisionStatusEnum =
  (typeof ProductPriceRevisionStatusEnum)[keyof typeof ProductPriceRevisionStatusEnum];

export const ProductPriceRevisionStatusEnum = {
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
} as const;

/**
 * 価格改定カスタムプロパティ値用シリアライザ（読み取り）
 */
export interface ProductPriceRevisionCustomPropertyValue {
  readonly id: number;
  price_revision: number;
  custom_property: number;
  readonly custom_property_detail: ProductPriceRevisionCustomProperty;
  /** @nullable */
  value?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 価格改定一覧用
 */
export interface ProductPriceRevisionList {
  readonly id: number;
  readonly title: string;
  readonly status: ProductPriceRevisionStatusEnum;
  readonly shipping_start_date: string;
  readonly arrival_start_date: string;
  /**
   * 標準単価・取引先別単価をマスタへ反映した日時。未反映の間は None
   * @nullable
   */
  readonly shipping_applied_at: string | null;
  /**
   * 原価・仕入先別単価をマスタへ反映した日時。未反映の間は None
   * @nullable
   */
  readonly arrival_applied_at: string | null;
  /** 価格改定した担当者。単価変更ログに担当者として記録される */
  readonly responsible_person: number;
  /** 担当者名を取得 */
  readonly responsible_person_name: string;
  /** 商品数（商品明細の件数） */
  readonly product_count: number;
  readonly custom_properties: readonly ProductPriceRevisionCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedProductPriceRevisionListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductPriceRevisionList[];
}

/**
 * 価格改定商品明細の入力
 */
export interface ProductPriceRevisionItemInputRequest {
  /** 商品バリエーションID */
  product_variation_id: number;
  /**
   * 改定後の標準単価（null は改定しない）
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  unit_price: string | null;
  /**
   * 改定後の原価（null は改定しない）
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  cost_price: string | null;
}

/**
 * 価格改定取引先別単価明細の入力
 */
export interface ProductPriceRevisionCustomerPriceInputRequest {
  /** 得意先ID */
  customer_id: number;
  /** 商品バリエーションID（商品明細に含まれるもの） */
  product_variation_id: number;
  /**
   * 改定後の取引先別単価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  price: string;
}

/**
 * 価格改定仕入先別単価明細の入力
 */
export interface ProductPriceRevisionSupplierPriceInputRequest {
  /** 仕入先ID */
  supplier_id: number;
  /** 商品バリエーションID（商品明細に含まれるもの） */
  product_variation_id: number;
  /**
   * 改定後の仕入単価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  price: string;
}

/**
 * 価格改定カスタムプロパティ値更新用シリアライザ
 */
export interface ProductPriceRevisionCustomPropertyUpdateRequest {
  custom_property_id: number;
  /** @nullable */
  value: string | null;
}

/**
 * 価格改定新規作成用
 */
export interface ProductPriceRevisionCreateRequest {
  /**
   * タイトル
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /** 社内メモ */
  internal_notes?: string;
  /** 適用開始日(出荷予定日) */
  shipping_start_date: string;
  /** 適用開始日(入荷予定日) */
  arrival_start_date: string;
  /** 商品明細 */
  items: ProductPriceRevisionItemInputRequest[];
  /** 取引先別単価明細（改定しない場合は空配列） */
  customer_prices: ProductPriceRevisionCustomerPriceInputRequest[];
  /** 仕入先別単価明細（改定しない場合は空配列） */
  supplier_prices: ProductPriceRevisionSupplierPriceInputRequest[];
  /** 担当者のユーザーID（省略時は保存したユーザー） */
  responsible_person_id?: number;
  /** カスタムプロパティ値の更新データ */
  custom_properties?: ProductPriceRevisionCustomPropertyUpdateRequest[];
}

/**
 * 価格改定商品明細詳細用
 */
export interface ProductPriceRevisionItemDetail {
  readonly id: number;
  readonly product_variation: number;
  readonly product_id: number;
  /** @nullable */
  readonly product_code: string | null;
  readonly product_name: string;
  readonly variation_name: string;
  /** @nullable */
  readonly spec: string | null;
  /** @nullable */
  readonly model_number: string | null;
  /**
   * 現在の標準単価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly current_unit_price: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly unit_price: string | null;
  /**
   * 現在の原価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly current_cost_price: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly cost_price: string | null;
}

/**
 * 価格改定取引先別単価明細詳細用
 */
export interface ProductPriceRevisionCustomerPriceDetail {
  readonly id: number;
  readonly customer: number;
  readonly customer_code: string;
  readonly customer_name: string;
  readonly product_variation: number;
  /** @nullable */
  readonly product_code: string | null;
  readonly product_name: string;
  readonly variation_name: string;
  /** @nullable */
  readonly spec: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly current_price: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly price: string;
}

/**
 * 価格改定仕入先別単価明細詳細用
 */
export interface ProductPriceRevisionSupplierPriceDetail {
  readonly id: number;
  readonly supplier: number;
  readonly supplier_code: string;
  readonly supplier_name: string;
  readonly product_variation: number;
  /** @nullable */
  readonly product_code: string | null;
  readonly product_name: string;
  readonly variation_name: string;
  /** @nullable */
  readonly spec: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly current_price: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly price: string;
}

/**
 * 価格改定詳細用
 */
export interface ProductPriceRevisionDetail {
  readonly id: number;
  readonly title: string;
  readonly internal_notes: string;
  readonly status: ProductPriceRevisionStatusEnum;
  readonly shipping_start_date: string;
  readonly arrival_start_date: string;
  /**
   * 標準単価・取引先別単価をマスタへ反映した日時。未反映の間は None
   * @nullable
   */
  readonly shipping_applied_at: string | null;
  /**
   * 原価・仕入先別単価をマスタへ反映した日時。未反映の間は None
   * @nullable
   */
  readonly arrival_applied_at: string | null;
  /** 価格改定した担当者。単価変更ログに担当者として記録される */
  readonly responsible_person: number;
  /** 担当者名を取得 */
  readonly responsible_person_name: string;
  readonly items: readonly ProductPriceRevisionItemDetail[];
  readonly customer_prices: readonly ProductPriceRevisionCustomerPriceDetail[];
  readonly supplier_prices: readonly ProductPriceRevisionSupplierPriceDetail[];
  readonly custom_properties: readonly ProductPriceRevisionCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 価格改定更新用
 *
 * 下書きでは適用開始日と明細3種がすべて必須、下書き以外では指定できない。
 * ステータスで必須・禁止が変わるため、その検証はサービスで行う。
 */
export interface ProductPriceRevisionUpdateRequest {
  /**
   * タイトル
   * @minLength 1
   * @maxLength 255
   */
  title: string;
  /** 社内メモ */
  internal_notes?: string;
  /** 適用開始日(出荷予定日)（下書きの間のみ指定可能・必須） */
  shipping_start_date?: string;
  /** 適用開始日(入荷予定日)（下書きの間のみ指定可能・必須） */
  arrival_start_date?: string;
  /** 商品明細（下書きの間のみ指定可能・必須） */
  items?: ProductPriceRevisionItemInputRequest[];
  /** 取引先別単価明細（下書きの間のみ指定可能・必須） */
  customer_prices?: ProductPriceRevisionCustomerPriceInputRequest[];
  /** 仕入先別単価明細（下書きの間のみ指定可能・必須） */
  supplier_prices?: ProductPriceRevisionSupplierPriceInputRequest[];
  /** 担当者のユーザーID（省略時は保存したユーザー） */
  responsible_person_id?: number;
  /** カスタムプロパティ値の更新データ */
  custom_properties?: ProductPriceRevisionCustomPropertyUpdateRequest[];
}

/**
 * 価格改定の見積一括登録の候補の1行
 *
 * 受注実績と取引先別単価の改定の「得意先 × 商品バリエーション」を同じ形に正規化した行。
 */
export interface ProductPriceRevisionQuotationCandidate {
  /** 得意先ID */
  readonly customer_id: number;
  /** 得意先コード */
  readonly customer_code: string;
  /** 得意先名 */
  readonly customer_name: string;
  /** 商品バリエーションID */
  readonly product_variation_id: number;
  /** @nullable */
  readonly product_code: string | null;
  readonly product_name: string;
  readonly variation_name: string;
  /** @nullable */
  readonly spec: string | null;
  /**
   * 最終受注日。受注実績の無い行は null
   * @nullable
   */
  readonly last_ordered_date: string | null;
  /**
   * 改定前単価。出荷予定日側をマスタへ反映済みの改定は null
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly current_price: string | null;
  /**
   * 改定後単価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly revised_price: string;
  /**
   * 作成済みの見積ID。未作成は null
   * @nullable
   */
  readonly quotation_id: number | null;
}

/**
 * 価格改定の見積一括登録で選んだ候補の行の入力
 */
export interface ProductPriceRevisionQuotationLineInputRequest {
  /** 得意先ID */
  customer_id: number;
  /** 商品バリエーションID */
  product_variation_id: number;
}

/**
 * 価格改定の見積一括登録用
 */
export interface ProductPriceRevisionQuotationCreateRequest {
  /** 見積を作成する候補の行のリスト */
  lines: ProductPriceRevisionQuotationLineInputRequest[];
}

/**
 * 価格改定の見積一括登録レスポンス用
 */
export interface ProductPriceRevisionQuotationCreateResponse {
  /** 作成された見積IDのリスト（得意先コード順） */
  quotation_ids: number[];
}

/**
 * 価格改定ステータス更新用
 */
export interface PatchedProductPriceRevisionStatusUpdateRequest {
  status?: ProductPriceRevisionStatusEnum;
}

/**
 * 商品プリセット一覧用
 */
export interface ProductPresetList {
  readonly id: number;
  readonly name: string;
  readonly internal_notes: string;
  /** 品目数 */
  readonly item_count: number;
  /** 合計（基本価格）。品目ごとに数量 × 標準単価を組織の得意先用の端数処理で整数へ丸めた合計 */
  readonly total_base_price: string;
  readonly updated_at: string;
}

export interface PaginatedProductPresetListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductPresetList[];
}

/**
 * 商品プリセット品目の入力
 */
export interface ProductPresetItemInputRequest {
  /**
   * 商品バリエーションID
   * @minimum 1
   */
  product_variation_id: number;
  /**
   * 数量
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  quantity: string;
}

/**
 * 商品プリセット作成・更新用
 */
export interface ProductPresetInputRequest {
  /**
   * プリセット名
   * @minLength 1
   * @maxLength 255
   */
  name: string;
  /** メモ */
  internal_notes?: string;
  /** 品目（配列の順で表示順を振る。500件まで） */
  items: ProductPresetItemInputRequest[];
}

/**
 * 商品プリセット品目詳細用
 */
export interface ProductPresetItemDetail {
  readonly id: number;
  readonly product_variation_id: number;
  readonly product_id: number;
  /** @nullable */
  readonly product_code: string | null;
  readonly variation_name: string;
  /** @nullable */
  readonly spec: string | null;
  /** @nullable */
  readonly unit_name: string | null;
  /**
   * 基本価格（商品バリエーションの標準単価）
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly unit_price: string;
  readonly is_saleable: boolean;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
  readonly sort_order: number;
}

/**
 * 商品プリセット詳細用
 */
export interface ProductPresetDetail {
  readonly id: number;
  readonly name: string;
  readonly internal_notes: string;
  /** 品目数 */
  readonly item_count: number;
  /** 合計（基本価格）。品目ごとに数量 × 標準単価を組織の得意先用の端数処理で整数へ丸めた合計 */
  readonly total_base_price: string;
  readonly items: readonly ProductPresetItemDetail[];
  readonly updated_at: string;
}

/**
 * 商品バリエーション仕入先情報
 */
export interface ProductVariationSupplier {
  readonly id: number;
  product_variation: number;
  readonly product_variation_name: string;
  /**
   * 発注書作成時のデフォルト数量として使用
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  minimum_order_quantity?: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_cost_price: string;
  /**
   * 発注から入荷までの日数
   * @minimum 0
   * @maximum 32767
   */
  lead_time_days?: number;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 商品仕入先情報
 */
export interface ProductSupplier {
  readonly id: number;
  product: number;
  readonly product_name: string;
  supplier: number;
  readonly supplier_name: string;
  /** 発注時にデフォルトで選択される仕入先 */
  is_default?: boolean;
  readonly variation_suppliers: readonly ProductVariationSupplier[];
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedProductSupplierList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductSupplier[];
}

/**
 * バリエーション仕入先情報の入力用
 */
export interface ProductVariationSupplierUpdateRequest {
  product_variation_id: number;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  minimum_order_quantity?: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_cost_price: string;
  /** @minimum 0 */
  lead_time_days?: number;
}

/**
 * 一括更新用の各仕入先情報
 */
export interface ProductSupplierItemUpdateRequest {
  supplier_id: number;
  is_default?: boolean;
  variation_suppliers?: ProductVariationSupplierUpdateRequest[];
}

/**
 * 商品仕入先情報の一括更新用
 */
export interface ProductSupplierBulkUpdateRequest {
  product_id: number;
  suppliers: ProductSupplierItemUpdateRequest[];
}

/**
 * 仕入先情報検索リクエスト用
 */
export interface ProductSupplierLookupRequestRequest {
  /**
   * 仕入先(仕入先フラグONの取引先)ID。省略時は仕入先情報なしの既定値と原価の予約単価のみ返す
   * @nullable
   */
  supplier_id?: number | null;
  /**
   * 商品バリエーションIDのリスト
   * @minItems 1
   */
  product_variation_ids: number[];
}

/**
 * 仕入先情報検索結果の各アイテム
 */
export interface ProductSupplierLookupItem {
  /** 商品バリエーションID */
  product_variation_id: number;
  /**
   * 最低発注数量
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  minimum_order_quantity: string;
  /**
   * 仕入単価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  unit_cost_price: string;
  /**
   * 原価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  cost_price: string;
  /**
   * 仕入先別単価（設定がない場合はnull）
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  supplier_unit_cost_price: string | null;
  /** 予約単価候補（価格改定で予約された、入荷予定日側が未反映の原価・仕入先別単価） */
  reserved_prices: ProductVariationReservedPrice[];
}

/**
 * 仕入先情報検索レスポンス用
 */
export interface ProductSupplierLookupResponse {
  /** 検索結果リスト */
  items: ProductSupplierLookupItem[];
}

/**
 * バリエーション別取引先単価用
 */
export interface ProductVariationCustomerPrice {
  readonly id: number;
  customer: number;
  product_variation: number;
  readonly product: number;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly unit_cost_price: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly original_unit_price: string;
  readonly customer_name: string;
  readonly product_variation_name: string;
  readonly updated_at: string;
}

export interface PaginatedProductVariationCustomerPriceList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductVariationCustomerPrice[];
}

/**
 * バリエーション別取引先単価の作成・更新用
 */
export interface ProductVariationCustomerPriceCreateUpdateRequest {
  customer: number;
  product_variation: number;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
}

/**
 * 取引先別単価一括削除用
 */
export interface ProductCustomerPriceBulkDeleteRequest {
  /** 削除する取引先別単価IDのリスト */
  ids: number[];
}

/**
 * バリエーション別取引先単価一括登録用
 */
export interface ProductVariationCustomerPriceBulkImportRequest {
  /**
   * R2オブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: unknown;
  /**
   * アップロードファイル名
   * @maxLength 255
   */
  filename?: string;
}

/**
 * バリエーション別取引先単価一括登録レスポンス用
 */
export interface ProductVariationCustomerPriceBulkImportResponse {
  /** インポートログID */
  import_log_id: number;
  /** 新規件数 */
  imported_count: number;
  /** 更新件数 */
  updated_count: number;
  /** 処理成功フラグ */
  is_success: boolean;
}

export interface ProductVariationCustomerPriceBulkCreateUpdatePriceItemRequest {
  /** @nullable */
  id?: number | null;
  customer: number;
  product_variation: number;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
}

/**
 * 商品のバリエーション別取引先単価の一括作成・更新用
 *
 * - サービス側(ビジネスロジック)で厳密なバリデーション等を行う
 */
export interface ProductVariationCustomerPriceBulkCreateUpdateRequest {
  product_id: number;
  customer_prices: ProductVariationCustomerPriceBulkCreateUpdatePriceItemRequest[];
}

/**
 * * `RATE` - 掛け率
 * * `FIXED` - 固定単価
 */
export type PriceTypeEnum = (typeof PriceTypeEnum)[keyof typeof PriceTypeEnum];

export const PriceTypeEnum = {
  RATE: 'RATE',
  FIXED: 'FIXED',
} as const;

/**
 * 商品バリエーションランク別価格設定
 */
export interface ProductVariationPartnerPriceGroup {
  readonly id: number;
  product_variation: number;
  readonly product_variation_name: string;
  price_group: number;
  readonly price_group_code: string;
  readonly price_group_name: string;
  price_type: PriceTypeEnum;
  readonly price_type_display: string;
  /**
   * 価格タイプがRATEの場合は掛け率（%）、FIXEDの場合は固定単価
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  value: string;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedProductVariationPartnerPriceGroupList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductVariationPartnerPriceGroup[];
}

/**
 * 商品バリエーションランク別価格設定の一括更新用アイテム
 */
export interface ProductVariationPartnerPriceGroupBulkItemRequest {
  /** @nullable */
  id?: number | null;
  product_variation_id: number;
  price_group: number;
  price_type: PriceTypeEnum;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  value: string;
}

/**
 * 商品バリエーションランク別価格設定の一括更新用
 */
export interface ProductVariationPartnerPriceGroupBulkUpdateRequest {
  price_groups: ProductVariationPartnerPriceGroupBulkItemRequest[];
  /** 削除対象のレコードIDリスト */
  delete_ids?: number[];
}

/**
 * 一覧アイテムor詳細情報用の数量別単価
 *
 * NOTE: 単独で一覧や詳細情報を取得する時に使用する
 */
export interface ProductVariationQuantityPriceListItem {
  readonly id: number;
  readonly product_id: number;
  product_variation: number;
  product_variation_name: string;
  readonly product_name: string;
  product_code: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  min_quantity: number;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  max_quantity?: number | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly unit_cost_price: string | null;
  readonly updated_at: string;
}

export interface PaginatedProductVariationQuantityPriceListItemList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductVariationQuantityPriceListItem[];
}

/**
 * 数量別単価の作成・更新用
 */
export interface ProductVariationQuantityPriceCreateUpdateRequest {
  product_variation: number;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  min_quantity: number;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  max_quantity?: number | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  price: string;
}

/**
 * CSVカラムとデータ項目のマッピング
 */
export type ProductVariationQuantityPriceBulkImportRequestMapping = { [key: string]: number };

/**
 * 数量別単価一括登録用
 */
export interface ProductVariationQuantityPriceBulkImportRequest {
  /**
   * R2オブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: ProductVariationQuantityPriceBulkImportRequestMapping;
  /**
   * アップロードファイル名
   * @maxLength 255
   */
  filename?: string;
}

/**
 * 数量別単価一括登録レスポンス用
 */
export interface ProductVariationQuantityPriceBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** インポートログID */
  import_log_id?: number;
  /** 新規件数 */
  imported_count?: number;
  /** 更新件数 */
  updated_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

export type ProductVariationQuantityPriceBulkCreateUpdateRequestQuantityPricesItem = {
  [key: string]: unknown;
};

/**
 * 商品の数量別単価の一括作成・更新用
 */
export interface ProductVariationQuantityPriceBulkCreateUpdateRequest {
  product_id: number;
  quantity_prices: ProductVariationQuantityPriceBulkCreateUpdateRequestQuantityPricesItem[];
}

/**
 * * `MANAGED` - 在庫管理する
 * * `NOT_MANAGED` - 在庫管理しない（非在庫品）
 */
export type InventoryManagementTypeEnum =
  (typeof InventoryManagementTypeEnum)[keyof typeof InventoryManagementTypeEnum];

export const InventoryManagementTypeEnum = {
  MANAGED: 'MANAGED',
  NOT_MANAGED: 'NOT_MANAGED',
} as const;

/**
 * 商品カテゴリ
 *
 * カテゴリマスタの情報を含めて返す
 */
export interface ProductCategory {
  readonly id: number;
  readonly category: CategoryMaster;
}

/**
 * * `MATERIAL` - 材料費
 * * `LABOR` - 労務費
 * * `EXPENSE` - 経費
 * * `OUTSOURCING` - 外注費
 */
export type CostCategoryEnum = (typeof CostCategoryEnum)[keyof typeof CostCategoryEnum];

export const CostCategoryEnum = {
  MATERIAL: 'MATERIAL',
  LABOR: 'LABOR',
  EXPENSE: 'EXPENSE',
  OUTSOURCING: 'OUTSOURCING',
} as const;

/**
 * 商品バリエーションのサンプル
 */
export interface ProductVariationSample {
  readonly id: number;
  /** @maxLength 500 */
  name: string;
  /** @maxLength 50 */
  code: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
}

/**
 * 商品バリエーション一覧アイテム
 */
export interface ProductVariationListItem {
  readonly id: number;
  readonly product_id: number;
  readonly product_name: string;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  manufacturer: string;
  /** @nullable */
  readonly spec: string | null;
  /** @nullable */
  notes?: string | null;
  readonly variation_name: string;
  /** @nullable */
  unit?: number | null;
  /** @nullable */
  readonly unit_name: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  cost_price: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp: string;
  /** @nullable */
  readonly packaging_type_id: number | null;
  /** @nullable */
  readonly packaging_type_name: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  msrp?: string | null;
  /** MSRPがオープン価格の場合はTrue */
  is_open_price?: boolean;
  readonly variation_values: readonly VariationValue[];
  /** @nullable */
  readonly customer_price_id: number | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly customer_price: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly rank_price: string | null;
  readonly rank_prices: readonly ProductVariationRankPrice[];
  readonly reserved_prices: readonly ProductVariationReservedPrice[];
  /** @nullable */
  readonly last_ordered_date: string | null;
  /** @nullable */
  readonly customer_model_number: string | null;
  readonly quantity_prices: readonly ProductVariationQuantityPrice[];
  tax_class: TaxClassEnum;
  inventory_management_type?: InventoryManagementTypeEnum;
  lot_management_type?: LotManagementTypeEnum;
  is_saleable?: boolean;
  is_processable?: boolean;
  readonly product_categories: readonly ProductCategory[];
  /** @nullable */
  readonly default_supplier_name: string | null;
  /** @nullable */
  readonly thumbnail_url: string | null;
  readonly features: ProductVariationFeatures;
  readonly cost_category: CostCategoryEnum | NullEnum;
  /** サンプル(受注・見積の明細でサンプルとして選べる品名・商品コード・単価) */
  readonly samples: readonly ProductVariationSample[];
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  readonly width: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  readonly depth: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  readonly height: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly weight: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedProductVariationListItemList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductVariationListItem[];
}

/**
 * 商品バリエーション詳細情報の添付ファイルのアップロードURL発行用リクエスト
 */
export interface CatalogAttachmentUploadRequestRequest {
  /**
   * アップロードするファイル名
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /**
   * アップロードするファイルのMIMEタイプ
   * @minLength 1
   * @maxLength 100
   */
  file_type: string;
  /**
   * ファイルサイズ(バイト)。アップロードURLの署名に含め、この値と異なるサイズのPUTを拒否する
   * @minimum 1
   * @maximum 5242880
   */
  file_size: number;
}

/**
 * 商品バリエーション詳細情報ファイル
 */
export interface ProductVariationCatalogFile {
  readonly id: number;
  readonly product_variation_catalog: number;
  /** @maxLength 255 */
  name: string;
  readonly object_key: string;
  /** @maxLength 100 */
  file_type?: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  sort_order?: number;
  /** @nullable */
  readonly download_url: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 商品バリエーション詳細情報添付ファイル(非公開)
 *
 * 非公開バケットのファイルのためダウンロードURLは含めず、都度ダウンロードURL取得APIで発行する。
 */
export interface ProductVariationCatalogAttachment {
  readonly id: number;
  readonly name: string;
  readonly file_type: string;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 商品バリエーション詳細情報
 */
export interface ProductVariationCatalog {
  readonly id: number;
  readonly product_variation: number;
  /** @nullable */
  description?: string | null;
  /**
   * JANコード（最大13桁）
   * @maxLength 13
   * @nullable
   */
  jan_code?: string | null;
  /**
   * 全文検索用のキーワード
   * @nullable
   */
  keywords?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  width?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  depth?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  height?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  weight?: string | null;
  /**
   * 案件原価管理で利用する原価区分（工事機能フラグ有効時に設定）
   *
   * * `MATERIAL` - 材料費
   * * `LABOR` - 労務費
   * * `EXPENSE` - 経費
   * * `OUTSOURCING` - 外注費
   */
  cost_category?: CostCategoryEnum | BlankEnum | NullEnum;
  /** 機能フラグをキーとした拡張機能用データ */
  readonly features_datas: unknown;
  readonly files: readonly ProductVariationCatalogFile[];
  readonly attachments: readonly ProductVariationCatalogAttachment[];
  /** サンプル */
  readonly samples: readonly ProductVariationSample[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * ファイル並び順更新用のアイテム
 */
export interface FileReorderItemRequest {
  /**
   * ファイルID
   * @minimum 1
   */
  id: number;
  /**
   * 表示順序
   * @minimum 0
   */
  sort_order: number;
}

/**
 * 商品バリエーション詳細情報ファイル並び順更新用
 */
export interface ProductVariationCatalogFileReorderRequest {
  /**
   * ファイルIDと並び順のリスト
   * @minItems 1
   */
  file_orders: FileReorderItemRequest[];
}

/**
 * 商品詳細情報ファイル
 */
export interface ProductCatalogFile {
  readonly id: number;
  readonly product_catalog: number;
  /** @maxLength 255 */
  name: string;
  readonly object_key: string;
  /** @maxLength 100 */
  file_type?: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  sort_order?: number;
  /** @nullable */
  readonly download_url: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 商品バリエーションのサンプル(作成・更新用)
 */
export interface ProductVariationSampleCreateUpdateRequest {
  /**
   * 更新するサンプルのID。省略時はサンプルを追加する
   * @nullable
   */
  id?: number | null;
  /**
   * サンプル品名
   * @minLength 1
   * @maxLength 500
   */
  name: string;
  /**
   * サンプル商品コード
   * @minLength 1
   * @maxLength 50
   */
  code: string;
  /**
   * サンプル単価
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  unit_price: string;
}

/**
 * 商品バリエーション詳細情報作成・更新用
 */
export interface ProductVariationCatalogCreateUpdateRequest {
  /** @nullable */
  description?: string | null;
  /**
   * JANコード（最大13桁）
   * @maxLength 13
   * @nullable
   */
  jan_code?: string | null;
  /**
   * @maxLength 1000
   * @nullable
   */
  keywords?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  width?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  depth?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,5}(?:\.\d{0,1})?$
   */
  height?: string | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  weight?: string | null;
  /**
   * 案件原価管理で利用する原価区分（工事機能フラグ有効時に設定）
   *
   * * `MATERIAL` - 材料費
   * * `LABOR` - 労務費
   * * `EXPENSE` - 経費
   * * `OUTSOURCING` - 外注費
   */
  cost_category?: CostCategoryEnum | BlankEnum | NullEnum;
  /** 機能フラグをキーとした拡張機能用データ */
  features_datas?: unknown;
  /** サンプル。指定するとこの一覧に揃え、一覧に無い既存のサンプルは削除する。省略時は変更しない */
  samples?: ProductVariationSampleCreateUpdateRequest[];
}

/**
 * * `image/png` - image/png
 * * `image/jpeg` - image/jpeg
 */
export type FileTypeEnum = (typeof FileTypeEnum)[keyof typeof FileTypeEnum];

export const FileTypeEnum = {
  'image/png': 'image/png',
  'image/jpeg': 'image/jpeg',
} as const;

/**
 * 商品詳細情報ファイル単一アップロード用リクエスト
 */
export interface CatalogFileUploadRequestRequest {
  /**
   * アップロードするファイル名
   * @minLength 1
   * @maxLength 255
   */
  file_name: string;
  /**
   * アップロードするファイルタイプ
   *
   * * `image/png` - image/png
   * * `image/jpeg` - image/jpeg
   */
  file_type: FileTypeEnum;
  /**
   * ファイルサイズ(バイト)。アップロードURLの署名に含め、この値と異なるサイズのPUTを拒否する
   * @minimum 1
   * @maximum 5242880
   */
  file_size: number;
}

/**
 * 商品バリエーション部品構成 (一覧/レスポンス)
 */
export interface ProductVariationPartItem {
  readonly id: number;
  readonly part_variation_id: number;
  readonly product_id: number;
  /** @nullable */
  readonly product_code: string | null;
  readonly variation_name: string;
  /** @nullable */
  readonly unit_name: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly cost_price: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  readonly quantity: string;
  readonly sort_order: number;
}

/**
 * 部品リスト一括置換 (リクエスト) の各行
 */
export interface ProductVariationPartInputRequest {
  /** @minimum 1 */
  part_variation_id: number;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity: string;
  /** @minimum 0 */
  sort_order?: number;
}

/**
 * 部品リスト一括置換用リクエスト
 */
export interface ProductVariationPartReplaceRequest {
  parts: ProductVariationPartInputRequest[];
}

/**
 * バリエーション値
 */
export interface VariationValueRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  value: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  value_id?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  sort_order?: number;
  /** @minLength 1 */
  variation_type_name: string;
  variation_type_sort_order: number;
}

/**
 * 商品バリエーション
 */
export interface ProductVariationRequest {
  /** @nullable */
  unit?: number | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  cost_price: string;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  /** @minLength 1 */
  manufacturer?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp: string;
  /** @nullable */
  packaging_type_id?: number | null;
  variation_values: VariationValueRequest[];
  tax_class?: TaxClassEnum;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  msrp?: string | null;
  /** MSRPがオープン価格の場合はTrue */
  is_open_price?: boolean;
}

/**
 * 商品作成用
 *
 * NOTE: base_price は受け付けない。新規作成UIに価格入力が無く、作成時の初期単価は
 * バリエーション(variations[].unit_price)で指定するため。単一(デフォルト)バリエーション
 * 商品の単価は作成後の更新(ProductUpdateSerializer.base_price)で設定する。
 */
export interface ProductCreateRequest {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @maxLength 100
   * @nullable
   */
  name_kana?: string | null;
  /**
   * 規格(バリエーションごとの指定が無いバリエーションへ保存する)
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * 原価(デフォルトバリエーション原価として保存。未指定・nullの場合は0)
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  unit_cost_price?: string | null;
  /**
   * 単位(デフォルトバリエーション用)
   * @nullable
   */
  unit?: number | null;
  /** @nullable */
  notes?: string | null;
  variations?: ProductVariationRequest[];
  /** カテゴリIDのリスト */
  categories?: number[];
  /** チェックされていない場合は見積書や受注書のアイテムとして選択できない */
  is_saleable?: boolean;
  /** チェック済みの場合は今後の加工管理の対象商品として扱われる */
  is_processable?: boolean;
  /**
   * 在庫管理の方法を選択します
   *
   * * `MANAGED` - 在庫管理する
   * * `NOT_MANAGED` - 在庫管理しない（非在庫品）
   */
  inventory_management_type?: InventoryManagementTypeEnum;
  lot_management_type?: LotManagementTypeEnum;
  tax_class?: TaxClassEnum;
}

/**
 * バリエーションタイプのvalues用
 *
 * NOTE: 詳細取得APIのvariation_typesのために定義
 */
export interface VariationTypeValue {
  readonly id: number;
  /** @maxLength 100 */
  value: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  value_id?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  sort_order?: number;
}

/**
 * バリエーションタイプ
 */
export interface VariationType {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  sort_order?: number;
  values: VariationTypeValue[];
}

export interface ProductDetail {
  readonly id: number;
  /** @maxLength 150 */
  name: string;
  /**
   * @maxLength 100
   * @nullable
   */
  name_kana?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly base_price: string;
  /** @nullable */
  readonly unit: number | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly snp: string | null;
  /** @nullable */
  notes?: string | null;
  variations: ProductVariation[];
  variation_types: VariationType[];
  readonly categories: readonly ProductCategory[];
  /** チェックされていない場合は見積書や受注書のアイテムとして選択できない */
  is_saleable?: boolean;
  /** チェック済みの場合は今後の加工管理の対象商品として扱われる */
  is_processable?: boolean;
  /**
   * 在庫管理の方法を選択します
   *
   * * `MANAGED` - 在庫管理する
   * * `NOT_MANAGED` - 在庫管理しない（非在庫品）
   */
  inventory_management_type?: InventoryManagementTypeEnum;
  lot_management_type?: LotManagementTypeEnum;
  /** ロット管理の設定を変更できるか(全倉庫の在庫数・入荷予定数・出荷予定数が 0 で、在庫変動履歴とロットが無い商品だけ) */
  readonly is_lot_management_type_changeable: boolean;
  tax_class?: TaxClassEnum;
  readonly has_parts: boolean;
  readonly updated_at: string;
}

/**
 * バリエーション値更新用
 */
export interface VariationValueUpdateRequest {
  variation_value_id?: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  value: string;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   * @nullable
   */
  value_id?: number | null;
  /**
   * @minimum -2147483648
   * @maximum 2147483647
   */
  sort_order?: number;
  /** @minLength 1 */
  variation_type_name: string;
  variation_type_sort_order: number;
}

/**
 * 商品バリエーション更新用
 *
 * * ProductVariation.id (variation_id) と VariationValue.id (variation_value_id) を持つかどうかが差分
 */
export interface ProductVariationUpdateRequest {
  /** @nullable */
  unit?: number | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  cost_price: string;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  /** @minLength 1 */
  manufacturer?: string;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp: string;
  /** @nullable */
  packaging_type_id?: number | null;
  variation_id?: number;
  variation_values: VariationValueUpdateRequest[];
  tax_class?: TaxClassEnum;
  /**
   * @minimum -32768
   * @maximum 32767
   */
  sort_order?: number;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  msrp?: string | null;
  /** MSRPがオープン価格の場合はTrue */
  is_open_price?: boolean;
}

/**
 * 商品更新用
 */
export interface ProductUpdateRequest {
  /**
   * @minLength 1
   * @maxLength 150
   */
  name: string;
  /**
   * @maxLength 100
   * @nullable
   */
  name_kana?: string | null;
  /**
   * 規格(全バリエーションへ保存する。バリエーションごとの値は variations[].spec で指定する)
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /**
   * 商品コード（デフォルトバリエーション用）
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * 品番（デフォルトバリエーション用）
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * 基本単価(デフォルトバリエーション単価として保存)
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  base_price?: string;
  /**
   * 原価(デフォルトバリエーション原価として保存。未指定・nullの場合は変更しない)
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  unit_cost_price?: string | null;
  /**
   * 単位(デフォルトバリエーション用)
   * @nullable
   */
  unit?: number | null;
  /**
   * 荷姿(デフォルトバリエーション用)
   * @nullable
   */
  packaging_type_id?: number | null;
  /**
   * 入数(デフォルトバリエーション用)
   * @nullable
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  snp?: string | null;
  /**
   * 上代(デフォルトバリエーション用)
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  msrp?: string | null;
  /** オープン価格フラグ */
  is_open_price?: boolean;
  /** @nullable */
  notes?: string | null;
  variations?: ProductVariationUpdateRequest[];
  /** カテゴリIDのリスト */
  categories?: number[];
  /** チェックされていない場合は見積書や受注書のアイテムとして選択できない */
  is_saleable?: boolean;
  /** チェック済みの場合は今後の加工管理の対象商品として扱われる */
  is_processable?: boolean;
  /**
   * 在庫管理の方法を選択します
   *
   * * `MANAGED` - 在庫管理する
   * * `NOT_MANAGED` - 在庫管理しない（非在庫品）
   */
  inventory_management_type?: InventoryManagementTypeEnum;
  lot_management_type?: LotManagementTypeEnum;
  tax_class?: TaxClassEnum;
}

/**
 * 商品詳細情報カスタムプロパティ値
 */
export interface ProductCatalogCustomPropertyValue {
  readonly id: number;
  product_catalog: number;
  custom_property: number;
  readonly custom_property_detail: ProductCatalogCustomProperty;
  /** @nullable */
  value?: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 商品詳細情報
 */
export interface ProductCatalog {
  readonly id: number;
  readonly product: number;
  /** @nullable */
  description?: string | null;
  readonly files: readonly ProductCatalogFile[];
  readonly custom_properties: readonly ProductCatalogCustomPropertyValue[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 商品詳細情報ファイル並び順更新用
 */
export interface ProductCatalogFileReorderRequest {
  /**
   * ファイルIDと並び順のリスト
   * @minItems 1
   */
  file_orders: FileReorderItemRequest[];
}

/**
 * カスタムプロパティ更新用
 */
export interface ProductCatalogCustomPropertyUpdateRequest {
  custom_property_id: number;
  /** @nullable */
  value?: string | null;
}

/**
 * 商品詳細情報作成・更新用
 */
export interface ProductCatalogCreateUpdateRequest {
  /** @nullable */
  description?: string | null;
  /** @nullable */
  custom_properties?: ProductCatalogCustomPropertyUpdateRequest[] | null;
}

/**
 * 紐づく帳票1件のサンプル（idと表示用番号）
 */
export interface ProductDeletionImpactSample {
  /** 帳票ID（UI側でリンクを構築するために使用） */
  id: number;
  /** 表示用の帳票No. */
  number: string;
}

/**
 * 商品削除時に紐づく帳票1種別ぶんのサマリ
 */
export interface ProductDeletionImpactLinkedDocument {
  /** 帳票種別の識別子 */
  type: string;
  /** 紐づく帳票件数 */
  count: number;
  /** 紐づく帳票のサンプル */
  samples: ProductDeletionImpactSample[];
}

/**
 * 商品削除影響範囲レスポンス
 */
export interface ProductDeletionImpact {
  /** 紐づく帳票が1件以上存在するか */
  has_linked_documents: boolean;
  /** 紐づきが存在する帳票種別のリスト（優先度順） */
  linked_documents: ProductDeletionImpactLinkedDocument[];
}

/**
 * * `Shopify` - Shopify
 * * `AnimalOfficeExternalAPI` - AnimalOfficeExternalAPI
 * * `BASE` - BASE
 * * `AmazonSP` - AmazonSP
 */
export type ServiceEnum = (typeof ServiceEnum)[keyof typeof ServiceEnum];

export const ServiceEnum = {
  Shopify: 'Shopify',
  AnimalOfficeExternalAPI: 'AnimalOfficeExternalAPI',
  BASE: 'BASE',
  AmazonSP: 'AmazonSP',
} as const;

/**
 * * `active` - active
 * * `archived` - archived
 * * `draft` - draft
 * * `unlisted` - unlisted
 */
export type ProductExternalIntegrationDataStatusEnum =
  (typeof ProductExternalIntegrationDataStatusEnum)[keyof typeof ProductExternalIntegrationDataStatusEnum];

export const ProductExternalIntegrationDataStatusEnum = {
  active: 'active',
  archived: 'archived',
  draft: 'draft',
  unlisted: 'unlisted',
} as const;

/**
 * Shopify連携商品のバリエーション別価格情報(datas.variants の要素)
 */
export interface ProductShopifyVariant {
  /** ShopifyのバリエーションID */
  id: number;
  /** バリエーション名(option1〜3を「 / 」で連結。該当が無ければ「-」) */
  variation_name: string;
  /**
   * SKU
   * @nullable
   */
  sku?: string | null;
  /** 価格(Decimal由来の文字列) */
  price: string;
}

/**
 * 外部連携の付加情報(ProductExternalIntegration.datas)
 *
 * 保持する項目は service により異なるため全フィールドを任意とする。
 * - Shopify: status(公開ステータス) / variants(バリエーション別価格)
 * - BASE: price(販売価格) / proper_price(定価)
 */
export interface ProductExternalIntegrationData {
  /**
   * Shopifyの公開ステータス
   *
   * * `active` - active
   * * `archived` - archived
   * * `draft` - draft
   * * `unlisted` - unlisted
   */
  status?: ProductExternalIntegrationDataStatusEnum | NullEnum;
  /** Shopifyのバリエーション別価格一覧 */
  variants?: ProductShopifyVariant[];
  /**
   * BASEの販売価格
   * @nullable
   */
  price?: number | null;
  /**
   * BASEの定価
   * @nullable
   */
  proper_price?: number | null;
}

/**
 * 商品外部連携情報
 */
export interface ProductExternalIntegration {
  readonly id: number;
  readonly service: ServiceEnum;
  readonly external_id: string;
  /**
   * 外部サービスへのリンク
   * @nullable
   */
  external_link: string | null;
  /** 外部連携の付加情報(serviceにより内容が異なる) */
  datas: ProductExternalIntegrationData;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 商品一括削除用
 */
export interface ProductBulkDeleteRequest {
  /** 削除する商品IDのリスト */
  product_ids: number[];
}

/**
 * 商品一括登録用
 */
export interface ProductBulkImportRequest {
  /**
   * R2オブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: unknown;
  /**
   * アップロードファイル名
   * @maxLength 255
   */
  filename?: string;
}

/**
 * 一括登録レスポンス用
 */
export interface ProductBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** インポートログID */
  import_log_id?: number;
  /** 処理ステータス */
  status?: string;
  /** 新規登録された件数 */
  imported_count?: number;
  /** 更新された件数 */
  updated_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

/**
 * 数量別単価インポートログ
 */
export interface ProductVariationQuantityPriceImportLog {
  readonly id: number;
  readonly status: ImportLogStatusEnum;
  readonly is_success: boolean;
  readonly imported_count: number;
  readonly updated_count: number;
  readonly row_count: number;
  readonly errors: unknown;
  /** @nullable */
  readonly filename: string | null;
  readonly created_at: string;
}

export interface PaginatedProductVariationQuantityPriceImportLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: ProductVariationQuantityPriceImportLog[];
}

export interface PaginatedQuantityUnitMasterList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: QuantityUnitMaster[];
}

/**
 * 数量単位マスタ
 *
 * 項目が多くないのでList,Detail共通のものを使用する
 */
export interface QuantityUnitMasterRequest {
  /**
   * @minLength 1
   * @maxLength 50
   */
  name: string;
}

/**
 * 商品バリエーション AG Grid (Server-Side Row Model) 用レスポンス
 *
 * 行データは商品バリエーション一覧 (`GET /api/products/product-variations`) と同一の
 * `ProductVariationListItemSerializer` を返し、UI との I/F 契約を一致させる。
 * グループ化は行わないため leaf データのみを返す。
 */
export interface ProductVariationSsrmLeafResponse {
  /** 商品バリエーションデータ */
  results: ProductVariationListItem[];
  /** 総件数 */
  count: number;
  /**
   * 次ページのURL
   * @nullable
   */
  next?: string | null;
  /**
   * 前ページのURL
   * @nullable
   */
  previous?: string | null;
  /** 商品名の全文検索(FTS)経由で絞り込んだ場合のみ true */
  with_fts?: boolean;
}

export type ProductVariationSsrmResponse = ProductVariationSsrmLeafResponse;

/**
 * 商品バリエーションエクスポート (AG Grid / SSRM 版) のリクエスト
 *
 * エクスポート対象の決定は次の優先順位:
 *   1. product_variation_ids 指定あり -> その ID のみ (選択エクスポート。フィルタ項目は無視)
 *   2. いずれも無し -> AG Grid (SSRM) 一覧 (`ProductVariationSsrmViewSet.list`) と同一の
 *      絞り込みにマッチした全件
 * フィルタ項目は `<col>` / `<col>_filter_type` / `<col>_filter` 等、SSRM 一覧のクエリパラメータと
 * 同名・同義。一覧と同じ解釈にするため、数値・日付・CSV の各項目も文字列で受ける。
 */
export interface ProductVariationSsrmExportRequestRequest {
  /**
   * フォーマットタイプ
   *
   * * `csv` - csv
   * * `excel` - excel
   */
  format_type: FormatTypeEnum;
  /** エクスポート対象の商品バリエーションIDリスト(選択エクスポート用) */
  product_variation_ids?: number[];
  /**
   * 商品名 (全文検索/部分一致)
   * @minLength 1
   */
  variation_name?: string;
  /**
   * 商品名フィルタの種類
   * @minLength 1
   */
  variation_name_filter_type?: string;
  /**
   * バリエーション属性のキー/バリュー (部分一致)
   * @minLength 1
   */
  variation_values?: string;
  /**
   * 商品コード (部分一致)
   * @minLength 1
   */
  product_code?: string;
  /**
   * 商品コードフィルタの種類
   * @minLength 1
   */
  product_code_filter_type?: string;
  /**
   * 品番 (部分一致)
   * @minLength 1
   */
  model_number?: string;
  /**
   * 品番フィルタの種類
   * @minLength 1
   */
  model_number_filter_type?: string;
  /**
   * メーカー (部分一致)
   * @minLength 1
   */
  manufacturer?: string;
  /**
   * メーカーフィルタの種類
   * @minLength 1
   */
  manufacturer_filter_type?: string;
  /**
   * 単位 (部分一致)
   * @minLength 1
   */
  unit_name?: string;
  /**
   * 単位フィルタの種類
   * @minLength 1
   */
  unit_name_filter_type?: string;
  /**
   * 規格 (部分一致)
   * @minLength 1
   */
  spec?: string;
  /**
   * 規格フィルタの種類
   * @minLength 1
   */
  spec_filter_type?: string;
  /**
   * 備考 (部分一致)
   * @minLength 1
   */
  notes?: string;
  /**
   * 備考フィルタの種類
   * @minLength 1
   */
  notes_filter_type?: string;
  /**
   * 仕入先 (部分一致)
   * @minLength 1
   */
  default_supplier_name?: string;
  /**
   * 仕入先フィルタの種類
   * @minLength 1
   */
  default_supplier_name_filter_type?: string;
  /**
   * 単価フィルタの値
   * @minLength 1
   */
  unit_price_filter?: string;
  /**
   * 単価フィルタの種類
   * @minLength 1
   */
  unit_price_filter_type?: string;
  /**
   * 単価フィルタの上限 (inRange用)
   * @minLength 1
   */
  unit_price_filter_to?: string;
  /**
   * 原価フィルタの値
   * @minLength 1
   */
  cost_price_filter?: string;
  /**
   * 原価フィルタの種類
   * @minLength 1
   */
  cost_price_filter_type?: string;
  /**
   * 原価フィルタの上限 (inRange用)
   * @minLength 1
   */
  cost_price_filter_to?: string;
  /**
   * 粗利率フィルタの値
   * @minLength 1
   */
  gross_profit_rate_filter?: string;
  /**
   * 粗利率フィルタの種類
   * @minLength 1
   */
  gross_profit_rate_filter_type?: string;
  /**
   * 粗利率フィルタの上限 (inRange用)
   * @minLength 1
   */
  gross_profit_rate_filter_to?: string;
  /**
   * 入数フィルタの値
   * @minLength 1
   */
  snp_filter?: string;
  /**
   * 入数フィルタの種類
   * @minLength 1
   */
  snp_filter_type?: string;
  /**
   * 入数フィルタの上限 (inRange用)
   * @minLength 1
   */
  snp_filter_to?: string;
  /**
   * 上代フィルタの値
   * @minLength 1
   */
  msrp_filter?: string;
  /**
   * 上代フィルタの種類
   * @minLength 1
   */
  msrp_filter_type?: string;
  /**
   * 上代フィルタの上限 (inRange用)
   * @minLength 1
   */
  msrp_filter_to?: string;
  /**
   * 幅(mm)フィルタの値
   * @minLength 1
   */
  width_filter?: string;
  /**
   * 幅(mm)フィルタの種類
   * @minLength 1
   */
  width_filter_type?: string;
  /**
   * 幅(mm)フィルタの上限 (inRange用)
   * @minLength 1
   */
  width_filter_to?: string;
  /**
   * 奥行(mm)フィルタの値
   * @minLength 1
   */
  depth_filter?: string;
  /**
   * 奥行(mm)フィルタの種類
   * @minLength 1
   */
  depth_filter_type?: string;
  /**
   * 奥行(mm)フィルタの上限 (inRange用)
   * @minLength 1
   */
  depth_filter_to?: string;
  /**
   * 高さ(mm)フィルタの値
   * @minLength 1
   */
  height_filter?: string;
  /**
   * 高さ(mm)フィルタの種類
   * @minLength 1
   */
  height_filter_type?: string;
  /**
   * 高さ(mm)フィルタの上限 (inRange用)
   * @minLength 1
   */
  height_filter_to?: string;
  /**
   * 重量(g)フィルタの値
   * @minLength 1
   */
  weight_filter?: string;
  /**
   * 重量(g)フィルタの種類
   * @minLength 1
   */
  weight_filter_type?: string;
  /**
   * 重量(g)フィルタの上限 (inRange用)
   * @minLength 1
   */
  weight_filter_to?: string;
  /**
   * 更新日フィルタの基準日
   * @minLength 1
   */
  updated_at_from?: string;
  /**
   * 更新日フィルタの上限 (inRange用)
   * @minLength 1
   */
  updated_at_to?: string;
  /**
   * 更新日フィルタの種類
   * @minLength 1
   */
  updated_at_filter_type?: string;
  /**
   * 分類1のカテゴリID (カンマ区切りで複数指定可)
   * @minLength 1
   */
  category_type_1?: string;
  /**
   * 分類2のカテゴリID (カンマ区切りで複数指定可)
   * @minLength 1
   */
  category_type_2?: string;
  /**
   * 分類3のカテゴリID (カンマ区切りで複数指定可)
   * @minLength 1
   */
  category_type_3?: string;
  /**
   * 在庫管理タイプ (カンマ区切りで複数指定可)
   * @minLength 1
   */
  inventory_management_type?: string;
  /**
   * 荷姿ID (カンマ区切りで複数指定可)
   * @minLength 1
   */
  packaging_type?: string;
  /**
   * 販売可フラグ
   * @nullable
   */
  saleable?: boolean | null;
  /**
   * 加工可フラグ
   * @nullable
   */
  processable?: boolean | null;
}

/**
 * 商品バリエーションID一覧レスポンス用のシリアライザ(全件選択用)
 */
export interface ProductVariationListIdsResponse {
  /** 商品バリエーションIDのリスト */
  ids: number[];
  /** 該当件数 */
  count: number;
}

/**
 * 仕入インポートログシリアライザ
 */
export interface PurchaseInvoiceImportLog {
  readonly id: number;
  readonly status: ImportLogStatusEnum;
  readonly is_success: boolean;
  readonly imported_count: number;
  readonly imported_items_count: number;
  readonly row_count: number;
  readonly errors: unknown;
  /** @nullable */
  readonly filename: string | null;
  /** エラーCSVがダウンロード可能か（object_keyが存在するか） */
  readonly has_error_file: boolean;
  readonly created_at: string;
}

export interface PaginatedPurchaseInvoiceImportLogList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: PurchaseInvoiceImportLog[];
}

/**
 * 仕入一覧用シリアライザー
 */
export interface PurchaseInvoiceList {
  readonly id: number;
  /** @maxLength 100 */
  purchase_invoice_number: string;
  /** @nullable */
  readonly supplier_name: string | null;
  /** @nullable */
  readonly pay_to_name: string | null;
  /** @nullable */
  project?: number | null;
  /** @nullable */
  readonly project_name: string | null;
  purchase_date?: string;
  payment_due_date: string;
  tax_calculation_type?: TaxCalculationTypeEnum;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  subtotal?: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  total_amount?: string;
  readonly responsible_department: number;
  /** @nullable */
  readonly responsible_department_name: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedPurchaseInvoiceListList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: PurchaseInvoiceList[];
}

/**
 * 仕入作成用シリアライザー（案件紐付けは任意）
 */
export interface PurchaseInvoiceCreateRequest {
  /**
   * 紐付ける案件ID
   * @nullable
   */
  project?: number | null;
}

/**
 * 仕入明細用シリアライザー
 */
export interface PurchaseInvoiceItem {
  /** @nullable */
  id?: number | null;
  readonly product_variation: ProductVariation;
  /** @nullable */
  readonly product_id: number | null;
  /** @maxLength 500 */
  name: string;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity?: string;
  readonly unit: QuantityUnitMaster;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp?: string;
  /** @nullable */
  packaging_type_id?: number | null;
  /** @nullable */
  readonly packaging_type_name: string | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  tax_class?: TaxClassEnum;
  /**
   * @maxLength 250
   * @nullable
   */
  summary?: string | null;
  /**
   * 明細の表示順序。nullの場合はIDでソート
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  sort_order?: number | null;
  /**
   * @nullable
   * @pattern ^-?\d{0,10}(?:\.\d{0,2})?$
   */
  readonly tax_correction: string | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * * `DRAFT` - 下書き
 * * `ISSUED` - 入荷予定
 * * `PARTIALLY_RECEIVED` - 一部納入済
 * * `RECEIVED` - 納入済
 */
export type PurchaseOrderDeliveryStatusEnum =
  (typeof PurchaseOrderDeliveryStatusEnum)[keyof typeof PurchaseOrderDeliveryStatusEnum];

export const PurchaseOrderDeliveryStatusEnum = {
  DRAFT: 'DRAFT',
  ISSUED: 'ISSUED',
  PARTIALLY_RECEIVED: 'PARTIALLY_RECEIVED',
  RECEIVED: 'RECEIVED',
} as const;

/**
 * 発注書参照用の薄いシリアライザ（関連発注書表示などで使用）
 */
export interface PurchaseOrderReference {
  readonly id: number;
  /** @nullable */
  readonly slip_number: string | null;
  readonly status: PurchaseOrderDeliveryStatusEnum;
  readonly ordered_date: string;
  readonly delivery_date: string;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  readonly total_amount: string;
}

/**
 * 仕入詳細用シリアライザー
 */
export interface PurchaseInvoiceDetail {
  readonly id: number;
  /** @maxLength 100 */
  purchase_invoice_number: string;
  readonly supplier: PartnerThin | null;
  readonly pay_to: PartnerThin | null;
  /** @nullable */
  project?: number | null;
  /** @nullable */
  readonly project_name: string | null;
  purchase_date?: string;
  payment_due_date: string;
  responsible_person: number;
  readonly responsible_department: number;
  tax_calculation_type?: TaxCalculationTypeEnum;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  subtotal?: string;
  tax_breakdown?: unknown;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  total_amount?: string;
  notes?: string;
  internal_notes?: string;
  readonly items: readonly PurchaseInvoiceItem[];
  readonly purchase_orders: readonly PurchaseOrderReference[];
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * CSVカラムとデータ項目のマッピング
 */
export type PurchaseInvoiceBulkImportRequestMapping = { [key: string]: number };

/**
 * 仕入一括登録リクエスト
 */
export interface PurchaseInvoiceBulkImportRequest {
  /**
   * R2オブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: PurchaseInvoiceBulkImportRequestMapping;
  /** アップロードファイル名 */
  filename?: string;
  /** 商品マスタデータ取り込みを行わない */
  skip_product_master_import?: boolean;
}

/**
 * 仕入一括登録レスポンス
 */
export interface PurchaseInvoiceBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** インポートログID */
  import_log_id?: number;
  /** インポートされた仕入件数 */
  imported_count?: number;
  /** インポートされた明細件数 */
  imported_items_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

/**
 * 仕入明細用シリアライザー
 */
export interface PurchaseInvoiceItemRequest {
  /** @nullable */
  id?: number | null;
  /** @nullable */
  product_variation_id?: number | null;
  /**
   * @minLength 1
   * @maxLength 500
   */
  name: string;
  /**
   * @maxLength 50
   * @nullable
   */
  product_code?: string | null;
  /**
   * @maxLength 50
   * @nullable
   */
  model_number?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * @maxLength 100
   * @nullable
   */
  spec?: string | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  quantity?: string;
  /** @nullable */
  unit_id?: number | null;
  /** @pattern ^-?\d{0,8}(?:\.\d{0,2})?$ */
  snp?: string;
  /** @nullable */
  packaging_type_id?: number | null;
  /** @pattern ^-?\d{0,10}(?:\.\d{0,2})?$ */
  unit_price: string;
  tax_class?: TaxClassEnum;
  /**
   * @maxLength 250
   * @nullable
   */
  summary?: string | null;
  /**
   * 明細の表示順序。nullの場合はIDでソート
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  sort_order?: number | null;
}

/**
 * 仕入更新用シリアライザー
 *
 * 支払請求の取引先は支払先(pay_to)に一本化されているため、仕入先(supplier)は更新対象外。
 * 作成時に発注書から引き継いだ値をそのまま保持する。
 */
export interface PurchaseInvoiceUpdateRequest {
  /**
   * 案件ID（解除時はnull）
   * @nullable
   */
  project_id?: number | null;
  /** @nullable */
  pay_to?: number | null;
  purchase_date?: string;
  payment_due_date: string;
  tax_calculation_type?: TaxCalculationTypeEnum;
  /** @nullable */
  responsible_department_id?: number | null;
  notes?: string;
  internal_notes?: string;
  items?: PurchaseInvoiceItemRequest[];
}

/**
 * 発注書から仕入への一括変換用シリアライザー
 */
export interface PurchaseInvoiceBulkCreateFromPurchaseOrdersRequest {
  /**
   * 仕入に変換する発注書IDのリスト
   * @minItems 1
   */
  purchase_order_ids: number[];
}

export type PurchaseInvoiceBulkCreateFromPurchaseOrdersResponseSkippedDetailsItem = {
  [key: string]: unknown;
};

/**
 * 発注書から仕入への一括変換レスポンス用
 */
export interface PurchaseInvoiceBulkCreateFromPurchaseOrdersResponse {
  /** 仕入が作成された発注書IDのリスト */
  created_ids: number[];
  /** 作成された仕入IDのリスト（created_idsと同順） */
  purchase_invoice_ids: number[];
  /** スキップされた発注書IDのリスト */
  skipped_ids: number[];
  /** スキップ理由のリスト */
  skipped_details: PurchaseInvoiceBulkCreateFromPurchaseOrdersResponseSkippedDetailsItem[];
}

/**
 * 複数発注書から仕入への変換用シリアライザー
 */
export interface ConsolidatedPurchaseInvoiceCreateRequest {
  /**
   * まとめて仕入を作成する発注書IDのリスト
   * @minItems 1
   */
  purchase_order_ids: number[];
}

/**
 * 発注書から仕入への変換用シリアライザー
 */
export interface PurchaseOrderToPurchaseInvoiceRequest {
  /** 変換元の発注書ID */
  purchase_order_id: number;
}

export interface CustomerMonthlySales {
  /** 集計期間の年月(日は1日固定) */
  period: string;
  partner: number;
  /**
   * 該当期間の売上金額合計
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  total_amount?: string;
  /**
   * 該当期間の原価金額合計
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  total_cost?: string;
  /**
   * 粗利率(%)
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  gross_margin: string;
}

export interface CustomerMonthlySalesItem {
  /**
   * 売上合計金額
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  readonly total_amount: string;
  /**
   * 原価合計金額
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  readonly total_cost: string;
  /**
   * 粗利率(%)
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly gross_margin: string;
}

export interface CustomerMonthlySalesSummary {
  /** 取引先ID */
  readonly partner_id: number;
  /** 取引先名 */
  readonly partner_name: string;
  /**
   * 最新売上計上日
   * @nullable
   */
  readonly latest_order_date: string | null;
  /** 今年度の顧客別売上データ */
  readonly this_year: CustomerMonthlySalesItem | null;
  /** 前年度の顧客別売上データ */
  readonly last_year: CustomerMonthlySalesItem | null;
  /** 前々年度の顧客別売上データ */
  readonly two_years_ago: CustomerMonthlySalesItem | null;
}

export interface TopSalesProduct {
  /** 商品ID */
  readonly product_id: number;
  /** 商品名 */
  readonly product_name: string;
  /**
   * 売上金額合計
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  readonly total_amount: string;
  /**
   * 販売数量合計
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  readonly total_quantity: string;
}

export interface MonthlySales {
  readonly id: number;
  /** 集計期間の年月(日は1日固定) */
  period: string;
  /** @pattern ^-?\d{0,16}(?:\.\d{0,2})?$ */
  total_amount?: string;
}

export interface ProductMonthlySales {
  /** 集計期間の年月(日は1日固定) */
  period: string;
  product: number;
  /**
   * 該当期間の売上金額合計
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  total_amount?: string;
  /**
   * 該当期間の原価金額合計
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  total_cost?: string;
  /**
   * 販売数量合計
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  total_quantity: string;
  /**
   * 粗利率(%)
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  gross_margin: string;
}

export interface ProductMonthlySalesItem {
  /**
   * 売上合計金額
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  readonly total_amount: string;
  /**
   * 原価合計金額
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  readonly total_cost: string;
  /**
   * 販売数量合計
   * @pattern ^-?\d{0,16}(?:\.\d{0,2})?$
   */
  readonly total_quantity: string;
  /**
   * 粗利率(%)
   * @pattern ^-?\d{0,8}(?:\.\d{0,2})?$
   */
  readonly gross_margin: string;
}

export interface ProductMonthlySalesSummary {
  /** 商品ID */
  readonly product_id: number;
  /** 商品名 */
  readonly product_name: string;
  /**
   * 最新売上計上日
   * @nullable
   */
  readonly latest_order_date: string | null;
  /** 今年度の商品別売上データ */
  readonly this_year: ProductMonthlySalesItem | null;
  /** 前年度の商品別売上データ */
  readonly last_year: ProductMonthlySalesItem | null;
  /** 前々年度の商品別売上データ */
  readonly two_years_ago: ProductMonthlySalesItem | null;
}

/**
 * * `representative` - 代表
 * * `collaborative` - 共同研究
 */
export type ProjectTypeEnum = (typeof ProjectTypeEnum)[keyof typeof ProjectTypeEnum];

export const ProjectTypeEnum = {
  representative: 'representative',
  collaborative: 'collaborative',
} as const;

/**
 * 研究課題シリアライザー（詳細表示用）
 */
export interface ResearchProject {
  readonly id: number;
  researcher: number;
  project_name: string;
  /**
   * @maxLength 250
   * @nullable
   */
  organization_abbreviation?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  category?: string | null;
  project_type?: ProjectTypeEnum;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  total_allocation?: number | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  start_year?: number | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  end_year?: number | null;
  readonly created_at: string;
  readonly updated_at: string;
}

/**
 * 研究者情報シリアライザー（詳細表示用）
 */
export interface Researcher {
  readonly id: number;
  lead: number;
  /** @maxLength 100 */
  researcher_id: string;
  /**
   * @maxLength 250
   * @nullable
   */
  affiliation?: string | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  current_year_representative_fund?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  past_5years_representative_fund?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  representative_project_count?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  collaborative_project_count?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  amed_total_amount?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  total_holding_amount?: number | null;
  /**
   * @maxLength 250
   * @nullable
   */
  estimated_field?: string | null;
  /** @nullable */
  keywords?: string | null;
  readonly research_projects: readonly ResearchProject[];
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedResearcherList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: Researcher[];
}

/**
 * ネストされた研究課題用シリアライザー（researcher フィールドなし）
 */
export interface ResearchProjectNestedRequest {
  /** @minLength 1 */
  project_name: string;
  /**
   * @maxLength 250
   * @nullable
   */
  organization_abbreviation?: string | null;
  /**
   * @maxLength 250
   * @nullable
   */
  category?: string | null;
  project_type?: ProjectTypeEnum;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  total_allocation?: number | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  start_year?: number | null;
  /**
   * @minimum 0
   * @maximum 32767
   * @nullable
   */
  end_year?: number | null;
}

/**
 * 研究者情報の作成・更新用シリアライザー（研究課題も一括処理）
 */
export interface ResearcherCreateUpdateRequest {
  lead: number;
  /**
   * @minLength 1
   * @maxLength 100
   */
  researcher_id: string;
  /**
   * @maxLength 250
   * @nullable
   */
  affiliation?: string | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  current_year_representative_fund?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  past_5years_representative_fund?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  representative_project_count?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  collaborative_project_count?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  amed_total_amount?: number | null;
  /**
   * @minimum 0
   * @maximum 2147483647
   * @nullable
   */
  total_holding_amount?: number | null;
  /**
   * @maxLength 250
   * @nullable
   */
  estimated_field?: string | null;
  /** @nullable */
  keywords?: string | null;
  /** @nullable */
  research_projects?: ResearchProjectNestedRequest[] | null;
}

/**
 * * `overwrite` - 上書き
 * * `ignore` - 無視
 */
export type DuplicateActionEnum = (typeof DuplicateActionEnum)[keyof typeof DuplicateActionEnum];

export const DuplicateActionEnum = {
  overwrite: 'overwrite',
  ignore: 'ignore',
} as const;

/**
 * 研究者情報一括インポート用シリアライザ
 */
export interface ResearcherBulkImportRequest {
  /**
   * アップロードされたCSVファイルのオブジェクトキー
   * @minLength 1
   */
  object_key: string;
  /** CSVカラムとデータ項目のマッピング */
  mapping: unknown;
  /**
   * 重複データの処理方法
   *
   * * `overwrite` - 上書き
   * * `ignore` - 無視
   */
  duplicate_action?: DuplicateActionEnum;
}

/**
 * 研究者情報一括インポートレスポンス用のシリアライザ
 */
export interface ResearcherBulkImportResponse {
  /** 処理の成功/失敗 */
  success?: boolean;
  /** 新規登録された件数 */
  imported_count?: number;
  /** 更新された件数 */
  updated_count?: number;
  /** 処理対象の総行数 */
  total_rows?: number;
  /** エラー詳細 */
  row_errors?: BulkImportErrorDetail[];
  /** 処理結果のサマリーメッセージ */
  summary_message?: string;
}

export interface ResourceLink {
  /** 画面遷移先のリソースID */
  id: number;
  /**
   * 親商品ID（商品バリエーションの場合のみ設定）
   * @nullable
   */
  product_id: number | null;
}

export interface Shelf {
  readonly id: number;
  /** @maxLength 100 */
  name: string;
  location: number;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  area?: number | null;
  readonly created_at: string;
  readonly updated_at: string;
}

export interface PaginatedShelfList {
  count: number;
  /** @nullable */
  next?: string | null;
  /** @nullable */
  previous?: string | null;
  results: Shelf[];
}

export interface ShelfRequest {
  /**
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  location: number;
  /** @nullable */
  floor?: number | null;
  /** @nullable */
  area?: number | null;
}

/**
 * アニマルオフィス(OFFICEスコープ)のサインイン用シリアライザ
 *
 * ユーザー認証に加えて、有効な組織にOFFICEスコープで所属していることを検証する。
 * アクセストークンは長命なため、無効化済みの組織や所属にはトークンを発行しない。
 *
 * トークンの発行はここでは行わない。MFA が有効なユーザーにはコード入力を挟む必要があるため、
 * 認証済みユーザー(`self.user`)を受け取った view 側で MFA の要否を判定して発行する。
 */
export interface OfficeSignInRequest {
  /** @minLength 1 */
  username: string;
  /** @minLength 1 */
  password: string;
}

/**
 * * `MFA_REQUIRED` - MFA_REQUIRED
 */
export type CodeEnum = (typeof CodeEnum)[keyof typeof CodeEnum];

export const CodeEnum = {
  MFA_REQUIRED: 'MFA_REQUIRED',
} as const;

/**
 * サインインで MFA コードの入力が必要な場合の 401 レスポンス
 */
export interface MfaRequiredResponse {
  detail: string;
  code: CodeEnum;
  /** `/api/token/mfa` へコードと一緒に送る短命トークン */
  mfa_token: string;
}

/**
 * MFA コードを検証してトークンを発行するためのシリアライザ
 *
 * `mfa_token` の検証とユーザーの解決までを行い、コード自体の検証は view がサービスへ委譲する。
 */
export interface MfaTokenObtainRequest {
  /** @minLength 1 */
  mfa_token: string;
  /**
   * 認証アプリのコードまたはバックアップコード
   * @minLength 1
   * @maxLength 32
   */
  mfa_code: string;
}

export interface TokenRefreshRequest {
  /** @minLength 1 */
  refresh: string;
}

/**
 * サインイン中ユーザー自身のプロフィール用シリアライザ
 *
 * organization/roleはアニマルオフィス(OFFICEスコープ)の所属から解決する。
 * サポートアカウントのように複数組織に所属するユーザーで無効化済みの組織を返さないよう、
 * IsAuthenticatedOrganizationUserと同じ条件(所属・組織ともに有効)で絞り込む。
 */
export interface UserDetail {
  readonly id: number;
  /**
   * この項目は必須です。半角アルファベット、半角数字、@/./+/-/_ で150文字以下にしてください。
   * @maxLength 150
   * @pattern ^[\w.@+-]+$
   */
  username: string;
  email?: string;
  readonly organization: Organization;
  readonly role: UserRoleEnum;
  readonly name: string;
}

export type AccountTitleListParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type AccountsPayableSummaryListParams = {
  /**
   * 締めグループID（0は未設定）
   */
  closing_group_id?: number;
  /**
   * 当月支払残の上限
   */
  current_payment_balance_max?: number;
  /**
   * 当月支払残の下限
   */
  current_payment_balance_min?: number;
  /**
   * 当月支払額の上限
   */
  current_payment_max?: number;
  /**
   * 当月支払額の下限
   */
  current_payment_min?: number;
  /**
   * 当月仕入(税抜)の上限
   */
  current_purchase_subtotal_max?: number;
  /**
   * 当月仕入(税抜)の下限
   */
  current_purchase_subtotal_min?: number;
  /**
   * 当月仕入(税込)の上限
   */
  current_purchase_total_max?: number;
  /**
   * 当月仕入(税込)の下限
   */
  current_purchase_total_min?: number;
  /**
   * 部門IDリスト（カンマ区切り）
   */
  department_ids?: string;
  /**
   * 当月末残高の上限
   */
  ending_balance_max?: number;
  /**
   * 当月末残高の下限
   */
  ending_balance_min?: number;
  /**
   * 対象期間開始日（YYYY-MM-DD）
   */
  from_date: string;
  /**
   * ソート対象フィールド（先頭に - を付けると降順）。指定可能: pay_to_code, pay_to_name, previous_balance, current_payment, current_payment_balance, current_purchase_total, current_purchase_subtotal, ending_balance
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 支払先コード（部分一致）
   */
  pay_to_code?: string;
  /**
   * 支払先名（部分一致）
   */
  pay_to_name?: string;
  /**
   * 前月末残高の上限
   */
  previous_balance_max?: number;
  /**
   * 前月末残高の下限
   */
  previous_balance_min?: number;
  /**
   * 対象期間終了日（YYYY-MM-DD）
   */
  to_date: string;
};

export type AccountsPayableSsrmParams = {
  /**
   * 分類1のカテゴリID(カンマ区切りで複数指定可)
   */
  category_type_1?: string;
  /**
   * 分類1が未設定の支払先を含めるか(カテゴリID指定とは OR)
   */
  category_type_1_unassigned?: boolean;
  /**
   * 分類2のカテゴリID(カンマ区切りで複数指定可)
   */
  category_type_2?: string;
  /**
   * 分類2が未設定の支払先を含めるか(カテゴリID指定とは OR)
   */
  category_type_2_unassigned?: boolean;
  /**
   * 分類3のカテゴリID(カンマ区切りで複数指定可)
   */
  category_type_3?: string;
  /**
   * 分類3が未設定の支払先を含めるか(カテゴリID指定とは OR)
   */
  category_type_3_unassigned?: boolean;
  /**
   * 当月支払残の絞り込み値
   */
  current_payment_balance_filter?: number;
  /**
   * 当月支払残の絞り込み値(inRange の上限)
   */
  current_payment_balance_filter_to?: number;
  /**
   * 当月支払残のフィルタタイプ
   */
  current_payment_balance_filter_type?: AccountsPayableSsrmCurrentPaymentBalanceFilterType;
  /**
   * 当月支払額の絞り込み値
   */
  current_payment_filter?: number;
  /**
   * 当月支払額の絞り込み値(inRange の上限)
   */
  current_payment_filter_to?: number;
  /**
   * 当月支払額のフィルタタイプ
   */
  current_payment_filter_type?: AccountsPayableSsrmCurrentPaymentFilterType;
  /**
   * 当月仕入(税抜)の絞り込み値
   */
  current_purchase_subtotal_filter?: number;
  /**
   * 当月仕入(税抜)の絞り込み値(inRange の上限)
   */
  current_purchase_subtotal_filter_to?: number;
  /**
   * 当月仕入(税抜)のフィルタタイプ
   */
  current_purchase_subtotal_filter_type?: AccountsPayableSsrmCurrentPurchaseSubtotalFilterType;
  /**
   * 当月仕入(税込)の絞り込み値
   */
  current_purchase_total_filter?: number;
  /**
   * 当月仕入(税込)の絞り込み値(inRange の上限)
   */
  current_purchase_total_filter_to?: number;
  /**
   * 当月仕入(税込)のフィルタタイプ
   */
  current_purchase_total_filter_type?: AccountsPayableSsrmCurrentPurchaseTotalFilterType;
  /**
   * 消費税(10%)の絞り込み値
   */
  current_tax_10_filter?: number;
  /**
   * 消費税(10%)の絞り込み値(inRange の上限)
   */
  current_tax_10_filter_to?: number;
  /**
   * 消費税(10%)のフィルタタイプ
   */
  current_tax_10_filter_type?: AccountsPayableSsrmCurrentTax10FilterType;
  /**
   * 消費税(8%)の絞り込み値
   */
  current_tax_8_filter?: number;
  /**
   * 消費税(8%)の絞り込み値(inRange の上限)
   */
  current_tax_8_filter_to?: number;
  /**
   * 消費税(8%)のフィルタタイプ
   */
  current_tax_8_filter_type?: AccountsPayableSsrmCurrentTax8FilterType;
  /**
   * 部門IDリスト（カンマ区切り）
   */
  department_ids?: string;
  /**
   * 当月末残高の絞り込み値
   */
  ending_balance_filter?: number;
  /**
   * 当月末残高の絞り込み値(inRange の上限)
   */
  ending_balance_filter_to?: number;
  /**
   * 当月末残高のフィルタタイプ
   */
  ending_balance_filter_type?: AccountsPayableSsrmEndingBalanceFilterType;
  /**
   * 対象期間開始日（YYYY-MM-DD）。to_date との期間は120日以内
   */
  from_date: string;
  /**
   * 展開済みグループキーのJSON配列（空文字は未設定グループ）
   */
  group_keys?: string;
  /**
   * ソート対象フィールド（先頭に - を付けると降順）。指定可能: category_type_1, category_type_2, category_type_3, current_payment, current_payment_balance, current_purchase_subtotal, current_purchase_total, current_tax_10, current_tax_8, ending_balance, pay_to_code, pay_to_name, previous_balance
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 支払先コードの絞り込み値
   */
  pay_to_code?: string;
  /**
   * 支払先コードのフィルタタイプ(既定は contains)
   */
  pay_to_code_filter_type?: AccountsPayableSsrmPayToCodeFilterType;
  /**
   * 支払先名の絞り込み値
   */
  pay_to_name?: string;
  /**
   * 支払先名のフィルタタイプ(既定は contains)
   */
  pay_to_name_filter_type?: AccountsPayableSsrmPayToNameFilterType;
  /**
   * 前月末残高の絞り込み値
   */
  previous_balance_filter?: number;
  /**
   * 前月末残高の絞り込み値(inRange の上限)
   */
  previous_balance_filter_to?: number;
  /**
   * 前月末残高のフィルタタイプ
   */
  previous_balance_filter_type?: AccountsPayableSsrmPreviousBalanceFilterType;
  /**
   * グループ化カラムのJSON配列。指定可能: category_type_1, category_type_2, category_type_3
   */
  row_group_cols?: string;
  /**
   * 対象期間終了日（YYYY-MM-DD）。from_date との期間は120日以内
   */
  to_date: string;
};

export type AccountsPayableSsrmCurrentPaymentBalanceFilterType =
  (typeof AccountsPayableSsrmCurrentPaymentBalanceFilterType)[keyof typeof AccountsPayableSsrmCurrentPaymentBalanceFilterType];

export const AccountsPayableSsrmCurrentPaymentBalanceFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type AccountsPayableSsrmCurrentPaymentFilterType =
  (typeof AccountsPayableSsrmCurrentPaymentFilterType)[keyof typeof AccountsPayableSsrmCurrentPaymentFilterType];

export const AccountsPayableSsrmCurrentPaymentFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type AccountsPayableSsrmCurrentPurchaseSubtotalFilterType =
  (typeof AccountsPayableSsrmCurrentPurchaseSubtotalFilterType)[keyof typeof AccountsPayableSsrmCurrentPurchaseSubtotalFilterType];

export const AccountsPayableSsrmCurrentPurchaseSubtotalFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type AccountsPayableSsrmCurrentPurchaseTotalFilterType =
  (typeof AccountsPayableSsrmCurrentPurchaseTotalFilterType)[keyof typeof AccountsPayableSsrmCurrentPurchaseTotalFilterType];

export const AccountsPayableSsrmCurrentPurchaseTotalFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type AccountsPayableSsrmCurrentTax10FilterType =
  (typeof AccountsPayableSsrmCurrentTax10FilterType)[keyof typeof AccountsPayableSsrmCurrentTax10FilterType];

export const AccountsPayableSsrmCurrentTax10FilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type AccountsPayableSsrmCurrentTax8FilterType =
  (typeof AccountsPayableSsrmCurrentTax8FilterType)[keyof typeof AccountsPayableSsrmCurrentTax8FilterType];

export const AccountsPayableSsrmCurrentTax8FilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type AccountsPayableSsrmEndingBalanceFilterType =
  (typeof AccountsPayableSsrmEndingBalanceFilterType)[keyof typeof AccountsPayableSsrmEndingBalanceFilterType];

export const AccountsPayableSsrmEndingBalanceFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type AccountsPayableSsrmPayToCodeFilterType =
  (typeof AccountsPayableSsrmPayToCodeFilterType)[keyof typeof AccountsPayableSsrmPayToCodeFilterType];

export const AccountsPayableSsrmPayToCodeFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type AccountsPayableSsrmPayToNameFilterType =
  (typeof AccountsPayableSsrmPayToNameFilterType)[keyof typeof AccountsPayableSsrmPayToNameFilterType];

export const AccountsPayableSsrmPayToNameFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type AccountsPayableSsrmPreviousBalanceFilterType =
  (typeof AccountsPayableSsrmPreviousBalanceFilterType)[keyof typeof AccountsPayableSsrmPreviousBalanceFilterType];

export const AccountsPayableSsrmPreviousBalanceFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type AccountsPayableDetailParams = {
  /**
   * 対象期間開始日（YYYY-MM-DD）
   */
  from_date: string;
  /**
   * 対象期間終了日（YYYY-MM-DD）
   */
  to_date: string;
};

export type AccountsReceivableListParams = {
  /**
   * 締めグループID（0は未設定）
   */
  closing_group_id?: number;
  /**
   * 当月回収残の上限
   */
  current_collection_balance_max?: number;
  /**
   * 当月回収残の下限
   */
  current_collection_balance_min?: number;
  /**
   * 当月回収の上限
   */
  current_collection_max?: number;
  /**
   * 当月回収の下限
   */
  current_collection_min?: number;
  /**
   * 当月売上(税込)の上限
   */
  current_sales_with_tax_max?: number;
  /**
   * 当月売上(税込)の下限
   */
  current_sales_with_tax_min?: number;
  /**
   * 当月売上(税抜)の上限
   */
  current_sales_without_tax_max?: number;
  /**
   * 当月売上(税抜)の下限
   */
  current_sales_without_tax_min?: number;
  /**
   * 部署IDリスト（カンマ区切り、または複数指定）
   */
  department_ids?: string;
  /**
   * 当月末残高の上限
   */
  end_balance_max?: number;
  /**
   * 当月末残高の下限
   */
  end_balance_min?: number;
  /**
   * 期間開始日 (YYYY-MM-DD)
   */
  from_date: string;
  /**
   * ソート対象フィールド（先頭に - を付けると降順）。指定可能: previous_balance, current_collection, current_collection_balance, current_sales_with_tax, current_sales_without_tax, end_balance
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  /**
   * 得意先コード（部分一致）
   */
  partner_code?: string;
  /**
   * 得意先名（部分一致）
   */
  partner_name?: string;
  /**
   * 前月末残高の上限
   */
  previous_balance_max?: number;
  /**
   * 前月末残高の下限
   */
  previous_balance_min?: number;
  /**
   * 期間終了日 (YYYY-MM-DD)
   */
  to_date: string;
};

export type AccountsReceivableDetailParams = {
  /**
   * 対象期間開始日（YYYY-MM-DD）
   */
  from_date: string;
  /**
   * 対象期間終了日（YYYY-MM-DD）
   */
  to_date: string;
};

export type MemberInvitationValidateParams = {
  /**
   * 招待キー
   */
  invitation_key: string;
};

export type AreaListParams = {
  /**
   * ソート対象フィールド（例: name, -name, updated_at, -updated_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type AuditLogListParams = {
  /**
   * ログ種別。複数指定した場合はいずれかに一致するものを返す
   */
  log_type?: AuditLogTypeEnum[];
  /**
   * 記録日時の下限(この日時を含む)。日付のみ指定した場合は 00:00:00 として扱う
   */
  logged_at_from?: string;
  /**
   * 記録日時の上限(この日時を含む)。日付のみ指定した場合は 00:00:00 として扱う
   */
  logged_at_to?: string;
  /**
   * 記録日時の並び順
   *
   * * `logged_at` - logged_at
   * * `-logged_at` - -logged_at
   * @minLength 1
   */
  ordering?: AuditLogListOrdering;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type AuditLogListOrdering = (typeof AuditLogListOrdering)[keyof typeof AuditLogListOrdering];

export const AuditLogListOrdering = {
  logged_at: 'logged_at',
  '-logged_at': '-logged_at',
} as const;

export type BankAccountListParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type NotesTemplateListParams = {
  /**
   * 対象帳票タイプで絞り込む
   */
  document_type?: NotesTemplateDocumentTypeEnum;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type DocumentTemplateListParams = {
  /**
   * 帳票タイプ（必須）
   */
  document_type: DocumentTypeEnum;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type OfficeEdiPurchaseOrderListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  status?: string;
};

export type OfficeEdiPurchaseOrderConfirm200 = {
  confirmed_count?: number;
};

export type ExternalIntegrationsAmazonSpConnectionsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ExternalIntegrationsBaseConnectionsListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type BaseOauthStartParams = {
  /**
   * 再連携時の既存接続ID。指定した場合、OAuthで取得したshop_idが一致しない場合はエラーになる。
   */
  connection_id?: number;
};

export type FloorListParams = {
  /**
   * ソート対象フィールド（例: name, -name, updated_at, -updated_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type IncomingPaymentsListParams = {
  /**
   * 勘定科目（部分一致）
   */
  account_title_name?: string;
  /**
   * 銀行（振込先口座名・部分一致）
   */
  bank_account_name?: string;
  /**
   * 部門名（部分一致）
   */
  department_name?: string;
  /**
   * 入金額（最大）
   */
  max_amount?: string;
  /**
   * 入金額（最小）
   */
  min_amount?: string;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  /**
   * 得意先名（部分一致）
   */
  partner_name?: string;
  /**
   * 入金日（開始, YYYY-MM-DD）
   */
  payment_date_from?: string;
  /**
   * 入金日（終了, YYYY-MM-DD）
   */
  payment_date_to?: string;
  /**
   * 決済方法ID
   */
  payment_method_id?: number;
  /**
   * 入金No.（部分一致）
   */
  payment_no?: string;
  /**
   * 担当者ID
   */
  responsible_person_id?: number;
  /**
   * 消込ステータスフィルタ（カンマ区切りで複数指定可能）
   */
  status?: string;
  /**
   * 摘要（部分一致）
   */
  summary?: string;
};

export type InventoryItemHistoryListParams = {
  /**
   * 事業所（倉庫）IDで絞り込み。未指定の場合は本社(can_delete=False)を使用
   */
  location_id?: number;
  /**
   * ロットIDで絞り込み(ロット管理商品のみ。指定時の変動後数量はそのロットの残高)
   */
  lot_id?: number;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品バリエーションIDで絞り込み（必須）
   */
  product_variation_id: number;
};

export type InventoryItemImportLogsListParams = {
  /**
   * インポート対象のロケーションID
   */
  location_id: number;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type InventoryItemInitializeBulkImportParams = {
  /**
   * インポート対象のロケーションID
   */
  location_id: number;
};

export type InventoryItemListParams = {
  /**
   * エリア名で部分一致検索（location_id指定時のみ有効）
   */
  area_name?: string;
  /**
   * 商品分類1（CategoryMaster ID）でフィルタ
   */
  category_type_1?: number;
  /**
   * 商品分類2（CategoryMaster ID）でフィルタ
   */
  category_type_2?: number;
  /**
   * 商品分類3（CategoryMaster ID）でフィルタ
   */
  category_type_3?: number;
  /**
   * フロア名で部分一致検索（location_id指定時のみ有効）
   */
  floor_name?: string;
  /**
   * 事業所（倉庫）IDで絞り込み。指定がない場合は商品バリエーション単位で集約
   */
  location_id?: number;
  /**
   * 計算在庫の最大値
   */
  max_calculated_stock?: number;
  /**
   * 現在庫数の最大値
   */
  max_current_quantity?: number;
  /**
   * 在庫価値の最大値
   */
  max_inventory_value?: number;
  /**
   * 安全在庫数の最大値
   */
  max_safety_stock?: number;
  /**
   * 予定在庫数の最大値
   */
  max_scheduled_quantity?: number;
  /**
   * 入庫予定数の最大値
   */
  max_scheduled_receiving_quantity?: number;
  /**
   * 出庫予定数の最大値
   */
  max_scheduled_shipment_quantity?: number;
  /**
   * 在庫評価額の最大値
   */
  max_valuation_amount?: number;
  /**
   * 計算在庫の最小値
   */
  min_calculated_stock?: number;
  /**
   * 現在庫数の最小値
   */
  min_current_quantity?: number;
  /**
   * 在庫価値の最小値
   */
  min_inventory_value?: number;
  /**
   * 安全在庫数の最小値
   */
  min_safety_stock?: number;
  /**
   * 予定在庫数の最小値
   */
  min_scheduled_quantity?: number;
  /**
   * 入庫予定数の最小値
   */
  min_scheduled_receiving_quantity?: number;
  /**
   * 出庫予定数の最小値
   */
  min_scheduled_shipment_quantity?: number;
  /**
   * 在庫評価額の最小値
   */
  min_valuation_amount?: number;
  /**
   * ソート対象フィールド（先頭に `-` を付けると降順）。
   * 未指定時は商品バリエーション一覧と同じ既定順（商品ID降順 → 表示順降順 → 商品バリエーションID降順）。
   * サポートフィールド:
   * - product_variation_name
   * - product_code
   * - supplier_name
   * - current_quantity / scheduled_receiving_quantity / scheduled_shipment_quantity / scheduled_quantity
   * - inventory_value / valuation_amount
   * - safety_stock / calculated_stock
   * - category_type_1 / category_type_2 / category_type_3
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品コードで部分一致検索
   */
  product_code?: string;
  /**
   * 商品バリエーションIDでフィルタ（カンマ区切りで複数指定可能）
   */
  product_variation_ids?: string;
  /**
   * 商品バリエーション名で部分一致検索
   */
  product_variation_name?: string;
  /**
   * 棚番名で部分一致検索（location_id指定時のみ有効）
   */
  shelf_name?: string;
  /**
   * 仕入先名で部分一致検索
   */
  supplier_name?: string;
};

export type InventoryItemHistoricalListParams = {
  /**
   * 事業所（倉庫）ID
   */
  location_id: number;
  /**
   * 最大在庫数でフィルタ
   */
  max_historical_quantity?: number;
  /**
   * 最大在庫価値でフィルタ
   */
  max_inventory_value?: number;
  /**
   * 最大安全在庫数でフィルタ
   */
  max_safety_stock?: number;
  /**
   * 最大在庫評価額でフィルタ
   */
  max_valuation_amount?: number;
  /**
   * 最小在庫数でフィルタ
   */
  min_historical_quantity?: number;
  /**
   * 最小在庫価値でフィルタ
   */
  min_inventory_value?: number;
  /**
   * 最小安全在庫数でフィルタ
   */
  min_safety_stock?: number;
  /**
   * 最小在庫評価額でフィルタ
   */
  min_valuation_amount?: number;
  /**
   * ソート対象フィールド（例: product_variation_name, -product_variation_name, product_code, -product_code, supplier_name, -supplier_name, historical_quantity, -historical_quantity, inventory_value, -inventory_value, valuation_amount, -valuation_amount）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品コードで部分一致検索
   */
  product_code?: string;
  /**
   * 商品バリエーション名で部分一致検索
   */
  product_variation_name?: string;
  /**
   * 仕入先名で部分一致検索
   */
  supplier_name?: string;
  /**
   * 評価基準日（YYYY-MM-DD形式）
   */
  valuation_date: string;
};

export type InventoryItemHistoricalSummaryParams = {
  /**
   * 事業所（倉庫）ID
   */
  location_id: number;
  /**
   * 最大在庫数でフィルタ
   */
  max_historical_quantity?: number;
  /**
   * 最大在庫価値でフィルタ
   */
  max_inventory_value?: number;
  /**
   * 最大安全在庫数でフィルタ
   */
  max_safety_stock?: number;
  /**
   * 最大在庫評価額でフィルタ
   */
  max_valuation_amount?: number;
  /**
   * 最小在庫数でフィルタ
   */
  min_historical_quantity?: number;
  /**
   * 最小在庫価値でフィルタ
   */
  min_inventory_value?: number;
  /**
   * 最小安全在庫数でフィルタ
   */
  min_safety_stock?: number;
  /**
   * 最小在庫評価額でフィルタ
   */
  min_valuation_amount?: number;
  /**
   * 商品コードで部分一致検索
   */
  product_code?: string;
  /**
   * 商品バリエーション名で部分一致検索
   */
  product_variation_name?: string;
  /**
   * 仕入先名で部分一致検索
   */
  supplier_name?: string;
  /**
   * 評価基準日（YYYY-MM-DD形式）
   */
  valuation_date: string;
};

export type InventoryItemSummaryParams = {
  /**
   * エリア名で部分一致検索（location_id指定時のみ有効）
   */
  area_name?: string;
  /**
   * フロア名で部分一致検索（location_id指定時のみ有効）
   */
  floor_name?: string;
  /**
   * 事業所（倉庫）IDで絞り込み。指定がない場合は商品バリエーション単位で集約
   */
  location_id?: number;
  /**
   * 計算在庫の最大値
   */
  max_calculated_stock?: number;
  /**
   * 現在庫数の最大値
   */
  max_current_quantity?: number;
  /**
   * 在庫価値の最大値
   */
  max_inventory_value?: number;
  /**
   * 安全在庫数の最大値
   */
  max_safety_stock?: number;
  /**
   * 予定在庫数の最大値
   */
  max_scheduled_quantity?: number;
  /**
   * 入庫予定数の最大値
   */
  max_scheduled_receiving_quantity?: number;
  /**
   * 出庫予定数の最大値
   */
  max_scheduled_shipment_quantity?: number;
  /**
   * 在庫評価額の最大値
   */
  max_valuation_amount?: number;
  /**
   * 計算在庫の最小値
   */
  min_calculated_stock?: number;
  /**
   * 現在庫数の最小値
   */
  min_current_quantity?: number;
  /**
   * 在庫価値の最小値
   */
  min_inventory_value?: number;
  /**
   * 安全在庫数の最小値
   */
  min_safety_stock?: number;
  /**
   * 予定在庫数の最小値
   */
  min_scheduled_quantity?: number;
  /**
   * 入庫予定数の最小値
   */
  min_scheduled_receiving_quantity?: number;
  /**
   * 出庫予定数の最小値
   */
  min_scheduled_shipment_quantity?: number;
  /**
   * 在庫評価額の最小値
   */
  min_valuation_amount?: number;
  /**
   * 商品コードで部分一致検索
   */
  product_code?: string;
  /**
   * 商品バリエーション名で部分一致検索
   */
  product_variation_name?: string;
  /**
   * 棚番名で部分一致検索（location_id指定時のみ有効）
   */
  shelf_name?: string;
  /**
   * 仕入先名で部分一致検索
   */
  supplier_name?: string;
};

export type InventoryItemWarehouseStockParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 対象の商品バリエーションID
   */
  product_variation_id: number;
};

export type InventoryScheduledReceivingListParams = {
  /**
   * 商品バリエーションIDで絞り込み
   */
  product_variation_id: number;
};

export type InventoryScheduledShipmentListParams = {
  /**
   * 商品バリエーションIDで絞り込み
   */
  product_variation_id: number;
};

export type StockAdjustmentItemListParams = {
  /**
   * 調整日の絞り込みタイプ(AG Grid 日付フィルタ)。equals=単日(adjusted_at_from), lessThan=より前(基準日を含まない), greaterThan=より後(基準日を含まない), inRange=範囲(adjusted_at_from〜adjusted_at_to)。未指定時は adjusted_at_from/adjusted_at_to の inclusive 範囲。
   */
  adjusted_at_filter_type?: StockAdjustmentItemListAdjustedAtFilterType;
  /**
   * 調整日の開始日でフィルタリング (YYYY-MM-DD)
   */
  adjusted_at_from?: string;
  /**
   * 調整日の終了日でフィルタリング (YYYY-MM-DD)
   */
  adjusted_at_to?: string;
  /**
   * 処理内容で絞り込み（カンマ区切りで複数指定可能。値: STOCK_IN, STOCK_OUT, LOCATION_TRANSFER, STOCKTAKING）
   */
  adjustment_type?: string;
  /**
   * 金額でフィルタリング(inRange 時の下限)
   */
  amount?: number;
  /**
   * 金額フィルタの種別(AG Grid 数値フィルタ。未指定は equals 扱い)
   */
  amount_filter_type?: StockAdjustmentItemListAmountFilterType;
  /**
   * 金額の上限でフィルタリング(inRange 時の上限)
   */
  amount_to?: number;
  /**
   * 相手先倉庫IDで絞り込み（カンマ区切りで複数指定可能）
   */
  destination_location_id?: string;
  /**
   * 相手先倉庫未選択(NULL)を対象に含めるか(true 指定時。IDとはOR)
   */
  destination_location_unassigned?: boolean;
  /**
   * 倉庫IDで絞り込み（カンマ区切りで複数指定可能）
   */
  location_id?: string;
  /**
   * 商品名で絞り込み（部分一致）
   */
  name?: string;
  /**
   * 商品名の空白/空白でない絞り込み(blank=空白, notBlank=空白でない。部分一致は name を指定)
   */
  name_filter_type?: StockAdjustmentItemListNameFilterType;
  /**
   * 在庫調整No.で絞り込み（部分一致）
   */
  number?: string;
  /**
   * ソートキー（先頭の '-' で降順）
   */
  ordering?: StockAdjustmentItemListOrdering;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品コードで絞り込み（部分一致）
   */
  product_code?: string;
  /**
   * 商品コードの空白/空白でない絞り込み(blank=空白, notBlank=空白でない。部分一致は product_code を指定)
   */
  product_code_filter_type?: StockAdjustmentItemListProductCodeFilterType;
  /**
   * 数量でフィルタリング(inRange 時の下限)
   */
  quantity?: number;
  /**
   * 数量フィルタの種別(AG Grid 数値フィルタ。未指定は equals 扱い)
   */
  quantity_filter_type?: StockAdjustmentItemListQuantityFilterType;
  /**
   * 数量の上限でフィルタリング(inRange 時の上限)
   */
  quantity_to?: number;
  /**
   * 理由で絞り込み（部分一致）
   */
  reason?: string;
  /**
   * 理由の空白/空白でない絞り込み(blank=空白, notBlank=空白でない。部分一致は reason を指定)
   */
  reason_filter_type?: StockAdjustmentItemListReasonFilterType;
  /**
   * 部門IDで絞り込み（カンマ区切りで複数指定可能）
   */
  responsible_department_id?: string;
  /**
   * 部門未選択(NULL)を対象に含めるか(true 指定時。IDとはOR)
   */
  responsible_department_unassigned?: boolean;
  /**
   * 担当者IDで絞り込み（カンマ区切りで複数指定可能）
   */
  responsible_person_id?: string;
  /**
   * 入数でフィルタリング(inRange 時の下限)
   */
  snp?: number;
  /**
   * 入数フィルタの種別(AG Grid 数値フィルタ。未指定は equals 扱い)
   */
  snp_filter_type?: StockAdjustmentItemListSnpFilterType;
  /**
   * 入数の上限でフィルタリング(inRange 時の上限)
   */
  snp_to?: number;
  /**
   * 規格で絞り込み（部分一致）
   */
  spec?: string;
  /**
   * 規格の空白/空白でない絞り込み(blank=空白, notBlank=空白でない。部分一致は spec を指定)
   */
  spec_filter_type?: StockAdjustmentItemListSpecFilterType;
  /**
   * ステータスで絞り込み（カンマ区切りで複数指定可能）
   */
  status?: string;
  /**
   * 単位で絞り込み（部分一致）
   */
  unit_name?: string;
  /**
   * 単位の空白/空白でない絞り込み(blank=空白, notBlank=空白でない。部分一致は unit_name を指定)
   */
  unit_name_filter_type?: StockAdjustmentItemListUnitNameFilterType;
  /**
   * 単価でフィルタリング(inRange 時の下限)
   */
  unit_price?: number;
  /**
   * 単価フィルタの種別(AG Grid 数値フィルタ。未指定は equals 扱い)
   */
  unit_price_filter_type?: StockAdjustmentItemListUnitPriceFilterType;
  /**
   * 単価の上限でフィルタリング(inRange 時の上限)
   */
  unit_price_to?: number;
};

export type StockAdjustmentItemListAdjustedAtFilterType =
  (typeof StockAdjustmentItemListAdjustedAtFilterType)[keyof typeof StockAdjustmentItemListAdjustedAtFilterType];

export const StockAdjustmentItemListAdjustedAtFilterType = {
  equals: 'equals',
  greaterThan: 'greaterThan',
  inRange: 'inRange',
  lessThan: 'lessThan',
} as const;

export type StockAdjustmentItemListAmountFilterType =
  (typeof StockAdjustmentItemListAmountFilterType)[keyof typeof StockAdjustmentItemListAmountFilterType];

export const StockAdjustmentItemListAmountFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type StockAdjustmentItemListNameFilterType =
  (typeof StockAdjustmentItemListNameFilterType)[keyof typeof StockAdjustmentItemListNameFilterType];

export const StockAdjustmentItemListNameFilterType = {
  blank: 'blank',
  notBlank: 'notBlank',
} as const;

export type StockAdjustmentItemListOrdering =
  (typeof StockAdjustmentItemListOrdering)[keyof typeof StockAdjustmentItemListOrdering];

export const StockAdjustmentItemListOrdering = {
  '-adjusted_at': '-adjusted_at',
  '-adjustment_type': '-adjustment_type',
  '-amount': '-amount',
  '-destination_location_name': '-destination_location_name',
  '-location_name': '-location_name',
  '-name': '-name',
  '-number': '-number',
  '-product_code': '-product_code',
  '-quantity': '-quantity',
  '-responsible_department_name': '-responsible_department_name',
  '-responsible_person_name': '-responsible_person_name',
  '-snp': '-snp',
  '-unit_name': '-unit_name',
  '-unit_price': '-unit_price',
  adjusted_at: 'adjusted_at',
  adjustment_type: 'adjustment_type',
  amount: 'amount',
  destination_location_name: 'destination_location_name',
  location_name: 'location_name',
  name: 'name',
  number: 'number',
  product_code: 'product_code',
  quantity: 'quantity',
  responsible_department_name: 'responsible_department_name',
  responsible_person_name: 'responsible_person_name',
  snp: 'snp',
  unit_name: 'unit_name',
  unit_price: 'unit_price',
} as const;

export type StockAdjustmentItemListProductCodeFilterType =
  (typeof StockAdjustmentItemListProductCodeFilterType)[keyof typeof StockAdjustmentItemListProductCodeFilterType];

export const StockAdjustmentItemListProductCodeFilterType = {
  blank: 'blank',
  notBlank: 'notBlank',
} as const;

export type StockAdjustmentItemListQuantityFilterType =
  (typeof StockAdjustmentItemListQuantityFilterType)[keyof typeof StockAdjustmentItemListQuantityFilterType];

export const StockAdjustmentItemListQuantityFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type StockAdjustmentItemListReasonFilterType =
  (typeof StockAdjustmentItemListReasonFilterType)[keyof typeof StockAdjustmentItemListReasonFilterType];

export const StockAdjustmentItemListReasonFilterType = {
  blank: 'blank',
  notBlank: 'notBlank',
} as const;

export type StockAdjustmentItemListSnpFilterType =
  (typeof StockAdjustmentItemListSnpFilterType)[keyof typeof StockAdjustmentItemListSnpFilterType];

export const StockAdjustmentItemListSnpFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type StockAdjustmentItemListSpecFilterType =
  (typeof StockAdjustmentItemListSpecFilterType)[keyof typeof StockAdjustmentItemListSpecFilterType];

export const StockAdjustmentItemListSpecFilterType = {
  blank: 'blank',
  notBlank: 'notBlank',
} as const;

export type StockAdjustmentItemListUnitNameFilterType =
  (typeof StockAdjustmentItemListUnitNameFilterType)[keyof typeof StockAdjustmentItemListUnitNameFilterType];

export const StockAdjustmentItemListUnitNameFilterType = {
  blank: 'blank',
  notBlank: 'notBlank',
} as const;

export type StockAdjustmentItemListUnitPriceFilterType =
  (typeof StockAdjustmentItemListUnitPriceFilterType)[keyof typeof StockAdjustmentItemListUnitPriceFilterType];

export const StockAdjustmentItemListUnitPriceFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type StockAdjustmentListParams = {
  /**
   * 調整日の開始日でフィルタリング (YYYY-MM-DD)
   */
  adjusted_at_from?: string;
  /**
   * 調整日の終了日でフィルタリング (YYYY-MM-DD)
   */
  adjusted_at_to?: string;
  /**
   * 処理内容で絞り込み
   */
  adjustment_type?: string;
  /**
   * カスタム項目での検索（項目種別により完全一致または部分一致）。Nはproperty_type番号（1以上）。例: custom_property_1=検索値
   */
  'custom_property_{N}'?: string;
  /**
   * 相手先倉庫IDで絞り込み
   */
  destination_location_id?: number;
  /**
   * 倉庫IDで絞り込み
   */
  location_id?: number;
  /**
   * 在庫調整No.で絞り込み（部分一致）
   */
  number?: string;
  /**
   * ソート対象フィールド（例: number, -number, adjusted_at, -adjusted_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 理由で絞り込み（部分一致）
   */
  reason?: string;
  /**
   * 部門IDで絞り込み
   */
  responsible_department_id?: number;
  /**
   * 担当者名で絞り込み（部分一致）
   */
  responsible_person_name?: string;
  /**
   * ステータスで絞り込み（カンマ区切りで複数指定可能）
   */
  status?: string;
};

export type StockTakingImportLogsListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type StockTakingListParams = {
  /**
   * 完了日の開始日でフィルタリング (YYYY-MM-DD)
   */
  completed_at_from?: string;
  /**
   * 完了日の終了日でフィルタリング (YYYY-MM-DD)
   */
  completed_at_to?: string;
  /**
   * 作成日の開始日でフィルタリング (YYYY-MM-DD)
   */
  created_at_from?: string;
  /**
   * 作成日の終了日でフィルタリング (YYYY-MM-DD)
   */
  created_at_to?: string;
  /**
   * 倉庫IDで絞り込み
   */
  location_id?: number;
  /**
   * ソート対象フィールド（例: id, -id, created_at, -created_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 棚卸理由で絞り込み（部分一致）
   */
  reason?: string;
  /**
   * ステータスで絞り込み
   */
  status?: string;
  /**
   * 棚卸No.で絞り込み（部分一致）
   */
  stocktaking_number?: string;
};

export type StockTakingListItemsParams = {
  /**
   * 実在庫数の最大値でフィルタリング
   */
  actual_quantity_max?: string;
  /**
   * 実在庫数の最小値でフィルタリング
   */
  actual_quantity_min?: string;
  /**
   * 現在庫数の最大値でフィルタリング
   */
  current_quantity_max?: string;
  /**
   * 現在庫数の最小値でフィルタリング
   */
  current_quantity_min?: string;
  /**
   * 差分の最大値でフィルタリング
   */
  difference_max?: string;
  /**
   * 差分の最小値でフィルタリング
   */
  difference_min?: string;
  /**
   * ソート対象フィールド（例: id, -id, product_variation__product_code, -product_variation__product_code, product_variation__variation_name, -product_variation__variation_name, current_quantity, -current_quantity, actual_quantity, -actual_quantity, difference, -difference, created_at, -created_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品コードで絞り込み（部分一致）
   */
  product_code?: string;
  /**
   * 商品名で絞り込み（部分一致）
   */
  product_variation_name?: string;
};

export type StockTakingBarcodeSearchParams = {
  /**
   * バーコード値（JANコードまたは商品コード）
   */
  code: string;
  /**
   * 在庫数を取得する倉庫ID
   */
  location_id: number;
  /**
   * 既存の棚卸明細を判定する棚卸ID
   */
  stock_taking_id?: number;
};

export type InvoiceExportSettingListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type InvoiceImportLogsListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type InvoiceTagListParams = {
  /**
   * タグ名での検索（部分一致）
   */
  name?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type InvoiceListParams = {
  /**
   * 消込ステータスでフィルタリング
   */
  allocation_status?: AllocationStatusEnum;
  /**
   * 請求先の取引先IDでの検索
   */
  bill_to_id?: number;
  /**
   * 請求先名での部分一致検索
   */
  bill_to_name?: string;
  /**
   * カスタム項目での検索（項目種別により完全一致または部分一致）。Nはproperty_type番号（1以上）。例: custom_property_1=検索値
   */
  'custom_property_{N}'?: string;
  /**
   * 得意先の取引先IDでの検索
   */
  customer_id?: number;
  /**
   * 得意先名での部分一致検索
   */
  customer_name?: string;
  /**
   * 支払期限の開始日でフィルタリング (YYYY-MM-DD)
   */
  due_date_from?: string;
  /**
   * 支払期限の終了日でフィルタリング (YYYY-MM-DD)
   */
  due_date_to?: string;
  /**
   * 案件に紐付き済みの請求書を除外するかどうか
   */
  exclude_project_linked?: boolean;
  /**
   * 発行日の開始日でフィルタリング (YYYY-MM-DD)
   */
  from_date?: string;
  /**
   * 対応ステータスでフィルタリング（all: すべて, in_progress: 対応中, completed: 対応済）
   */
  handling_status?: InvoiceListHandlingStatus;
  /**
   * 未入金額が0より大きい請求書のみを返す
   */
  has_unallocated_amount?: boolean;
  /**
   * 請求書番号での部分一致検索
   */
  invoice_number?: string;
  /**
   * 三井住友区分での絞り込み（true/false）。出力先取引先（請求先があれば請求先、なければ得意先）の請求設定で判定する。falseは区分ONでない請求書（請求設定なしを含む）を返す
   */
  is_smbc_billing?: boolean;
  /**
   * 消込金額の最大値でフィルタリング
   */
  max_allocated_amount?: string;
  /**
   * 合計金額の最大値でフィルタリング
   */
  max_amount?: string;
  /**
   * 小計（税抜き金額）の最大値でフィルタリング
   */
  max_subtotal?: string;
  /**
   * 差額（未消込金額）の最大値でフィルタリング
   */
  max_unallocated_amount?: string;
  /**
   * 消込金額の最小値でフィルタリング
   */
  min_allocated_amount?: string;
  /**
   * 合計金額の最小値でフィルタリング
   */
  min_amount?: string;
  /**
   * 小計（税抜き金額）の最小値でフィルタリング
   */
  min_subtotal?: string;
  /**
   * 差額（未消込金額）の最小値でフィルタリング
   */
  min_unallocated_amount?: string;
  /**
   * ソート対象フィールド（例: id, -id, invoice_number, -invoice_number, issue_date, -issue_date, due_date, -due_date, total_amount, -total_amount, subtotal, -subtotal, status, -status, allocated_amount, -allocated_amount, unallocated_amount, -unallocated_amount, allocation_status_order, -allocation_status_order）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 取引先または請求先の取引先IDでの検索（OR条件）
   */
  partner_id?: number;
  /**
   * 決済方法IDでフィルタリング
   */
  payment_method_id?: number;
  /**
   * 商品IDでフィルター（請求明細に含まれる商品のID）
   */
  product_id?: number;
  /**
   * 案件IDでフィルタリング
   */
  project_id?: number;
  /**
   * 案件名での部分一致検索
   */
  project_name?: string;
  /**
   * 部門IDでフィルタリング
   */
  responsible_department?: number;
  /**
   * ステータスでフィルタリング
   */
  status?: InvoiceStatusEnum;
  /**
   * タグ名での検索（部分一致）
   */
  tag_name?: string;
  /**
   * 件名での部分一致検索
   */
  title?: string;
  /**
   * 発行日の終了日でフィルタリング (YYYY-MM-DD)
   */
  to_date?: string;
};

export type InvoiceListHandlingStatus =
  (typeof InvoiceListHandlingStatus)[keyof typeof InvoiceListHandlingStatus];

export const InvoiceListHandlingStatus = {
  all: 'all',
  completed: 'completed',
  in_progress: 'in_progress',
} as const;

export type InvoiceEmailLogsParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type InvoicePaymentSummariesParams = {
  /**
   * 請求書IDのリスト(カンマ区切り、または複数指定)。最大100件
   */
  ids: string;
};

export type InvoiceSummaryParams = {
  /**
   * 消込ステータスでフィルタリング
   */
  allocation_status?: AllocationStatusEnum;
  /**
   * 請求先の取引先IDでの検索
   */
  bill_to_id?: number;
  /**
   * 請求先名での部分一致検索
   */
  bill_to_name?: string;
  /**
   * カスタム項目での検索（項目種別により完全一致または部分一致）。Nはproperty_type番号（1以上）。例: custom_property_1=検索値
   */
  'custom_property_{N}'?: string;
  /**
   * 得意先名での部分一致検索
   */
  customer_name?: string;
  /**
   * 支払期限の開始日でフィルタリング (YYYY-MM-DD)
   */
  due_date_from?: string;
  /**
   * 支払期限の終了日でフィルタリング (YYYY-MM-DD)
   */
  due_date_to?: string;
  /**
   * 案件に紐付き済みの請求書を除外するかどうか
   */
  exclude_project_linked?: boolean;
  /**
   * 発行日の開始日でフィルタリング (YYYY-MM-DD)
   */
  from_date?: string;
  /**
   * 対応ステータスでフィルタリング（all: すべて, in_progress: 対応中, completed: 対応済）
   */
  handling_status?: InvoiceSummaryHandlingStatus;
  /**
   * 未入金額が0より大きい請求書のみを返す
   */
  has_unallocated_amount?: boolean;
  /**
   * 請求書番号での部分一致検索
   */
  invoice_number?: string;
  /**
   * 三井住友区分での絞り込み（true/false）。出力先取引先（請求先があれば請求先、なければ得意先）の請求設定で判定する。falseは区分ONでない請求書（請求設定なしを含む）を返す
   */
  is_smbc_billing?: boolean;
  /**
   * 消込金額の最大値でフィルタリング
   */
  max_allocated_amount?: string;
  /**
   * 合計金額の最大値でフィルタリング
   */
  max_amount?: string;
  /**
   * 小計（税抜き金額）の最大値でフィルタリング
   */
  max_subtotal?: string;
  /**
   * 差額（未消込金額）の最大値でフィルタリング
   */
  max_unallocated_amount?: string;
  /**
   * 消込金額の最小値でフィルタリング
   */
  min_allocated_amount?: string;
  /**
   * 合計金額の最小値でフィルタリング
   */
  min_amount?: string;
  /**
   * 小計（税抜き金額）の最小値でフィルタリング
   */
  min_subtotal?: string;
  /**
   * 差額（未消込金額）の最小値でフィルタリング
   */
  min_unallocated_amount?: string;
  /**
   * 取引先または請求先の取引先IDでの検索（OR条件）
   */
  partner_id?: number;
  /**
   * 決済方法IDでフィルタリング
   */
  payment_method_id?: number;
  /**
   * 商品IDでフィルター（請求明細に含まれる商品のID）
   */
  product_id?: number;
  /**
   * 案件IDでフィルタリング
   */
  project_id?: number;
  /**
   * 案件名での部分一致検索
   */
  project_name?: string;
  /**
   * 部門IDでフィルタリング
   */
  responsible_department?: number;
  /**
   * ステータスでフィルタリング
   */
  status?: InvoiceStatusEnum;
  /**
   * 件名での部分一致検索
   */
  title?: string;
  /**
   * 発行日の終了日でフィルタリング (YYYY-MM-DD)
   */
  to_date?: string;
};

export type InvoiceSummaryHandlingStatus =
  (typeof InvoiceSummaryHandlingStatus)[keyof typeof InvoiceSummaryHandlingStatus];

export const InvoiceSummaryHandlingStatus = {
  all: 'all',
  completed: 'completed',
  in_progress: 'in_progress',
} as const;

export type JapanpostZipcodeLookupParams = {
  /**
   * 郵便番号
   */
  zip_code: string;
};

export type LocationListParams = {
  /**
   * ソート対象フィールド（例: name, -name, updated_at, -updated_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ManufacturingOrderCustomPropertyListParams = {
  /**
   * 有効/無効でフィルタリング
   */
  is_active?: boolean;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ManufacturingOrderListParams = {
  /**
   * 作成日の開始日でフィルタ (YYYY-MM-DD)
   */
  created_date_from?: string;
  /**
   * 作成日の終了日でフィルタ (YYYY-MM-DD)
   */
  created_date_to?: string;
  /**
   * 完了予定日の開始日でフィルタ (YYYY-MM-DD)
   */
  expected_completion_date_from?: string;
  /**
   * 完了予定日の終了日でフィルタ (YYYY-MM-DD)
   */
  expected_completion_date_to?: string;
  /**
   * 倉庫IDでフィルタ
   */
  location_id?: number;
  /**
   * 生産番号での部分一致検索
   */
  manufacturing_number?: string;
  /**
   * 生産数量の最大値でフィルタ
   */
  max_quantity?: string;
  /**
   * 生産数量の最小値でフィルタ
   */
  min_quantity?: string;
  /**
   * ソート対象フィールド（例: id, -id, manufacturing_number, -manufacturing_number, target_variation__product_code, -target_variation__product_code, quantity, -quantity, status, -status, stock_status, -stock_status, stock_ready_date, -stock_ready_date, expected_completion_date, -expected_completion_date, production_completed_at, -production_completed_at, created_at, -created_at, updated_at, -updated_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品コードでの部分一致検索
   */
  product_code?: string;
  /**
   * 商品バリエーション名での部分一致検索
   */
  product_name?: string;
  /**
   * 生産完了日の開始日でフィルタ (YYYY-MM-DD)
   */
  production_completed_at_from?: string;
  /**
   * 生産完了日の終了日でフィルタ (YYYY-MM-DD)
   */
  production_completed_at_to?: string;
  /**
   * 生産ステータスでフィルタ
   */
  status?: ManufacturingOrderStatusEnum;
  /**
   * ステータスフィルター（all: すべて, completed: 完了, in_progress: 対応中）
   */
  status_filter?: ManufacturingOrderListStatusFilter;
  /**
   * 在庫ステータスでフィルタ
   */
  stock_status?: SalesOrderStockStatusEnum;
  /**
   * 生産対象商品バリエーションIDでフィルタ
   */
  target_variation_id?: number;
};

export type ManufacturingOrderListStatusFilter =
  (typeof ManufacturingOrderListStatusFilter)[keyof typeof ManufacturingOrderListStatusFilter];

export const ManufacturingOrderListStatusFilter = {
  all: 'all',
  completed: 'completed',
  in_progress: 'in_progress',
} as const;

export type ManufacturingOrderFinishedLotPreviewParams = {
  /**
   * 完了時に指定する予定のロット番号
   * @maxLength 100
   */
  lot_number?: string;
  /**
   * 完了時に指定する予定の生産完了日(番号未指定時の既定番号の基準)
   */
  production_completed_at?: string;
};

export type DepartmentListParams = {
  /**
   * 取得する部署の最大階層 (1=第一階層のみ, 2=第二階層まで, 指定なし=全階層)
   */
  max_depth?: number;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type OutgoingPaymentImportLogsListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type OutgoingPaymentsListParams = {
  /**
   * 出金日の開始日（YYYY-MM-DD）
   */
  from_date?: string;
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  /**
   * 取引先コード（部分一致）
   */
  partner_code?: string;
  /**
   * 取引先名（部分一致）
   */
  partner_name?: string;
  /**
   * 出金番号（前方一致）
   */
  payment_no?: string;
  /**
   * 出金日の終了日（YYYY-MM-DD）
   */
  to_date?: string;
};

export type PaymentMethodListParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type PdfTokenCreate200 = {
  token?: string;
  expires_in?: number;
};

export type ProductPartnerPriceGroupListParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ProductPartnerPriceGroupBulkUpdateParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ProductPriceChangeLogListParams = {
  /**
   * 変更種別。複数指定した場合はいずれかに一致するものを返す
   */
  change_type?: PriceChangeTypeEnum[];
  /**
   * 変更日時の下限(この日時を含む)。日付のみ指定した場合は 00:00:00 として扱う
   */
  logged_at_from?: string;
  /**
   * 変更日時の上限(この日時を含む)。日付のみ指定した場合は 00:00:00 として扱う
   */
  logged_at_to?: string;
  /**
   * 変更日時の並び順
   *
   * * `logged_at` - logged_at
   * * `-logged_at` - -logged_at
   * @minLength 1
   */
  ordering?: ProductPriceChangeLogListOrdering;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
  /**
   * 単価種別。複数指定した場合はいずれかに一致するものを返す
   */
  price_type?: PriceChangeTargetTypeEnum[];
};

export type ProductPriceChangeLogListOrdering =
  (typeof ProductPriceChangeLogListOrdering)[keyof typeof ProductPriceChangeLogListOrdering];

export const ProductPriceChangeLogListOrdering = {
  logged_at: 'logged_at',
  '-logged_at': '-logged_at',
} as const;

export type ProductImportLogsListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ProductsCatalogCustomPropertiesListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ProductCatalogCustomPropertyGroupListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ProductCategoryMasterListParams = {
  /**
   * カテゴリ名で部分一致検索
   */
  name?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * カテゴリタイプで絞り込み
   */
  type?: TypeEnum;
};

export type CustomerPriceImportLogsListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ProductPackagingTypeMasterListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ProductPriceRevisionCustomPropertyListParams = {
  /**
   * 有効/無効でフィルタリング
   */
  is_active?: boolean;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ProductPriceRevisionListParams = {
  /**
   * 適用開始日（入荷予定日）の開始日でフィルタ (YYYY-MM-DD)
   */
  arrival_start_date_from?: string;
  /**
   * 適用開始日（入荷予定日）の終了日でフィルタ (YYYY-MM-DD)
   */
  arrival_start_date_to?: string;
  /**
   * カスタム項目での検索（項目種別により完全一致または部分一致）。Nはproperty_type番号（1以上）。例: custom_property_1=検索値
   */
  'custom_property_{N}'?: string;
  /**
   * 商品数の最大値
   */
  max_product_count?: number;
  /**
   * 商品数の最小値
   */
  min_product_count?: number;
  /**
   * ソート対象フィールド（例: id, -id, title, -title, status, -status, shipping_start_date, -shipping_start_date, arrival_start_date, -arrival_start_date, product_count, -product_count, updated_at, -updated_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 適用開始日（出荷予定日）の開始日でフィルタ (YYYY-MM-DD)
   */
  shipping_start_date_from?: string;
  /**
   * 適用開始日（出荷予定日）の終了日でフィルタ (YYYY-MM-DD)
   */
  shipping_start_date_to?: string;
  /**
   * ステータスで絞り込み（カンマ区切りで複数指定可能）
   */
  status?: string;
  /**
   * ステータスタブで絞り込み（status と組み合わせた場合は両方を満たすものを返す）
   */
  status_filter?: ProductPriceRevisionListStatusFilter;
  /**
   * タイトルでの部分一致検索
   */
  title?: string;
};

export type ProductPriceRevisionListStatusFilter =
  (typeof ProductPriceRevisionListStatusFilter)[keyof typeof ProductPriceRevisionListStatusFilter];

export const ProductPriceRevisionListStatusFilter = {
  COMPLETED: 'COMPLETED',
  DRAFT: 'DRAFT',
  IN_PROGRESS: 'IN_PROGRESS',
} as const;

export type ProductPresetListParams = {
  /**
   * ソート対象フィールド（例: id, -id, name, -name, item_count, -item_count, total_base_price, -total_base_price, updated_at, -updated_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * プリセット名・品目の商品名・商品コードでの部分一致検索
   */
  search?: string;
};

export type ProductSupplierListParams = {
  /**
   * デフォルト仕入先でフィルター（true/false）
   */
  is_default?: boolean;
  /**
   * ソート対象フィールド（例: supplier__partner_name, -supplier__partner_name, is_default, -is_default, created_at, -created_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品IDでフィルター
   */
  product_id?: number;
  /**
   * 商品バリエーションIDでフィルター（バリエーションが属する商品の仕入先を返す）
   */
  product_variation_id?: number;
  /**
   * 商品バリエーションIDでフィルター（カンマ区切りで複数指定可能）
   */
  product_variation_ids?: string;
  /**
   * 仕入先IDでフィルター
   */
  supplier_id?: number;
};

export type ProductVariationCustomerPriceListParams = {
  /**
   * 取引先IDでフィルター
   */
  customer_id?: number;
  /**
   * 得意先名でフィルター（部分一致）
   */
  customer_name?: string;
  /**
   * 単位原価の最大値でフィルター
   */
  max_cost_price?: string;
  /**
   * 粗利益率の最大値（%）でフィルター
   */
  max_gross_profit_rate?: number;
  /**
   * 販売価格の最大値でフィルター
   */
  max_price?: string;
  /**
   * 単位原価の最小値でフィルター
   */
  min_cost_price?: string;
  /**
   * 粗利益率の最小値（%）でフィルター
   */
  min_gross_profit_rate?: number;
  /**
   * 販売価格の最小値でフィルター
   */
  min_price?: string;
  /**
   * ソート対象フィールド（例: price, -price, customer__partner_name, -customer__partner_name, product_variation__variation_name, -product_variation__variation_name, product_variation__cost_price, -product_variation__cost_price, gross_profit_rate, -gross_profit_rate）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品IDでフィルター
   */
  product_id?: number;
  /**
   * 商品名でフィルター（部分一致）
   */
  product_name?: string;
  /**
   * 商品バリエーションIDでフィルター
   */
  product_variation_id?: number;
  /**
   * 商品バリエーションIDでフィルター（カンマ区切りで複数指定可能）
   */
  product_variation_ids?: string;
  /**
   * 設定日時の終了日でフィルター（ISO8601形式）
   */
  updated_at_end?: string;
  /**
   * 設定日時の開始日でフィルター（ISO8601形式）
   */
  updated_at_start?: string;
};

export type ProductVariationPartnerPriceGroupListParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 価格グループコード(A-G)でフィルター
   */
  price_group_code?: string;
  /**
   * 価格グループIDでフィルター
   */
  price_group_id?: number;
  /**
   * 商品IDでフィルター
   */
  product_id?: number;
};

export type ProductVariationPartnerPriceGroupBulkUpdateParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ProductVariationQuantityPriceListParams = {
  /**
   * 粗利益率の最大値（%）でフィルター
   */
  max_gross_profit_rate?: number;
  /**
   * 最大数量の最大値
   */
  max_quantity_max?: number;
  /**
   * 最大数量の最小値
   */
  max_quantity_min?: number;
  /**
   * 粗利益率の最小値（%）でフィルター
   */
  min_gross_profit_rate?: number;
  /**
   * 最小数量の最大値
   */
  min_quantity_max?: number;
  /**
   * 最小数量の最小値
   */
  min_quantity_min?: number;
  /**
   * ソート順序（例: price, -price, product__name, gross_profit_rate, -gross_profit_rate）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 商品コードでフィルター（部分一致）
   */
  product_code?: string;
  /**
   * 商品IDでフィルター
   */
  product_id?: number;
  /**
   * 商品名でフィルター（部分一致）
   */
  product_name?: string;
  /**
   * 商品バリエーションIDでフィルター
   */
  product_variation_id?: number;
  /**
   * 商品バリエーション名でフィルター（部分一致）
   */
  product_variation_name?: string;
  /**
   * 最大単価
   */
  unit_price_max?: string;
  /**
   * 最小単価
   */
  unit_price_min?: string;
  /**
   * 更新日の開始日時（ISO8601形式）
   */
  updated_at_from?: string;
  /**
   * 更新日の終了日時（ISO8601形式）
   */
  updated_at_to?: string;
};

export type ProductVariationListParams = {
  /**
   * 分類1のカテゴリーIDでフィルタ
   */
  category_type_1?: number;
  /**
   * 分類2のカテゴリーIDでフィルタ
   */
  category_type_2?: number;
  /**
   * 分類3のカテゴリーIDでフィルタ
   */
  category_type_3?: number;
  /**
   * 原価の最大値
   */
  cost_price_max?: string;
  /**
   * 原価の最小値
   */
  cost_price_min?: string;
  /**
   * 取引先ID（指定すると取引先価格と、その取引先の取引先別単価の予約単価候補を含めて返す）
   */
  customer_id?: number;
  /**
   * デフォルト仕入先の取引先IDでフィルタ
   */
  default_supplier_id?: number;
  /**
   * デフォルト仕入先名での検索（部分一致）
   */
  default_supplier_name?: string;
  /**
   * 奥行(mm)の最大値
   */
  depth_max?: string;
  /**
   * 奥行(mm)の最小値
   */
  depth_min?: string;
  /**
   * 高さ(mm)の最大値
   */
  height_max?: string;
  /**
   * 高さ(mm)の最小値
   */
  height_min?: string;
  /**
   * 取引先の得意先別品番を含めて返し、search・model_number の検索対象に加える（customer_id指定時のみ有効）
   */
  include_customer_model_number?: boolean;
  /**
   * サンプル商品コードも search・product_code の検索対象に加える（受注・見積の明細でサンプルを選べるようにするときに指定する）
   */
  include_samples?: boolean;
  /**
   * 在庫管理タイプでの絞り込み（MANAGED/NOT_MANAGED）
   */
  inventory_management_type?: string;
  /**
   * メーカーでの検索（部分一致）
   */
  manufacturer?: string;
  /**
   * 粗利率の最大値（%）
   */
  max_gross_profit_rate?: number;
  /**
   * 粗利率の最小値（%）
   */
  min_gross_profit_rate?: number;
  /**
   * 品番での検索（部分一致。customer_id と include_customer_model_number 指定時は得意先別品番も対象）
   */
  model_number?: string;
  /**
   * 上代の最大値
   */
  msrp_max?: string;
  /**
   * 上代の最小値
   */
  msrp_min?: string;
  /**
   * 備考での検索（部分一致）
   */
  notes?: string;
  /**
   * 指定した取引先の受注実績がある商品のみに絞り込む（customer_id指定時のみ有効）
   */
  ordered_only?: boolean;
  /**
   * ソート対象フィールド（例: product__name, -product__name, product_code, -product_code, product__manufacturer, -product__manufacturer, spec, -spec, product__notes, -product__notes, product__inventory_management_type, -product__inventory_management_type, unit_price, -unit_price, cost_price, -cost_price, effective_msrp, -effective_msrp, catalog__width, -catalog__width, catalog__depth, -catalog__depth, catalog__height, -catalog__height, catalog__weight, -catalog__weight, updated_at, -updated_at）
   */
  ordering?: string;
  /**
   * 荷姿IDでフィルタ
   */
  packaging_type_id?: number;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 加工可否での絞り込み（true/false）
   */
  processable?: boolean;
  /**
   * 商品コードでの検索（部分一致）
   */
  product_code?: string;
  /**
   * 商品ID
   */
  product_id?: number;
  /**
   * 商品名での検索（部分一致）
   */
  product_name?: string;
  /**
   * 商品バリエーションIDでフィルタ（カンマ区切りで複数指定可能）
   */
  product_variation_ids?: string;
  /**
   * 販売可否での絞り込み（true/false）
   */
  saleable?: boolean;
  /**
   * 横断検索（商品コード、商品名、バリエーション名での OR検索）
   */
  search?: string;
  /**
   * 入数の最大値
   */
  snp_max?: string;
  /**
   * 入数の最小値
   */
  snp_min?: string;
  /**
   * 規格での検索（部分一致）
   */
  spec?: string;
  /**
   * 単価の最大値
   */
  unit_price_max?: string;
  /**
   * 単価の最小値
   */
  unit_price_min?: string;
  /**
   * バリエーション名での検索（部分一致）
   */
  variation_name?: string;
  /**
   * バリエーション属性のキー（属性名）またはバリュー（属性値）での検索（部分一致）
   */
  variation_values?: string;
  /**
   * 重量(g)の最大値
   */
  weight_max?: string;
  /**
   * 重量(g)の最小値
   */
  weight_min?: string;
  /**
   * 幅(mm)の最大値
   */
  width_max?: string;
  /**
   * 幅(mm)の最小値
   */
  width_min?: string;
};

export type ProductVariationDetailParams = {
  /**
   * 取引先ID（指定すると取引先価格とランク別単価、その取引先の取引先別単価の予約単価候補を含めて返す）
   */
  customer_id?: number;
  /**
   * 取引先の得意先別品番を含めて返す（customer_id指定時のみ有効）
   */
  include_customer_model_number?: boolean;
};

export type ProductVariationCatalogFilesReorderParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
};

export type ProductCatalogFilesReorderParams = {
  /**
   * Which field to use when ordering the results.
   */
  ordering?: string;
};

export type QuantityPriceImportLogsListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ProductQuantityUnitMasterListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type ProductVariationSsrmParams = {
  /**
   * 分類1のカテゴリーIDでのフィルタ(カンマ区切りで複数指定可能)
   */
  category_type_1?: string;
  /**
   * 分類2のカテゴリーIDでのフィルタ(カンマ区切りで複数指定可能)
   */
  category_type_2?: string;
  /**
   * 分類3のカテゴリーIDでのフィルタ(カンマ区切りで複数指定可能)
   */
  category_type_3?: string;
  /**
   * 原価フィルタの値
   */
  cost_price_filter?: string;
  /**
   * 原価フィルタの範囲上限値(inRange用)
   */
  cost_price_filter_to?: string;
  /**
   * 原価フィルタの種類
   */
  cost_price_filter_type?: ProductVariationSsrmCostPriceFilterType;
  /**
   * 仕入先フィルタの値
   */
  default_supplier_name?: string;
  /**
   * 仕入先フィルタの種類(未指定は contains 扱い)
   */
  default_supplier_name_filter_type?: ProductVariationSsrmDefaultSupplierNameFilterType;
  /**
   * 奥行(mm)フィルタの値
   */
  depth_filter?: string;
  /**
   * 奥行(mm)フィルタの範囲上限値(inRange用)
   */
  depth_filter_to?: string;
  /**
   * 奥行(mm)フィルタの種類
   */
  depth_filter_type?: ProductVariationSsrmDepthFilterType;
  /**
   * 粗利率フィルタの値
   */
  gross_profit_rate_filter?: string;
  /**
   * 粗利率フィルタの範囲上限値(inRange用)
   */
  gross_profit_rate_filter_to?: string;
  /**
   * 粗利率フィルタの種類
   */
  gross_profit_rate_filter_type?: ProductVariationSsrmGrossProfitRateFilterType;
  /**
   * 高さ(mm)フィルタの値
   */
  height_filter?: string;
  /**
   * 高さ(mm)フィルタの範囲上限値(inRange用)
   */
  height_filter_to?: string;
  /**
   * 高さ(mm)フィルタの種類
   */
  height_filter_type?: ProductVariationSsrmHeightFilterType;
  /**
   * 在庫管理タイプでのフィルタ(カンマ区切りで複数指定可能: MANAGED/NOT_MANAGED)
   */
  inventory_management_type?: string;
  /**
   * メーカーフィルタの値
   */
  manufacturer?: string;
  /**
   * メーカーフィルタの種類(未指定は contains 扱い)
   */
  manufacturer_filter_type?: ProductVariationSsrmManufacturerFilterType;
  /**
   * 品番フィルタの値
   */
  model_number?: string;
  /**
   * 品番フィルタの種類(未指定は contains 扱い)
   */
  model_number_filter_type?: ProductVariationSsrmModelNumberFilterType;
  /**
   * 上代フィルタの値
   */
  msrp_filter?: string;
  /**
   * 上代フィルタの範囲上限値(inRange用)
   */
  msrp_filter_to?: string;
  /**
   * 上代フィルタの種類
   */
  msrp_filter_type?: ProductVariationSsrmMsrpFilterType;
  /**
   * 備考フィルタの値
   */
  notes?: string;
  /**
   * 備考フィルタの種類(未指定は contains 扱い)
   */
  notes_filter_type?: ProductVariationSsrmNotesFilterType;
  /**
   * ソート対象フィールド。'-'を付けて降順。例: product_code, -product_code
   */
  ordering?: string;
  /**
   * 荷姿IDでのフィルタ(カンマ区切りで複数指定可能)
   */
  packaging_type?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 加工可否での絞り込み(true/false)
   */
  processable?: boolean;
  /**
   * 商品コードフィルタの値
   */
  product_code?: string;
  /**
   * 商品コードフィルタの種類(未指定は contains 扱い)
   */
  product_code_filter_type?: ProductVariationSsrmProductCodeFilterType;
  /**
   * 販売可否での絞り込み(true/false)
   */
  saleable?: boolean;
  /**
   * 入数フィルタの値
   */
  snp_filter?: string;
  /**
   * 入数フィルタの範囲上限値(inRange用)
   */
  snp_filter_to?: string;
  /**
   * 入数フィルタの種類
   */
  snp_filter_type?: ProductVariationSsrmSnpFilterType;
  /**
   * 規格フィルタの値
   */
  spec?: string;
  /**
   * 規格フィルタの種類(未指定は contains 扱い)
   */
  spec_filter_type?: ProductVariationSsrmSpecFilterType;
  /**
   * 単位フィルタの値
   */
  unit_name?: string;
  /**
   * 単位フィルタの種類(未指定は contains 扱い)
   */
  unit_name_filter_type?: ProductVariationSsrmUnitNameFilterType;
  /**
   * 単価フィルタの値
   */
  unit_price_filter?: string;
  /**
   * 単価フィルタの範囲上限値(inRange用)
   */
  unit_price_filter_to?: string;
  /**
   * 単価フィルタの種類
   */
  unit_price_filter_type?: ProductVariationSsrmUnitPriceFilterType;
  /**
   * 更新日フィルタの種類(未指定は equals 扱い)
   */
  updated_at_filter_type?: ProductVariationSsrmUpdatedAtFilterType;
  /**
   * 更新日フィルタの基準日(ISO 8601形式、例: 2026-01-01)
   */
  updated_at_from?: string;
  /**
   * 更新日フィルタの範囲上限日(inRange用、ISO 8601形式)
   */
  updated_at_to?: string;
  /**
   * 商品名フィルタの値
   */
  variation_name?: string;
  /**
   * 商品名フィルタの種類(未指定は contains 扱い)
   */
  variation_name_filter_type?: ProductVariationSsrmVariationNameFilterType;
  /**
   * バリエーション属性のキー(属性名)またはバリュー(属性値)での検索(部分一致)
   */
  variation_values?: string;
  /**
   * 重量(g)フィルタの値
   */
  weight_filter?: string;
  /**
   * 重量(g)フィルタの範囲上限値(inRange用)
   */
  weight_filter_to?: string;
  /**
   * 重量(g)フィルタの種類
   */
  weight_filter_type?: ProductVariationSsrmWeightFilterType;
  /**
   * 幅(mm)フィルタの値
   */
  width_filter?: string;
  /**
   * 幅(mm)フィルタの範囲上限値(inRange用)
   */
  width_filter_to?: string;
  /**
   * 幅(mm)フィルタの種類
   */
  width_filter_type?: ProductVariationSsrmWidthFilterType;
};

export type ProductVariationSsrmCostPriceFilterType =
  (typeof ProductVariationSsrmCostPriceFilterType)[keyof typeof ProductVariationSsrmCostPriceFilterType];

export const ProductVariationSsrmCostPriceFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmDefaultSupplierNameFilterType =
  (typeof ProductVariationSsrmDefaultSupplierNameFilterType)[keyof typeof ProductVariationSsrmDefaultSupplierNameFilterType];

export const ProductVariationSsrmDefaultSupplierNameFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmDepthFilterType =
  (typeof ProductVariationSsrmDepthFilterType)[keyof typeof ProductVariationSsrmDepthFilterType];

export const ProductVariationSsrmDepthFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmGrossProfitRateFilterType =
  (typeof ProductVariationSsrmGrossProfitRateFilterType)[keyof typeof ProductVariationSsrmGrossProfitRateFilterType];

export const ProductVariationSsrmGrossProfitRateFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmHeightFilterType =
  (typeof ProductVariationSsrmHeightFilterType)[keyof typeof ProductVariationSsrmHeightFilterType];

export const ProductVariationSsrmHeightFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmManufacturerFilterType =
  (typeof ProductVariationSsrmManufacturerFilterType)[keyof typeof ProductVariationSsrmManufacturerFilterType];

export const ProductVariationSsrmManufacturerFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmModelNumberFilterType =
  (typeof ProductVariationSsrmModelNumberFilterType)[keyof typeof ProductVariationSsrmModelNumberFilterType];

export const ProductVariationSsrmModelNumberFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmMsrpFilterType =
  (typeof ProductVariationSsrmMsrpFilterType)[keyof typeof ProductVariationSsrmMsrpFilterType];

export const ProductVariationSsrmMsrpFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmNotesFilterType =
  (typeof ProductVariationSsrmNotesFilterType)[keyof typeof ProductVariationSsrmNotesFilterType];

export const ProductVariationSsrmNotesFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmProductCodeFilterType =
  (typeof ProductVariationSsrmProductCodeFilterType)[keyof typeof ProductVariationSsrmProductCodeFilterType];

export const ProductVariationSsrmProductCodeFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmSnpFilterType =
  (typeof ProductVariationSsrmSnpFilterType)[keyof typeof ProductVariationSsrmSnpFilterType];

export const ProductVariationSsrmSnpFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmSpecFilterType =
  (typeof ProductVariationSsrmSpecFilterType)[keyof typeof ProductVariationSsrmSpecFilterType];

export const ProductVariationSsrmSpecFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmUnitNameFilterType =
  (typeof ProductVariationSsrmUnitNameFilterType)[keyof typeof ProductVariationSsrmUnitNameFilterType];

export const ProductVariationSsrmUnitNameFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmUnitPriceFilterType =
  (typeof ProductVariationSsrmUnitPriceFilterType)[keyof typeof ProductVariationSsrmUnitPriceFilterType];

export const ProductVariationSsrmUnitPriceFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmUpdatedAtFilterType =
  (typeof ProductVariationSsrmUpdatedAtFilterType)[keyof typeof ProductVariationSsrmUpdatedAtFilterType];

export const ProductVariationSsrmUpdatedAtFilterType = {
  equals: 'equals',
  greaterThan: 'greaterThan',
  inRange: 'inRange',
  lessThan: 'lessThan',
} as const;

export type ProductVariationSsrmVariationNameFilterType =
  (typeof ProductVariationSsrmVariationNameFilterType)[keyof typeof ProductVariationSsrmVariationNameFilterType];

export const ProductVariationSsrmVariationNameFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmWeightFilterType =
  (typeof ProductVariationSsrmWeightFilterType)[keyof typeof ProductVariationSsrmWeightFilterType];

export const ProductVariationSsrmWeightFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmWidthFilterType =
  (typeof ProductVariationSsrmWidthFilterType)[keyof typeof ProductVariationSsrmWidthFilterType];

export const ProductVariationSsrmWidthFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsParams = {
  /**
   * 分類1のカテゴリーIDでのフィルタ(カンマ区切りで複数指定可能)
   */
  category_type_1?: string;
  /**
   * 分類2のカテゴリーIDでのフィルタ(カンマ区切りで複数指定可能)
   */
  category_type_2?: string;
  /**
   * 分類3のカテゴリーIDでのフィルタ(カンマ区切りで複数指定可能)
   */
  category_type_3?: string;
  /**
   * 原価フィルタの値
   */
  cost_price_filter?: string;
  /**
   * 原価フィルタの範囲上限値(inRange用)
   */
  cost_price_filter_to?: string;
  /**
   * 原価フィルタの種類
   */
  cost_price_filter_type?: ProductVariationSsrmIdsCostPriceFilterType;
  /**
   * 仕入先フィルタの値
   */
  default_supplier_name?: string;
  /**
   * 仕入先フィルタの種類(未指定は contains 扱い)
   */
  default_supplier_name_filter_type?: ProductVariationSsrmIdsDefaultSupplierNameFilterType;
  /**
   * 奥行(mm)フィルタの値
   */
  depth_filter?: string;
  /**
   * 奥行(mm)フィルタの範囲上限値(inRange用)
   */
  depth_filter_to?: string;
  /**
   * 奥行(mm)フィルタの種類
   */
  depth_filter_type?: ProductVariationSsrmIdsDepthFilterType;
  /**
   * 粗利率フィルタの値
   */
  gross_profit_rate_filter?: string;
  /**
   * 粗利率フィルタの範囲上限値(inRange用)
   */
  gross_profit_rate_filter_to?: string;
  /**
   * 粗利率フィルタの種類
   */
  gross_profit_rate_filter_type?: ProductVariationSsrmIdsGrossProfitRateFilterType;
  /**
   * 高さ(mm)フィルタの値
   */
  height_filter?: string;
  /**
   * 高さ(mm)フィルタの範囲上限値(inRange用)
   */
  height_filter_to?: string;
  /**
   * 高さ(mm)フィルタの種類
   */
  height_filter_type?: ProductVariationSsrmIdsHeightFilterType;
  /**
   * 在庫管理タイプでのフィルタ(カンマ区切りで複数指定可能: MANAGED/NOT_MANAGED)
   */
  inventory_management_type?: string;
  /**
   * メーカーフィルタの値
   */
  manufacturer?: string;
  /**
   * メーカーフィルタの種類(未指定は contains 扱い)
   */
  manufacturer_filter_type?: ProductVariationSsrmIdsManufacturerFilterType;
  /**
   * 品番フィルタの値
   */
  model_number?: string;
  /**
   * 品番フィルタの種類(未指定は contains 扱い)
   */
  model_number_filter_type?: ProductVariationSsrmIdsModelNumberFilterType;
  /**
   * 上代フィルタの値
   */
  msrp_filter?: string;
  /**
   * 上代フィルタの範囲上限値(inRange用)
   */
  msrp_filter_to?: string;
  /**
   * 上代フィルタの種類
   */
  msrp_filter_type?: ProductVariationSsrmIdsMsrpFilterType;
  /**
   * 備考フィルタの値
   */
  notes?: string;
  /**
   * 備考フィルタの種類(未指定は contains 扱い)
   */
  notes_filter_type?: ProductVariationSsrmIdsNotesFilterType;
  /**
   * 荷姿IDでのフィルタ(カンマ区切りで複数指定可能)
   */
  packaging_type?: string;
  /**
   * 加工可否での絞り込み(true/false)
   */
  processable?: boolean;
  /**
   * 商品コードフィルタの値
   */
  product_code?: string;
  /**
   * 商品コードフィルタの種類(未指定は contains 扱い)
   */
  product_code_filter_type?: ProductVariationSsrmIdsProductCodeFilterType;
  /**
   * 販売可否での絞り込み(true/false)
   */
  saleable?: boolean;
  /**
   * 入数フィルタの値
   */
  snp_filter?: string;
  /**
   * 入数フィルタの範囲上限値(inRange用)
   */
  snp_filter_to?: string;
  /**
   * 入数フィルタの種類
   */
  snp_filter_type?: ProductVariationSsrmIdsSnpFilterType;
  /**
   * 規格フィルタの値
   */
  spec?: string;
  /**
   * 規格フィルタの種類(未指定は contains 扱い)
   */
  spec_filter_type?: ProductVariationSsrmIdsSpecFilterType;
  /**
   * 単位フィルタの値
   */
  unit_name?: string;
  /**
   * 単位フィルタの種類(未指定は contains 扱い)
   */
  unit_name_filter_type?: ProductVariationSsrmIdsUnitNameFilterType;
  /**
   * 単価フィルタの値
   */
  unit_price_filter?: string;
  /**
   * 単価フィルタの範囲上限値(inRange用)
   */
  unit_price_filter_to?: string;
  /**
   * 単価フィルタの種類
   */
  unit_price_filter_type?: ProductVariationSsrmIdsUnitPriceFilterType;
  /**
   * 更新日フィルタの種類(未指定は equals 扱い)
   */
  updated_at_filter_type?: ProductVariationSsrmIdsUpdatedAtFilterType;
  /**
   * 更新日フィルタの基準日(ISO 8601形式、例: 2026-01-01)
   */
  updated_at_from?: string;
  /**
   * 更新日フィルタの範囲上限日(inRange用、ISO 8601形式)
   */
  updated_at_to?: string;
  /**
   * 商品名フィルタの値
   */
  variation_name?: string;
  /**
   * 商品名フィルタの種類(未指定は contains 扱い)
   */
  variation_name_filter_type?: ProductVariationSsrmIdsVariationNameFilterType;
  /**
   * バリエーション属性のキー(属性名)またはバリュー(属性値)での検索(部分一致)
   */
  variation_values?: string;
  /**
   * 重量(g)フィルタの値
   */
  weight_filter?: string;
  /**
   * 重量(g)フィルタの範囲上限値(inRange用)
   */
  weight_filter_to?: string;
  /**
   * 重量(g)フィルタの種類
   */
  weight_filter_type?: ProductVariationSsrmIdsWeightFilterType;
  /**
   * 幅(mm)フィルタの値
   */
  width_filter?: string;
  /**
   * 幅(mm)フィルタの範囲上限値(inRange用)
   */
  width_filter_to?: string;
  /**
   * 幅(mm)フィルタの種類
   */
  width_filter_type?: ProductVariationSsrmIdsWidthFilterType;
};

export type ProductVariationSsrmIdsCostPriceFilterType =
  (typeof ProductVariationSsrmIdsCostPriceFilterType)[keyof typeof ProductVariationSsrmIdsCostPriceFilterType];

export const ProductVariationSsrmIdsCostPriceFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsDefaultSupplierNameFilterType =
  (typeof ProductVariationSsrmIdsDefaultSupplierNameFilterType)[keyof typeof ProductVariationSsrmIdsDefaultSupplierNameFilterType];

export const ProductVariationSsrmIdsDefaultSupplierNameFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmIdsDepthFilterType =
  (typeof ProductVariationSsrmIdsDepthFilterType)[keyof typeof ProductVariationSsrmIdsDepthFilterType];

export const ProductVariationSsrmIdsDepthFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsGrossProfitRateFilterType =
  (typeof ProductVariationSsrmIdsGrossProfitRateFilterType)[keyof typeof ProductVariationSsrmIdsGrossProfitRateFilterType];

export const ProductVariationSsrmIdsGrossProfitRateFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsHeightFilterType =
  (typeof ProductVariationSsrmIdsHeightFilterType)[keyof typeof ProductVariationSsrmIdsHeightFilterType];

export const ProductVariationSsrmIdsHeightFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsManufacturerFilterType =
  (typeof ProductVariationSsrmIdsManufacturerFilterType)[keyof typeof ProductVariationSsrmIdsManufacturerFilterType];

export const ProductVariationSsrmIdsManufacturerFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmIdsModelNumberFilterType =
  (typeof ProductVariationSsrmIdsModelNumberFilterType)[keyof typeof ProductVariationSsrmIdsModelNumberFilterType];

export const ProductVariationSsrmIdsModelNumberFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmIdsMsrpFilterType =
  (typeof ProductVariationSsrmIdsMsrpFilterType)[keyof typeof ProductVariationSsrmIdsMsrpFilterType];

export const ProductVariationSsrmIdsMsrpFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsNotesFilterType =
  (typeof ProductVariationSsrmIdsNotesFilterType)[keyof typeof ProductVariationSsrmIdsNotesFilterType];

export const ProductVariationSsrmIdsNotesFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmIdsProductCodeFilterType =
  (typeof ProductVariationSsrmIdsProductCodeFilterType)[keyof typeof ProductVariationSsrmIdsProductCodeFilterType];

export const ProductVariationSsrmIdsProductCodeFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmIdsSnpFilterType =
  (typeof ProductVariationSsrmIdsSnpFilterType)[keyof typeof ProductVariationSsrmIdsSnpFilterType];

export const ProductVariationSsrmIdsSnpFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsSpecFilterType =
  (typeof ProductVariationSsrmIdsSpecFilterType)[keyof typeof ProductVariationSsrmIdsSpecFilterType];

export const ProductVariationSsrmIdsSpecFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmIdsUnitNameFilterType =
  (typeof ProductVariationSsrmIdsUnitNameFilterType)[keyof typeof ProductVariationSsrmIdsUnitNameFilterType];

export const ProductVariationSsrmIdsUnitNameFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmIdsUnitPriceFilterType =
  (typeof ProductVariationSsrmIdsUnitPriceFilterType)[keyof typeof ProductVariationSsrmIdsUnitPriceFilterType];

export const ProductVariationSsrmIdsUnitPriceFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsUpdatedAtFilterType =
  (typeof ProductVariationSsrmIdsUpdatedAtFilterType)[keyof typeof ProductVariationSsrmIdsUpdatedAtFilterType];

export const ProductVariationSsrmIdsUpdatedAtFilterType = {
  equals: 'equals',
  greaterThan: 'greaterThan',
  inRange: 'inRange',
  lessThan: 'lessThan',
} as const;

export type ProductVariationSsrmIdsVariationNameFilterType =
  (typeof ProductVariationSsrmIdsVariationNameFilterType)[keyof typeof ProductVariationSsrmIdsVariationNameFilterType];

export const ProductVariationSsrmIdsVariationNameFilterType = {
  blank: 'blank',
  contains: 'contains',
  endsWith: 'endsWith',
  equals: 'equals',
  notBlank: 'notBlank',
  notContains: 'notContains',
  notEqual: 'notEqual',
  startsWith: 'startsWith',
} as const;

export type ProductVariationSsrmIdsWeightFilterType =
  (typeof ProductVariationSsrmIdsWeightFilterType)[keyof typeof ProductVariationSsrmIdsWeightFilterType];

export const ProductVariationSsrmIdsWeightFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type ProductVariationSsrmIdsWidthFilterType =
  (typeof ProductVariationSsrmIdsWidthFilterType)[keyof typeof ProductVariationSsrmIdsWidthFilterType];

export const ProductVariationSsrmIdsWidthFilterType = {
  blank: 'blank',
  equals: 'equals',
  greaterThan: 'greaterThan',
  greaterThanOrEqual: 'greaterThanOrEqual',
  inRange: 'inRange',
  lessThan: 'lessThan',
  lessThanOrEqual: 'lessThanOrEqual',
  notBlank: 'notBlank',
  notEqual: 'notEqual',
} as const;

export type PurchaseInvoiceImportLogsListParams = {
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type PurchaseInvoiceListParams = {
  /**
   * 仕入日の開始日でフィルタリング (YYYY-MM-DD)
   */
  from_date?: string;
  /**
   * 合計金額（税込）の最大値でフィルタリング
   */
  max_amount?: string;
  /**
   * 合計金額（税抜）の最大値でフィルタリング
   */
  max_subtotal?: string;
  /**
   * 合計金額（税込）の最小値でフィルタリング
   */
  min_amount?: string;
  /**
   * 合計金額（税抜）の最小値でフィルタリング
   */
  min_subtotal?: string;
  /**
   * ソート対象フィールド（例: id, -id, purchase_invoice_number, -purchase_date）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
  /**
   * 支払先IDでフィルタリング
   */
  pay_to_id?: number;
  /**
   * 支払先名での部分一致検索
   */
  pay_to_name?: string;
  /**
   * 支払予定日の開始日でフィルタリング (YYYY-MM-DD)
   */
  payment_due_date_from?: string;
  /**
   * 支払予定日の終了日でフィルタリング (YYYY-MM-DD)
   */
  payment_due_date_to?: string;
  /**
   * 仕入番号での部分一致検索
   */
  purchase_invoice_number?: string;
  /**
   * 部門IDでフィルタリング
   */
  responsible_department?: number;
  /**
   * 仕入先IDでフィルタリング
   */
  supplier_id?: number;
  /**
   * 仕入先名での部分一致検索
   */
  supplier_name?: string;
  /**
   * 仕入日の終了日でフィルタリング (YYYY-MM-DD)
   */
  to_date?: string;
};

export type CustomerSalesListParams = {
  /**
   * 取引先ID
   */
  partner_id: number;
  /**
   * 対象期間(yyyymm形式、カンマ区切り) 例: 202501,202502,202503
   */
  periods: string;
};

export type CustomerSalesPastYearsParams = {
  /**
   * 対象期間(yyyymm形式、カンマ区切り) 例: 202501,202502,202503
   */
  periods: string;
};

export type TopSalesProductsParams = {
  /**
   * 取引先ID
   */
  partner_id: number;
  /**
   * 対象期間(yyyymm形式、カンマ区切り) 例: 202501,202502,202503
   */
  periods: string;
  /**
   * 取得件数（デフォルト: 10）
   */
  top_n?: number;
};

export type MonthlySalesParams = {
  /**
   * 終了日(yyyymm形式)
   */
  period_end: string;
  /**
   * 開始日(yyyymm形式)
   */
  period_start: string;
};

export type ProductSalesListParams = {
  /**
   * 対象期間(yyyymm形式、カンマ区切り) 例: 202501,202502,202503
   */
  periods: string;
  /**
   * 商品ID
   */
  product_id: number;
};

export type ProductSalesPastYearsParams = {
  /**
   * 取引先ID
   */
  partner_id?: number;
  /**
   * 対象期間(yyyymm形式、カンマ区切り) 例: 202501,202502,202503
   */
  periods: string;
};

export type ResearcherListParams = {
  /**
   * A page number within the paginated result set.
   */
  page?: number;
  /**
   * Number of results to return per page.
   */
  page_size?: number;
};

export type ShelfListParams = {
  /**
   * 倉庫(事業所)IDで絞り込む
   */
  location_id?: number;
  /**
   * ソート対象フィールド（例: name, -name, updated_at, -updated_at）
   */
  ordering?: string;
  /**
   * ページ番号
   */
  page?: number;
  /**
   * 1ページあたりのアイテム数 (最大500)
   */
  page_size?: number;
};

export type TokenCreate200 = {
  access?: string;
  refresh?: string;
};

export type TokenObtainMfa200 = {
  access?: string;
  refresh?: string;
};

export type TokenRefreshCreate200 = {
  access?: string;
};
